var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoeClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2032 1968",
    width: 127,
    height: 123,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,26)",
    d: "m0 0h99l35 2 38 3 39 5 28 5 31 7 39 10 47 15 41 15 29 12 29 13 32 16 25 13 24 14 14 8 21 13 13 9 17 12 19 14 14 11 11 9 13 11 11 9 14 13 11 9 17 16 6 5v2l4 2 20 20 7 8 8 8 7 8 11 13 12 14 12 16 14 18 10 14 13 18 10 15 16 25 10 16 15 26 10 18 22 46 15 36 12 31 14 41 10 36 9 36 11 56 5 38 4 44 1 17 1 33v63l-1 27-4 48-4 33-5 28-12 56-8 30-11 36-14 41-16 39-15 33-19 38-10 18-11 19-14 22-10 16-16 23-11 15-10 14-12 15-11 14-9 10-9 11-9 10-7 8-15 16-7 7-6 7-8 7-16 16-8 7-14 13-11 9-11 10-13 10-12 10-17 13-19 13-12 8-17 11-28 17-25 14-24 13-29 15-26 12-36 15-18 7-36 12-34 10-56 14-41 8-36 5-42 4-33 2-39 1h-32l-38-1-47-3-38-4-32-5-53-12-37-10-37-11-31-11-29-12-29-13-39-19-25-13-23-13-21-12-19-12-21-14-19-14-17-13-14-11-13-11-11-9-16-15-8-7-12-11-16-15-37-37-7-8-13-15-12-14-11-14-10-12-12-16-14-19-11-16-15-23-8-13-15-26-13-24-11-21-13-28-15-35-13-35-15-45-12-45-7-30-7-37-6-37-4-36-2-27-1-31v-76l2-40 4-41 5-35 8-40 10-44 15-50 15-44 14-34 16-36 20-40 9-16 11-19 10-16 9-14 14-21 10-14 13-18 10-13 11-14 14-18 10-12 9-11 11-12 7-8 12-12 2-3h2l2-4 8-7 13-13 8-7 8-8 8-7 11-10 11-9 14-12 16-12 18-14 20-14 27-18 13-8 24-14 28-15 19-10 28-14 29-13 19-8 34-13 41-14 41-11 48-11 27-5 30-4 29-3z",
    fill: "#FCFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,455)",
    d: "m0 0h33l37 2 24 3 28 6 36 10 36 12 25 10 42 21 24 14 24 16 17 12 11 9 16 13 8 7 8 8 8 7 7 7 7 8 12 13 11 14 9 11 14 19 9 13 7 11 8 12 9 16 13 25 8 19 13 32 8 26 9 36 5 34 2 27v68l-2 34-4 30-6 31-10 35-12 36-13 32-8 16-8 15-6 11-6 12-8 13-4 7h-2l-2 5-13 18-10 12-10 13-11 13-7 7-14 16-8 7-4 4-2-1 4-87 6-91 4-58 2-27 2-30 2-23-4-41-4-7-14-7-15-3h-6l-7 1-5-1-4 1h-64l-136-2h-132l-236 1h-39l-14-1-31 3-10 2-10 5h-2l-2 8-1 9-1 21v20l-2 9 1 18 6 65 3 46 4 62 3 49 2 47 2 12-4-2-5-6-6-5-7-8-10-10v-2h-2l-7-8-10-11-8-10-9-11-12-17-14-20-4-7-6-11-3-5-2-2-3-7-16-33-7-17-4-10-12-36-8-30-7-35-4-31-3-39v-53l3-33 5-28 6-21 11-39 11-31 15-34 8-16 9-17 8-14 13-22 11-14 4-6h2l2-4 11-13 12-14 9-11 25-25 8-7 14-13 14-11 10-8 19-14 26-17 15-9 23-12 16-8 24-10 34-11 39-11 16-3 20-2 49-3z",
    fill: "#E54145"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,986)",
    d: "m0 0 14 1h39l257-1h111l136 2h64l5-1 9 1 2-1 11 1 10 2 14 7 5 8 4 42-3 32-2 36-4 55-6 88-4 79-1 25v3l-13 13-7 8-11 13-6 9-12 9-10 10-16 8-10 6-4 3-7 3-17 9-14 7-3 1h-13l-43 11-13 5-20 7-15 4-11 2-9 3-1 3-3 2h-7l-10-3-102-1-30-1-36-4-6-1-34-1-14-1-11-5v-2l-4-2-3-1-3-3-2-1v2h-7l-11-3-12-1-6-3-8-1v2l7 1 9 3 9 4 14 8 1 3v12l-4 23-3 9-7 4-17-2-10-4-9-6-6-7 1-9 6-15 3-9 1-7-8-1-10 7-6 5-8 11-2 4-3 2-5-1-9-5v-6l7-14 4-13v-21h-2l-5-10-3-2v-2l-4-2-8-6 6 7 6 9-1 9-3 5-5 2-5 6-5 13-4 7-5-1-9-4-11-7-9-9-5-11 1-8 10-19 9-6 13-1-3-2-3-10-6-7-11-9-10-8-13-11-7-6 2-1-2-4-2-25-2-51-4-61-3-41-3-45-6-65v-7l2-9v-21l1-20 2-13 2-4 12-6 10-2z",
    fill: "#D0D0CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,26)",
    d: "m0 0h99l35 2 38 3 39 5 28 5 31 7 39 10 47 15 41 15 29 12 29 13 32 16 25 13 24 14 14 8 21 13 13 9 17 12 19 14 14 11 11 9 13 11 11 9 14 13 11 9 17 16 6 5v2l4 2 20 20 7 8 8 8 7 8 11 13 12 14 12 16 14 18 10 14 13 18 10 15 16 25 10 16 15 26 10 18 22 46 15 36 12 31 14 41 10 36 9 36 11 56 5 38 4 44 1 17 1 33v63l-1 27-4 48-4 33-5 28-12 56-8 30-11 36-14 41-16 39-15 33-19 38-10 18-11 19-14 22-10 16-16 23-11 15-10 14-12 15-11 14-9 10-9 11-9 10-7 8-15 16-7 7-6 7-8 7-16 16-8 7-14 13-11 9-11 10-13 10-12 10-17 13-19 13-12 8-17 11-28 17-25 14-24 13-29 15-26 12-36 15-18 7-36 12-34 10-56 14-41 8-36 5-42 4-33 2-39 1h-32l-38-1-47-3-38-4-32-5-53-12-37-10-37-11-31-11-29-12-29-13-39-19-25-13-23-13-21-12-19-12-21-14-19-14-17-13-14-11-13-11-11-9-16-15-8-7-12-11-16-15-37-37-7-8-13-15-12-14-11-14-10-12-12-16-14-19-11-16-15-23-8-13-15-26-13-24-11-21-13-28-15-35-13-35-15-45-12-45-7-30-7-37-6-37-4-36-2-27-1-31v-76l2-40 4-41 5-35 8-40 10-44 15-50 15-44 14-34 16-36 20-40 9-16 11-19 10-16 9-14 14-21 10-14 13-18 10-13 11-14 14-18 10-12 9-11 11-12 7-8 12-12 2-3h2l2-4 8-7 13-13 8-7 8-8 8-7 11-10 11-9 14-12 16-12 18-14 20-14 27-18 13-8 24-14 28-15 19-10 28-14 29-13 19-8 34-13 41-14 41-11 48-11 27-5 30-4 29-3zm2 57-47 3-37 4-25 4-25 5-39 9-30 8-10 3-26 8-39 14-31 13-38 18-23 12-22 12-25 15-19 12-33 22-33 24-12 9-14 12-8 7-12 11-10 10-7 6-28 28-7 8-14 15-11 12-8 10-10 12-14 19-11 14-9 12v2h-2l-8 12-6 8-4 7-7 11-7 10-5 9-9 15-10 17-13 24-8 16-13 27-14 33-10 26-12 36-8 28-12 48-7 38-6 39-4 40-2 42v54l2 38 3 41 4 35 6 34 4 19 8 35 5 20 8 27 12 36 13 33 5 12 16 35 9 19 12 22 14 25 9 15 13 21 16 24 7 9 10 14 11 14 13 16 9 11 13 15 7 8 11 12 8 8 1 2h2l2 4 12 12 8 7 9 9 8 7 11 10 10 8 10 9 10 8 16 13 13 10 11 8 34 24 16 10 30 18 22 12 19 10 34 16 26 11 29 12 18 6 19 7 42 12 35 9 34 7 23 4 30 4 32 3 37 2h66l41-2 44-4 21-3 9-2 24-3 23-5 15-3 15-4 22-5 21-7 14-4 26-9 7-3 10-3 9-4 12-4 12-5 8-4 19-8 2-2 10-4 25-12 24-13 12-7 31-18 12-8 10-7 22-15 17-13 14-11 12-10 8-7 13-11 11-9 12-11 8-7 16-15 14-14 9-11 8-8 11-14 9-10 5-6v-2h2l11-14 9-11 9-12 10-14 8-12 12-17 9-14 13-22 8-13 9-17 10-19 11-23 8-19 6-13 12-31 9-25 13-40 5-21 8-31 4-17 8-50 4-33 3-30 1-19v-73l-2-37-4-41-8-57-7-36-12-51-10-33-9-27-12-31-10-24-11-24-11-23-12-22-12-21-11-19-13-20-9-14-12-17-14-19-14-18-10-13-12-14-9-11-8-8-7-8-36-36-8-7-9-9-8-7-13-11-11-9-17-14-19-14-19-13-24-16-17-11-20-12-24-14-27-14-19-10-23-11-19-8-27-11-26-9-18-6-56-15-32-7-32-6-44-6-49-4z",
    fill: "#040304"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(973,83)",
    d: "m0 0h106l49 4 44 6 51 10 36 9 17 5 16 4 18 6 34 12 19 8 28 12 16 8 37 19 24 14 14 8 21 13 42 28 14 10 17 13 11 9 10 8 15 13 8 7 10 9 8 8 8 7 36 36 7 8 10 11 9 11 13 16 21 28 14 19 10 15 10 16 11 17 10 18 10 17 14 26 11 23 13 29 11 28 10 27 8 24 9 31 13 56 6 33 8 59 3 33 2 37v73l-2 31-4 35-6 42-5 28-6 25-6 22-5 21-16 49-10 26-8 20-13 30-9 19-10 19-7 14-7 12-15 25-10 16-14 20-8 12-11 15-9 12-13 16-6 8h-2l-2 4-12 14-14 17-7 7-9 11-21 21-8 7-13 12-8 7-11 9-14 12-12 10-14 11-15 12-17 12-15 10-13 9-14 9-11 6-12 7-8 5-11 6-29 15-19 9-5 2-12 6-13 5-8 4-15 6-12 4-7 3-10 3-9 4-22 7-24 8-21 5-16 4-15 4-30 6-31 4-8 2-34 4-42 3-24 1h-66l-49-3-36-4-26-4-36-7-29-7-47-13-18-6-25-9-16-6-29-12-33-15-17-8-19-10-12-7-14-7-14-9-18-11-18-12-17-12-11-8-16-12-16-13-17-14-10-9-10-8-14-13-8-7-9-9-8-7-8-8v-2h-2l-7-8-10-10-7-8-12-14-9-11-11-13-11-14-12-16-9-13-8-11-15-23-9-15-13-22-16-29-9-17-13-28-10-23-5-12-12-31-8-24-9-28-9-36-6-27-5-24-5-29-4-35-4-54-1-25v-54l2-42 4-40 7-45 7-37 11-43 8-28 12-36 12-31 18-41 10-21 24-44 8-13 9-14 6-11 6-8 6-9 4-7 10-14 1-2h2l2-5 13-16 14-19 10-13 12-14 7-8 11-12 12-13 11-12 21-21 15-14 9-9 8-7 13-11 10-8 11-8 16-12 12-8 11-8 14-9 20-13 18-11 26-15 28-15 16-8 32-15 35-14 37-13 20-6 21-6 48-12 53-10 32-4 41-3zm16 35-37 1-20 2-37 4-27 4-56 13-24 7-45 15-12 5-28 11-11 5-15 7-18 8-16 8-23 12-24 14-22 13-19 13-25 17-19 14-10 8-14 12-10 8-10 9-8 7-10 9-2 1v2l-4 2-40 40-9 11-7 7-9 11-9 10-9 11-11 14-10 13-11 16-12 17-15 22-5 9-10 16-7 11-12 22-14 26-11 23-6 13-8 19-5 11-9 23-4 11-4 9-5 17-3 9-7 23-5 18-5 22-7 36-4 33-3 34-2 22-1 28v50l2 36 6 51 1 11 3 16 6 31 10 42 12 39 5 17 2 3 3 10 4 9 5 14 5 11 7 16 17 34 3 7 4 8 8 14 6 12 7 11 11 19 9 13 5 9 12 17 7 11 8 11 6 8 11 14 8 11 14 17 10 11 9 11 13 13 7 8 27 27 8 7 12 12 11 9 11 10 13 10 14 11 15 12 18 13 20 14 15 10 19 12 9 5 16 9 10 6 12 6 17 9 18 8 13 6 24 10 29 11 20 7 18 5 29 9 38 9 33 7 42 6 40 4 38 2h67l39-3 28-3 38-5 13-3 27-6 24-6 7-2 13-3 8-3 21-7 11-3 12-5 24-9 29-12 21-9 19-10 17-8 10-6 21-12 10-6 13-8 30-20v-2l5-2 16-11 15-11 14-11 4-3v-2l5-2v-2l4-2 11-10 11-9 11-10 3-2v-2l4-2 9-9 8-7 7-7 7-8 13-13 7-8 13-14 9-11 13-15 8-11 10-12 8-11 10-14 6-9 4-5 3-5 18-27 9-16 11-18v-3h2l4-8 9-17 8-16 8-18 6-13 10-25 15-42 15-49 8-31 8-37 8-49 4-39 1-18v-53l-2-60-3-35-8-50-7-36-5-20-6-20-5-17-8-24-9-24-10-24-6-15-8-18-7-15-16-31-13-22-14-23-13-21-13-19-13-18-14-19-10-13-14-17-12-13-14-15-7-7-7-8-39-39-8-7-14-13-11-9-13-11-32-24-11-8-14-10-19-12-11-7-13-8-25-15-14-7-11-6-15-8-28-13-27-11-12-5-10-3-8-3-18-6-11-4-15-4-20-6-36-8-38-7-20-4-38-4-28-2-23-1z",
    fill: "#FBFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,476)",
    d: "m0 0 12 3 12 5 19 10 20 13 21 16 11 10 8 7 16 16 9 11 12 15 9 15 10 21 10 27 8 21 12 28 12 30 9 25 7 25 7 29 2 12-1 15-5 16-7 17-10 19-8 11-7 9-3 4-1 8 5 2 19 12 27 15 28 15 24 14 17 9 8 4 1 3-1 1h-64l-136-2h-132l-236 1h-39l-8-1v-2l11-4 16-8 36-20 22-13 21-13 10-7 13-7-1-7-7-10-10-11-9-15-4-7-2-4v-7h-2l-3-14 1-17 8-28 9-27 11-28 13-31 13-29 12-30 5-12 12-27 13-27 10-17 10-13 8-10 9-10 7-8 11-11 8-7 17-13 13-8 14-6z",
    fill: "#292B43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658 1e3)",
    d: "m0 0 2 4 1 1v28h2l1 9 8 15 3 10 4 9 4 10 8 19 5 10 4 10 12 22 9 14 8 11 11 15 14 19 9 11 12 14 13 15 8 8v2h2l6 7 2 1v2h2v2l4 2 8 8 8 6v2l5 2 7 7 26 20 8 6 20 14 10 6 12 6 15 7 12 6 13 6 21 9 13 6 18 8 38 16 18 7 20 7 10 3 9 3 22 7 9 2 13 3 39 8 18 4 10 4 8 7 2 3-1 2-38 10-23 9-14 4-19 4-9 3-1 3-3 2h-7l-10-3-102-1-30-1-36-4-6-1-34-1-14-1-11-5v-2l-4-2-3-1-3-3-2-1v2h-7l-11-3-12-1-6-3-8-1v2l7 1 9 3 9 4 14 8 1 3v12l-4 23-3 9-7 4-17-2-10-4-9-6-6-7 1-9 6-15 3-9 1-7-8-1-10 7-6 5-8 11-2 4-3 2-5-1-9-5v-6l7-14 4-13v-21h-2l-5-10-3-2v-2l-4-2-8-6 6 7 6 9-1 9-3 5-5 2-5 6-5 13-4 7-5-1-9-4-11-7-9-9-5-11 1-8 10-19 9-6 13-1-3-2-3-10-6-7-11-9-10-8-13-11-7-6 2-1-2-4-2-25-2-51-4-61-3-41-3-45-6-65v-7l2-9v-21l1-20z",
    fill: "#B5B6B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,118)",
    d: "m0 0h68l36 2 34 3 19 2 20 4 38 7 39 9 9 3 8 2 18 5 8 3 25 8 6 3 9 3 28 11 29 13 19 10 12 6 12 7 11 6 12 7 17 10 10 7 18 11 14 10 11 8 19 14 18 14 13 11 11 9 16 15 12 11 37 37 7 8 10 10 7 8 13 14 8 10 11 14 13 18 14 19 20 30 14 23 9 15 14 24 15 29 6 13 11 25 14 35 12 32 8 25 6 23 4 15 5 22 8 45 4 26 3 35 2 60v53l-2 30-4 34-8 47-10 45-8 28-14 45-14 39-6 14-4 10-6 14-7 15-6 12-9 17-6 12h-2l-1 5-8 13-9 15-4 7-8 12-6 8-3 5-6 9-7 10-9 13-13 17-11 14-9 11-12 14-10 11-7 8-15 16-10 10-7 8-7 7-8 7-5 5h-2l-1 3-8 7-14 12-11 9-4 4h-2v2l-5 2v2l-13 10-10 8-10 7-19 13h-2v2l-30 20-15 9-11 7-22 12-8 5-23 11-16 8-25 11-33 13-22 8-7 3-17 5-16 5-7 2-8 3-52 12-16 3-2 1-56 7-35 3-14 1h-67l-38-2-40-4-42-6-51-11-30-8-29-9-14-4-35-13-25-10-19-8-16-8-19-9-10-6-11-6-17-9-7-5-11-6-17-11-19-13-17-12-21-16-16-13-13-10-28-24-11-11-8-7-31-31-7-8-8-8-9-11-12-13-11-14-6-8-13-17-7-9-9-13-7-11-10-14-9-15-9-14-10-17-9-15-6-12-6-11-3-5-4-10-8-15-10-23-4-8-14-35-3-8-4-11-6-21-8-26-12-51-6-35-1-3-6-53-2-25-1-20v-50l1-28 4-47 3-28 5-30 5-24 7-30 7-23 3-11 3-7 5-17 3-6 6-17 11-27 7-15 7-16 16-32 11-21 9-16 5-9 10-16 7-11 10-16 7-10 24-34 20-26 13-15 9-11 14-15 9-11 40-40h2v-2l11-9 7-7 11-9 9-8 11-9 12-10 19-14 28-19 24-16 22-13 25-14 19-10 23-11 24-11 28-12 22-8 12-5 24-8 21-6 18-5 32-8 19-4 35-5 43-4 6-1zm-11 14-25 1-38 4-45 7-33 7-13 4-8 2-15 4-23 6-16 5-35 12-20 8-12 5-37 17-27 14-51 30-11 8-12 8-11 8-14 10-18 13-13 11-10 8v2l-4 2-10 9-8 7-13 11-4 4v2h-2l-5 5-15 16-9 9-7 8-10 11v2l-4 2-8 10-8 9-8 10-13 17-15 20-14 19-10 14-24 36-5 9-5 8-12 22-11 19-16 32-6 13-3 7-10 23-2 7-5 12-6 16-11 33-5 20-4 15-6 28-2 8-2 15-1 1-5 38-4 49-1 16v78l3 36 3 26 4 27 5 25 7 31 6 24 6 21 7 23 5 15 7 18 6 16 9 22 7 15 16 32 13 24 16 27 16 25 8 12 24 34 10 14 13 15 8 10 11 13 9 11 10 11 7 8 7 7 7 8 24 24 8 7 17 16 11 9 10 9 11 9 18 14 17 12 16 12 14 10 14 9 21 13 16 9 18 10 16 8 32 15 36 15 8 3 26 9 9 3 16 5 21 6 60 14 33 5 39 5 18 2 35 2h72l35-2 26-3 16-2 3-1 18-2 14-3 18-3 43-10 25-8 14-4 28-10 23-8 21-9 11-5 12-5 24-12 5-3 7-3 11-6 6-4 7-3 17-10 18-11 10-7 11-7 16-12 10-7 12-9 19-14 10-9 22-18 8-8 9-7 40-40 9-11 11-11 9-11 13-15 13-17 11-14 12-17 11-15 16-25 10-15 15-26 12-21 8-15 8-16 12-27 6-13 8-20 8-23 12-36 7-25 8-33 6-31 6-39 4-33 2-27 1-26v-44l-2-40-4-37-8-49-3-13-2-13-2-6-3-15-10-36-5-16-14-39-8-20-16-36-23-46-12-21-6-10-11-18-8-12-11-16-13-18-10-14-13-17-13-16-11-13-14-15-7-8-15-16-32-32-8-7-15-14-11-9-14-12-11-9-18-14-36-26-23-15-18-11-10-6-11-6-23-13-19-9-14-7-25-11-21-8-22-7-8-3-20-7-45-12-31-7-44-8-47-5-36-2z",
    fill: "#090709"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,745)",
    d: "m0 0h79l10 2 12 2 10 2 21 2 10 3h13l8 2 7-1 4-3 8-2h8l8 3 5 5 1 3 5 2 11 6 1 4-3 1 10 4 6 7 1 2-1 10-8 18-6 10-8 14-7 6-10 5-5 2-4 6-7 17-6 10-5 5-6 11-6 7-7 12-13 12-7 7-18 12-16 8-5 3-11 1-7 3-7 2-12-1-10-2-6-2-1-2-14-5v-2l-5-1v-2l-4-1-8-7-8-6-5-3-3-3-3-5-10-10-4-5-6-5-9-14-9-15-5-7-6-14-3-3v-2l-9-3-8-7-7-9-9-16-4-9-3-8-1-11 2-7 2-4v-2l-2-1 1-4 3-4h2v-3l5-4 18-1h12l13-4 6-3h10v-2l8-2h10l9-1z",
    fill: "#FDE1CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,513)",
    d: "m0 0h2v2l-7 6-7 8-12 13-2 5-5 2-2 4-5 8-4 7-2 4-3 7-5 10v3l-3 6 2 1 1 6-3 7h-2v9l-3 11-3 8-2 1-3 12-4 5-3 5-1 4-6 3 1 7-5 3h-2l1 5 1 3-2 5-2 7-1 3-5 21-4 16 1 12 8 3 16 2v1l-14 3-7 2-2 2h-6l-3-3v-7h-3l-1 5-2 2 4 1v7l5 2v-2l12-6 2-2 3 1-4 2v3h-2l-2 4-1 4 2 4-3 4-1 7 2 13 5 12 8 15 8 11 8 7 9 4 5 7 5 12 7 10 11 19 8 10 6 5 7 8 6 6 3 5 11 8 7 5 4 4 3 1v2l5 1v2l5 1 10 4v2l9 2 14 2h5l7-2 7-3 11-1 19-10 16-10 12-11 7-7 5-4 6-11 8-10 6-11 5-5 8-16 5-12 4-4 10-4 8-5 4-5 11-20 5-10 5-13v-6l-6-8-10-4-4-2h7l9 4 4 2 4-1 4 7-2 3 4-2 10-2h7l7 7 3 8 2 22 1 7-1 2h2l1-3-1 9-8 21-8 16-10 16-9 11-3 4-1 8 5 2 19 12 27 15 28 15 24 14 17 9 8 4 1 3-1 1h-64l-136-2h-132l-236 1h-39l-8-1v-2l11-4 16-8 36-20 22-13 21-13 10-7 13-7-1-7-7-10-10-11-9-15-4-7-2-4v-7h-2l-3-14 1-17 8-28 9-27 11-28 13-31 13-29 12-30 5-12 12-27 13-27 10-17 10-13 8-10 9-10 7-8z",
    fill: "#1F1B21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1136)",
    d: "m0 0h48l24 5 18 6 11 6 5 4 3 4 2 13v16l-2 31-3 15-4 10-8 19-1 3 1 3-2 2 19 1 9 3 1 4v16l1 11-2 3-8-5-13-5-14-5-13-2-6 2-6 1-2 5-9 6-11 2-13 1h-20l-17-2-8-4-2-3-5-3-1-4 73-1 21-7 1-1-4-1-8 2h-11l-2-1v-3h-32l-11 1-8 2h-12v-3l-2 1h-14l1 2 9 3-2 4-5 2-1 3-8 1-36 1-7 1-3 2-3-5-3-24h45l-7-8-5-7-7-27-2-11-1-11v-27l2-18 4-8 10-8 12-5 20-5z",
    fill: "#244E3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,118)",
    d: "m0 0h68l36 2 34 3 19 2 20 4 38 7 39 9 9 3 8 2 18 5 8 3 25 8 6 3 9 3 28 11 29 13 19 10 12 6 12 7 11 6 12 7 17 10 10 7 18 11 14 10 11 8 19 14 18 14 13 11 11 9 16 15 12 11 37 37 7 8 10 10 5 6-1 2-2-1v-2l-4-2-4-3 7 7-1 2-12-12-7-8-42-42-8-7-15-14-11-9-12-11-17-13-15-11-7-4 5 5 3 2v2l4 2 4 4v2l4 2 1 4 6 4-1-2 4 2 6 5-4 3-13-11-17-13-36-26-23-15-18-11-10-6-11-6-23-13-19-9-14-7-25-11-21-8-22-7-8-3-20-7-45-12-31-7-44-8-47-5-36-2h-87l-25 1-38 4-45 7-33 7-13 4-8 2-15 4-23 6-16 5-35 12-20 8-12 5-37 17-27 14-51 30-11 8-12 8-11 8-14 10-18 13-13 11-8 7h-2v2l-11 9-3 3h-2l-1 3-11 9-6 5-3 4h-2v2h-2l-2 4-7 6-7 8-12 12-7 8-4 5h-2l-2 4-5 5-9 11-8 9-8 10-13 17-15 20-14 19-10 14-24 36-5 9-5 8-12 22-11 19-16 32-6 13-3 7-10 23-2 7-5 12-6 16-11 33-3 11h-2l-1 7-2 2-2-1v-7l2-10-4-4 1-8 3-9 6-20 3-6 6-17 11-27 7-15 7-16 16-32 11-21 9-16 5-9 10-16 7-11 10-16 7-10 24-34 20-26 13-15 9-11 14-15 9-11 40-40h2v-2l11-9 7-7 11-9 9-8 11-9 12-10 19-14 28-19 24-16 22-13 25-14 19-10 23-11 24-11 28-12 22-8 12-5 24-8 21-6 18-5 32-8 19-4 35-5 43-4 6-1z",
    fill: "#090809"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1108)",
    d: "m0 0h75l22 2 21 5 10 4 5 4 8 16 2 9 1 12v41l-2 56-1 17v35l1 3v9l-2 9-5 4-6 4-8 1-50 2h-88l-28-2-21-3-7-3-5-3v-5l3-7-2-11-3-11-2-15-3-43v-55l2-27 4-20 4-10 5-6 14-4 20-4 25-3zm17 28-24 3-20 5-12 5-10 8-4 8-2 18v27l2 17 5 21 3 11 8 11 4 4h-45l3 24 3 5 6-3h16l24-1 8-1 2-4 5-2 1-3-9-3-1-2h14l2-1 1 3h13l6-2 13-1h30v3l4 1h11l8-2 2 1-7 3-11 4-4 1-73 1 2 5 4 2 5 5 5 2 17 2h20l18-2 8-2 5-4 4-4v-2l11-2 4-1 17 4 11 5 9 3 9 5 1-7-1-7v-18l-2-3-8-2-19-1 2-3-1-4 6-12 6-17 2-7 2-9 2-31v-16l-2-13-5-6-10-6-15-6-25-6-6-1z",
    fill: "#ADACAC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,1550)",
    d: "m0 0h10l5 3 3 3v12l-3 32-4 51v13l4 10 7 6 4 1v2l11 1 3-3h2l5-10 3-15 6-21 7-24 1-5 1-18 2-6 17 3 16 5 3 3-1 4-5 5h-2l-2 5-5 12-1 5v7l2 5 5 4 14 5 8 2h10l5-8 2-8v-27l1-2h9l9 3 10 4 14 2v3l1-2h9l21 4 6 3 1 3 1 19 2 9 6 10 3 4 5-1 6-8 8-16 3-14 2-5 2-1h17l10 1-1 7-13 16-11 14-12 17-8 10-4 13v7l6 22v6h-9l-24-5-10-3v-3l6-8 5-10v-20l-3-11-6-13-7-20-10-16-9-8-5 5-4 9-9 30-7 24-2 8v21l3 5 3 2v3l-10-1-35-12-8-3v-2l6-3 3-1 2-4 5-5h2l2-4 4-9 2-5 1-6-4-2-18-7-8-5-10-1-5 6-3 7v31l2 5-9-1-19-5-9-4-8-3-16-8-12-4-19-10-10-6-11-6-4-1v-2l-7-2-13-7-9-4-16-8-11-7 1-3 17-6 9-6 10-8 11-9 16-16 14-10 11-9 5-5z",
    fill: "#060506"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,745)",
    d: "m0 0h79l10 2 12 2 10 2 21 2 10 3h13l8 2 7-1 4-3 8-2h8l8 3 5 5 1 3 5 2 11 6 1 4-3 1 10 4 6 7 1 2-1 10-8 18-6 10-8 14-7 6-10 5-5 2-4 6-5 12-1-3 7-16 10-6 9-3 4-5 7-11 5-10 5-8 5-14-1-7-3-4v-2l-5-2-7-3-8-2h-5l-4 7-3 16-1 8-3 6-3 3-15 6-22 4-20 1-21-3-12-5-8-6-3-5-2-1-3-5-8-10-2-1-1-3-6-5-7-2h-2l-2 4-2 3h-2l-2 7-14 16-9 6-10 4-10 3-7 1-1 1h-32l-15-3-8-4-9-7-3-6v-3h-2l-3-10-2-15-1-3h-10l-10 4-5 4-2 7 4 16 5 12 9 17 6 7 13 8 6 5 3 6 3 8 7 10 10 18 9 13-1 2-7-8-10-17-9-14-10-20-9-3-8-7-7-9-9-16-4-9-3-8-1-11 2-7 2-4v-2l-2-1 1-4 3-4h2v-3l5-4 18-1h12l13-4 6-3h10v-2l8-2h10l9-1z",
    fill: "#241E33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1455,340)",
    d: "m0 0 9 3 16 10 11 11-4 4-8 7-9 10-9 11-16 20-9 12-7 8-2 5v7l12 9 3 1h12l21-7 8-1 3 4-1 5-14 20-4 7 2 9 16-8 8-8h2v-2l8-7 7-7 8-7 8-9 3-3h2l2-4 6-7 7-11-1-6-2-4h4l9 6 9 9 10 8 5 6v4l-16 8-10 8-15 13-18 18-5 4h-2v2l-5 4-5 9 1 5 7 8 11 6h11l10-2h14l2 3-1 5-8 8-8 7-7 8-2 5h14l16-7 17-11 12-8 10-9 18-11 5-6-1-4-2-2v-6h5l13 11 13 18 15 23 7 11 4 9-1 5-14 9-10 5h-4v-8l1-5v-17l-5-11-5-5-4-2-6 1-8 7-7 7-2 1-1 3 4 1v8l5 2 5 5 1 8-2 6-2 2-6 1-7-6-5-6-4-9-2-1v-2l-10 2-10 6-7 10-1 4 7 13v2l5 2 2 2h16l8-3h6l-1 5-10 13-14 14-1 3-4-2-4-5v-2h-2l-7-10-12-18-8-11v-2h-2l-7-11-14-21-11-10-16-16-7-8-15-14-8-8-5-8-8-7-13-10-10-7-12-10-15-10-17-13-8-7v-2l9-3 9-8 22-28 10-13 7-9 7-11 4-10v-9z",
    fill: "#060506"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,895)",
    d: "m0 0 11 3 17 9 5 3 9 4 13 5 4 2v2l5 1 14 7 5 5 3 5 8 5 5 2v2l6 2 5 7 11 5h8l2 4 3 1 1 6h6l10 6 9 1 1-2h38l11-3 6 1h3l11-2 1-1 23-2 2-1 9-1 5-5 16-6 6-1 2-4 4-1 1-3 10-4 10-8v-3l7-1-1-2h-3l5-5 4-5 6-5 7-9 3-1 2 2-5 3-6 7 4-1v-2l2 1-3 5 5-2 1-4 5-5 3-2 1-5 2 1-1 8 5 2 19 12 27 15 28 15 24 14 17 9 8 4 1 3-1 1h-64l-136-2h-132l-236 1h-39l-6-1v-1h23l8-2 9-3 10 1 1-4 2-4 2-1 13-2 13 1 7 1 5-1 4 1 11-1v-2l7-1 1 1 9-1 3-1h15l2-1 21 1 2-1 16 1 14 2 1-1 14-1-2-6-8-6-17-10-5-3 2-1-2-6-5-4h6l4 2h5l-11-5-1-2-5-2-2-4h-2l-1-2-8-1-3-3-14-7-2-6-4-2-2 2-5-1-3-4z",
    fill: "#292B43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1047)",
    d: "m0 0 2 4 4 16 15 38 16 32 10 19 9 17 11 23 6 13 3 8 5 10 3 1-2 7-9 16-8 13-2 4h-2l-2 5-13 18-10 12-10 13-11 13-7 7-14 16-8 7-4 4-2-1 4-87 6-91 4-58 2-27 2-30z",
    fill: "#1F1D33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1069)",
    d: "m0 0 2 2 7 76 3 46 4 62 3 49 2 47 2 12-4-2-5-6-6-5-7-8-10-10v-2h-2l-7-8-10-11-8-10-9-11-12-17-14-20-4-7-6-11-1-5 4-1 7-10 6-11 12-26 18-38 9-17 14-31 10-24z",
    fill: "#1F1D33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,775)",
    d: "m0 0h7l9 4 4 2 4-1 4 7-2 3 4-2 10-2h7l7 7 3 8 2 22 1 7-1 2h2l1-3-1 9-8 21-8 16-10 16-9 11-3 3h-2v5l-7 5-2 4-1 3-5 1 2-5-1 1-5 2 9-12h-2l-2 4-9 10-10 10 3-1v3l-7 2v3l-13 10-5 1-2 1 1 2-4 2-3 1-1 3-6 1-16 6-3 1-2 4-9 1-9 2-16 1-3 1-7 2-2-1-1 2-4-2-8 1-8 2h-37l-1 1h-9l-10-6-6-1-2-6-5-4h-8l-11-6-3-4-2-5-3-5v-4l7 6 4 5 5 4 7 3h6l6 5 13 6 3 1v3h6l7 2 5 1 4-2 6 2h6l5-2 2-3h5v-2l-2-1 4-1 1-3 10-2 19-10 16-10 12-11 7-7 5-4 6-11 8-10 6-11 5-5 8-16 5-12 4-4 10-4 8-5 4-5 11-20 5-10 5-13v-6l-6-8-10-4z",
    fill: "#1F1B21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1263,245)",
    d: "m0 0h8l21 6 12 5 10 8 4 5v13l-4 13-4 7-10 2-5-8-1-2-2-14-5-10-7-7-9-4-4 2-8 6-7 7-6 10-5 11-4 14v18l4 9 6 8 8 5 12 3 18 2 6 3 4 11 2 4h9l7-7 8-16 10-19 9-17 7-14 1-13 3-8 4 1 13 9 29 15 19 11 8 6 2 4-1 6-15 14-9 4-5 2-2 4-4 10-10 3-11-1-8-4-8-6h-3l-7 8-6 10v11l6 7 11 4h8l10-3 13-6h4l-1 9-8 17-2 6v8l-5-2-9-4-16-9-13-9-23-11-11-8-2-1v-4h3l1-3h-6l-5-4-7-1h-9l-15-2-23-6-10-5-7-6-7-14-3-9-1-7v-20l3-12 6-12 12-16 12-9 8-4z",
    fill: "#060506"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,746)",
    d: "m0 0 1 2 4 2 1 3-3 16 3-1 2-7h1l-1 9-4 15-6 28-2 8-2 15-1 1-5 38-4 49-1 16v78l3 36 3 26 4 27 5 25 7 31 6 24 6 21 7 23 5 15 7 18 6 16 9 22 7 15 16 32 13 24 16 27 16 25 8 12 24 34 10 14 13 15 8 10 11 13 9 11 10 11 7 8 7 7 7 8 4 5-3 2-20-20 6 7 5 6 7 6 7 8 18 18 8 7 3 2v2l4 2 7 7 8 6v2l4 2 3 3-2 4-1-3-4-1-7-7v-2l-4-1-4-4-4-2v-2l-5-3-4-5-8-7-17-17-6-5v-2h-2v-2h-2v-2l-4-2v-2h-2l-5-5-1-3-4-2-6-5-2-3-5 1-9-10-9-11-9-10-11-14-8-11-9-11-11-16-7-10-7-11-8-11-7-12-9-14-10-17-9-15-6-12-6-11-3-5-4-10-8-15-10-23-4-8-14-35-3-8-4-11-6-21-8-26-12-51-6-35-1-3-6-53-2-25-1-20v-50l1-28 4-47 3-28 5-30 5-24 7-30z",
    fill: "#201C23"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(982,207)",
    d: "m0 0h66l15 1 9 3 1 3v11l-2 9-5 6-5-2-1-3-4-2-5-4-8-4h-16l-7 2-2 5-1 3v9l3 8 3 3h35l-2 12-5 6-4 2h-13l-12-1-3 8-2 5v12l5 5 3 2h13l12-3 8-8 5-7h5l4 5 1 12-1 10-4 8h8l2 1h6l10-9 13-15 8-8 9-12 6-9v-6l-12-27-5-9-8-13v-5l2-1h10l20 4 6 3 1 1 1 15 4 11 7 11 2 3 4-1 6-10 7-18 4-5h19l9 2 1 1v6l-10 8-9 7-8 8-8 12h-2v2l-6 5 1 5 3 10 8 16 6 15 8 16 6 8v3l-12-2-16-4-16-6-3-13-2-23-3-6-2-2-5 1-4 2-2 4-9 7-4 10v11h2l1 4h-18l-12-3-26-2-74-3-10-2 4-8 3-11 1-15v-56l-3-13-2-5h-2l-2-5z",
    fill: "#060506"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1609,1365)",
    d: "m0 0h2l1 2v12l-2 9-8 33v15l16 8 9 4 14 7 17 7 5 5v2l-13 5-17 3-23 3-13 2-3 3-3 13-5 32-2 17-6 5-5-3-7-11-3-9-7-14-3-5-3-9-3-5-5-3h-10l-34 5-8 2h-18l2-5 6-7 10-8 3-1 1-3 5-5h2l2-4h2l1-3 8-7 5-7-1-9-4-10-9-16-8-17-4-8-1-6 6 1 2 2 10 4 16 8 19 10 12 4h5l10-9 9-11 8-8 7-8 8-8z",
    fill: "#050405"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,1357)",
    d: "m0 0h2l3 3v9l-5 21-3 19v15l3 1v2l28 14 22 13 5 4-1 3-4 1-14 1-42 7-7 2-1 6-4 21-1 8-1 27-3 7-5 1-7-11-8-15-4-5-5-12-3-9-5-6-9-5-9 1-27 6-6 1h-15l-6-3 1-5 7-8 11-8 13-11 13-13v-6l-8-18-11-23-4-7-4-8v-4l7 1 36 18 17 10 6-1 6-4 28-28 7-8z",
    fill: "#050405"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,255)",
    d: "m0 0h21l8 2 14 8 9 9 10 16 4 8 4 13 1 6v16l-3 11-7 14-5 5-14 9-5 3-12 4-14 1h-11l-19-11-11-10-8-13-5-13-3-11v-19l2-10 6-13 6-8 11-8 14-7z",
    fill: "#060506"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,1525)",
    d: "m0 0h4l2 10 2 16 8 14 10 19 12 20 9 10 7 4 7 2-2 4h-2v2l-23 13-21 9-10 6-9 6-6 3h-20l-9-10-19-13-6-4-2-9 7-10 2-5v-20l-5-8-1-1h-17l-9 5-3 8 1 7 6 14 9 10 8 2-1 14v12l3 9 9 3h19l-5 5-10 8-8 4-19 9h-9l-2-7-2-16-6-20-4-8-3-8-3-7-9-16-6-12-4-6v-2l-4-2 4-4 11-4 14-4 24-9 12-3h15l6 4 8 9 6 12v14l-3 8-1 4v8l3 5 9 8 11 7 7 5h7l16-5 6-5v-9l-4-11-36-60-7-8-7-2-1-4 5-4 14-7z",
    fill: "#060506"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1205,1601)",
    d: "m0 0h16l7 3 10 7 5 5 5 4 8 10 5 13 3 17v9l-4 18-7 11-8 7-10 5-27 8-19 6h-19l2-8 2-4-1-13-7-29-5-19-2-5-2-8-3-6-10-11 1-4 13-4 21-5 16-5z",
    fill: "#060506"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,338)",
    d: "m0 0h10l9 3 8 7 3 3 5 10 1 3v12l-1 8v11l6 5 25 7 7 2h11l2 4-3 3h-2l-1 3-10 8-9 4h-5l-2 1-7-3-8-6-11-5-3-1h-11l-8 3-2 4v7l5 5 10 6 7 2 12 1v2l-5 5-9 8-8 5-16 13h-4l-2-13-4-12-13-18-6-9-10-14-7-9-12-14-4-5-5-3 2-5 7-7 16-10 9-7 16-9 9-4z",
    fill: "#060506"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1703,607)",
    d: "m0 0 4 1 3 5 4 12 1 8-3 9-8 15-7 11-5 9-7 9-11 14-10 14-1 2 20-7 16-8 17-8 9-4 6-7 2-11h3l5 8 6 15 6 18-1 2-6-4-3-4-6 1-20 9-9 4-30 13-15 7-12 6-13 2-6-12-2-7v-11l11-13 6-11 9-14 7-10 8-11 4-5 5-10-12 4-25 13-19 11h-2l-1 3-9 7-4 1-3-3v-2h-2l-4-8-3-12v-3l25-7 17-7 20-9 16-9 16-7 9-6z",
    fill: "#060506"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,603)",
    d: "m0 0h2l3 7 4 5 16 8 9 4 16 8 23 10 9 4 19 10 3 2v2h2l-1 5-9 9-4 8-7 2-25 2-19 3-42 3 3 5 23 12 14 6 9 2h26l-1 8-10 19-2 4h-5l-5-4-19-9-18-10-23-11-20-10-15-1-2 1-2 4-3 1 1-6 8-19 4-8 6-6 13-2 26-3 43-2 15-2 1-2-7-1-8-5-14-6-11-5-11-3-12-5-10-1h-7l-1 2h-4l1-6 8-16 7-10z",
    fill: "#060506"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1786,854)",
    d: "m0 0 4 2 2 9 4 42 3 18 1 15-3 2-10 1h-26l1-6 4-7 13-8 1-1v-9l-2-13-2-4-2-1h-18l-9 3-1 2-1 28-2 5-1 3-13 5-6 4-5 3-7 7-6 3-5 1h-12l-5-6-4-19-2-18-1-21-1-11-4-2-2-2 1-5 3-2 21 1 23-2 37-5 16-4z",
    fill: "#060506"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,742)",
    d: "m0 0 6 1 20 10 5 6 5 4v2l7 2 8 7 3 4-1 13-1 6v10l5 5 8 3 10 1 7-3 4-6 2-8v-10l-5-5-9-6-3-1-1-6 7-6h30l4-1-1 7-9 39-5 19-4 14-4 12h-2l-1 2-8-8-13-7-17-4-16-5-17-3-9-2-5-3h-8l-9 4h-8v-13l9-33 4-16 7-21z",
    fill: "#070607"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,1550)",
    d: "m0 0h10l5 3 3 3v12l-3 32-4 51v13l4 10 7 6 4 1v2l9 1v1l-7 1-16-7-13-5-18-10-13-7-5-3-4-1v-2l-7-2-13-7-9-4-16-8-11-7 1-3 17-6 9-6 10-8 11-9 16-16 14-10 11-9 5-5z",
    fill: "#060506"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1515,284)",
    d: "m0 0 5 2 22 16 16 13 10 9 11 9 17 16 13 12 41 41 7 8 5 4-7-7 1-2 8 7v2l5 1 13 14 8 10 11 14 13 18 14 19 20 30 14 23 9 15 14 24 15 29 6 13 11 25 14 35 12 32 8 25 6 23 4 15 5 22 8 45 4 26 1 20-2 6-1-4h-2v7l-2 2-2-25-2-7-1-8-1-11-2-11-2-15-1-5-2-7-2-10-7-34-4-13-10-31-8-24-6-14-6-16-7-17-2-2-3-10-6-12-3-3-4-6-2-5-2-2v-4h-2l-2-3v-5h-2l-8-15-6-11-8-13-1-3-2 1-7-12-12-19-15-22-13-18-10-14-13-17-13-16-11-13-14-15-7-8-15-16-31-31-8-7-15-14-11-9-12-10 1-4-5-5h-1-3l-6-5v-3l-3-2v-2l-4-2-5-6-6-4z",
    fill: "#201C23"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,845)",
    d: "m0 0 2 2v3l3 1 3 4v2l7 1 2 4h2l2 5 4 2 3 5v1l6 1 1 3 2 2h-2l-1 3-3 1 1 6 5 4 4 6h4l2-2 5 5 1 3 15 8 2 2 8 1 1 3h2l3 4 5 2 1 2 10 4 1 2h-7l-3-2h-4l5 4v5 2l11 6 12 7 7 6v5l-14 2-3 1-13-2-15-1-5 1-18-1-6 1h-12l-12 2v-2l-7 1v2l-13 2-3-1-5 1-12-1-7-1-13 2-2 1-3 7-3 1-8-1-11 4-5 1h-25v-2l11-4 16-8 36-20 22-13 21-13 10-7 13-7-1-7-7-10-10-11-9-15-4-7-2-4v-7h-2z",
    fill: "#1F1A27"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(898,1465)",
    d: "m0 0h131l32 1h68l33-1 9 1 2 1v2l6 1 3 3-1 2-9 3-18 4-27 4-30 5-21 2-16 1h-71l-36-3-29-5-31-7-28-6-5-2v-1z",
    fill: "#767475"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1623,500)",
    d: "m0 0h5l13 11 13 18 15 23 7 11 4 9-1 5-14 9-10 5h-4v-8l1-5v-17l-5-11-5-5-4-2-6 1-8 7-7 7-2 1-1 3 4 1v8l5 2 5 5 1 8-2 6-2 2-6 1-7-6-5-6-4-9-2-1v-2l-10 2-10 6-7 10-1 4 7 13v2l5 2 2 2h16l8-3h6l-1 5-10 13-14 14-1 3-4-2-4-5v-2h-2l-7-10-12-18-8-11v-2h-2l-7-11-16-24 3-2 4 1-2 6h14l16-7 17-11 12-8 10-9 18-11 5-6-1-4-2-2z",
    fill: "#070606"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1113,1449)",
    d: "m0 0h14l32 4 12 3 24 1 18 4 7 3-1 3-34 9-23 9-14 4-19 4-9 3-1 3-3 2h-7l-10-3-102-1-7-1-28-2-22-3-31-5-12-1-7-3h-5l-7-4-30-7-12-7 2-4 8-1v-2l14-2 58-2 1 1h56l8-1h21l10-2 26-1h35zm-215 16-38 5 3 2 16 4 45 10 29 5 36 3h71l29-2 28-4 28-5 14-2 19-5 3-1 1-3-6-3h-3v-2l-9-2h-13l-30 1h-71l-29-1z",
    fill: "#ADACAC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,409)",
    d: "m0 0h5l7 11 4 14-5 1-8-1-14 3-8 4-5 4-3 7 1 5 5 6 11 7 6 3 1 3 6 1 1-4 3-5 7-9 5-1 8 4 4 5-8 7-3 3-7 1-5 3 3 9 3 7 7 9 8 5 6-1 5-3 11-11 3-5v-9l-4-8-5-5 6-3 7 1 12 7 5 4 3 6-6 11-9 12-3 3h-2l-2 4-11 12-8 6-4 5-2 3h-2l-2 4-4 5h-2l-2 5-3 1-3-16-5-8-6-8-8-7-20-20-16-15-9-6-8-4-8 1-3 1v-2l5-4 6-7 5-3 4-6h2l2-4 11-12 12-11 11-9 7-4z",
    fill: "#070607"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,746)",
    d: "m0 0 1 2 4 2 1 3-3 16 3-1 2-7h1l-1 9-4 15-6 28-2 8-2 15-1 1-5 38-4 49-1 16v78l3 36 3 26 4 27 5 25 7 31 6 24 6 21 7 23 3 11h-2v4l-2 1v3l3 3-2 1-1 3-3-9h-2l-4-12-3-10-2-8-2-7-2-6-5-18-3-13-2-5-2-11-3-16-2-6-2-14-2-7-2-12-2-2v-8l-1-4h-2l-1 4-6-51-2-36v-50l1-28 4-47 3-28 5-30 5-24 7-30z",
    fill: "#211D25"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,435)",
    d: "m0 0 6 1 12 9 6 4 1 7-5 7h-2l-2 4-3 3h-2v2l-15 15-3 4h-3l-2-3h-5l-1 5h2v2l6 2 9 4 7 5 1-2 3 1h-2v2h5l3-6 7-9 14-20 9-8 2-1h6l3 2-1 7-7 12-11 13-7 9-3 5h-2v2l5 2 30 22 7-6 8-11 7-10 11-10 6-1 4 4 1 9-7 11h-2l-1 3-8 7-8 6h-2v2l-4 4-3 4h-2l5 5 9 8 13 8h6l3-1 1-3 5-3 9-9 8-7 5-4h10l5 2 2 3v6l-8 4-8 6-9 8-8 7-4 5-5 4h-9l-8-6-7-8-10-8-5-6-8-7-11-11-12-9-13-9-13-7-9-7-8-4-9-7-9-4-10-2-5-4 2-7 3-1 1-4 4-5 5-14 3-9 4-8 9 1 5-5z",
    fill: "#090809"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,755)",
    d: "m0 0 23 2 11 3-2 4-8 3h-59l-19 1-3 1 12 3v2h2l5 6 6 5 1 3-2 6-6 9-2 2h-4v2l-12 9-10 3-15 2h-29l-11-3-6-5-4-10-1-4-1-14 4-15 5-4 21-2 33-1 38-7z",
    fill: "#FADFCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,1489)",
    d: "m0 0h21l13 7v2l4 2 14 12 5 6 2 4v6l-5 8-5 5-4 2-7 1-3 2h-3l1-6 2-6v-13l-7-11-3-3-3-1h-11l-4 4-1 4v9l4 13 5 9 6 9 3 8v21l-5 10-11 8-4 1v2l-5 2-6-1-16-4-11-6-10-8-6-7-6-10-2-4v-13l4-6 7-6 5-2h9v3l7-2-1 3h-2l-2 6-5 10v10l5 8 1 3 5 2 3 1h9l5-2 3-6-1-11-7-20-5-8-3-17v-13l6-8 8-6z",
    fill: "#070606"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1712,747)",
    d: "m0 0h22l14 3 11 6 9 9 8 16 7 26v12l-4 6-8 5-7 4h-17l-5-4v-5l7-9 10-9 1-4v-17l-3-6-1-3-4-2-8-2h-14l-14 3-16 6-14 8-5 4-3 6 1 11 3 13 6 16 3 11v6l-1 2-8 1-6-11-6-8-7-13-5-9-2-14v-12l3-11 4-10 11-9 17-10 15-5z",
    fill: "#060506"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,492)",
    d: "m0 0 7 1 8 7 5 11v9l-1 4h-5v-2l-9-3v-2h-8l-7 1-4 3v7l4 7 7 7 17 10 15 11 11 8 10 5 7 2h9l4 2 6 1-2 4-4 6-5 5-8 14-7 10-5 4-10-20-10-11-11-7-14-10-9-6-12-9-12-7-7-1-2 3v15l1 3 4 2 8 12v6l-4 1h-7l-12-5-17-9 3-7 10-16 14-18 8-12 7-8 11-16 8-10 5-1z",
    fill: "#060506"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,218)",
    d: "m0 0h14v27l-2 7-4-1-8-5-4-5-10-3h-18l-5 5 1 10 4 14 7 13h-2v2h3l2-4 13-4 22-2v12l-1 3-13 4-5 1h-16v7l-1 3v15l2 7 3 5h22v5l-12 6-5 2-32 7h-8l2-8 3-9v-5l-2-5-4-25-8-36-5-15-5-8-4-5v-2l36-6 25-5z",
    fill: "#060506"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,1619)",
    d: "m0 0h9l6 3 5 10 4 10 11 21 11 25 6 13 6 12 9 11 2 4-6 3-20 2h-16v-21l-3-9-3-1-2-6-4-8-5-17-7-12-3-5v-2h-2l-3 9-3 11v16l5 4 5 2 12 2 1 3 5 2v1l-9 1-3 3-1 2h-7l-8-4-8-1-3 8v11l4 9 2 4v3l-5 1h-25l-4-1 1-7 5-10 9-25 10-29 4-10 8-16 4-16 2-4z",
    fill: "#060506"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1263,245)",
    d: "m0 0h8l21 6 12 5 10 8 4 5v13l-4 13-4 7-10 2-5-8-1-2-2-14-5-10-7-7-9-4-4 2-8 6-7 7-6 10-5 11-4 14v18l4 9 6 8 8 5 12 3 18 2 6 3 4 11 2 4 9 1 1 9h-5l1 2-4-1v-4h3l1-3h-6l-5-4-7-1h-9l-15-2-23-6-10-5-7-6-7-14-3-9-1-7v-20l3-12 6-12 12-16 12-9 8-4z",
    fill: "#060506"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1047)",
    d: "m0 0 2 4 4 16 15 38 16 32 10 19 9 17 11 23 6 13 3 8 5 10 3 1-2 7-9 16-8 13-2 4h-2l-2 5-4 1-8-3-1-4 3-5-1-2-3-1-1 3-6-1v-5h5l-3-8 1-5 3-1v-9l-3-1 2-6-1-13-3-1 3-4v-13l1-1v-5l-4-4-1-8-4-5-9-16-3 3-2-8-7 1-4-2-1-7-3 1-2-4v-7l-1-5-5-2v-9l-1-7 1-31z",
    fill: "#1F1A27"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,858)",
    d: "m0 0h14l13 3 6 4 1 10-8 4-10 4-6 3-7 8v10l5 10 5 6 10 6 12 4 6 1h20l12-4 9-7 7-9 3-8v-16l-3-12-2-5 1-4 13 5 7 8 3 15v11l-2 11-3 10-8 12-7 8-12 8-10 4-6 1h-25l-15-5-12-7-9-7-7-9-6-12-3-15v-15l5-16 6-12z",
    fill: "#070607"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1096,1268)",
    d: "m0 0 2 3-2 2 19 1 9 3 1 4v16l1 11-2 3-8-5-13-5-14-5-13-2-6 2-6 1-2 5-9 6-11 2-13 1h-20l-17-2-8-4-2-3-5-3-1-4 73-1 21-7 1-1-4-1-8 2h-11l-2-1v-3h-32l-11 1-8 2h-12v-3l-2 1h-14l1 2 9 3-2 4-5 2-1 3-8 1-36 1-7 1-3 2-3-5-3-24h45l-1-3 13 1 25 3 32 1 19-1 14-2 2-1 11-1h18l7-1z",
    fill: "#E54145"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1027)",
    d: "m0 0 5 1 3 7 7 30 14 56 12 37 6 14 10 24 8 16 8 17 7 11 6 11 6 10 15 23 14 20 10 13 13 16 11 14 13 15 29 29 8 7 11 10 10 8 7 7 4 6 5 8-6-2-12-7-16-13-11-9-9-9-8-7-13-12-14-15-7-8-13-15-13-17-10-13-12-19-8-11-14-22-8-14-12-22-8-17-7-15-7-19-3-9-4-9-4-13-6-18-8-33-6-28-1-2-2-15-1-5v-11z",
    fill: "#1A161F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,1028)",
    d: "m0 0h5v11l-7 34-4 20-6 21-3 12-8 26-12 31-12 28-8 17-9 17-16 27-11 18-11 16-10 13-12 16-11 13-7 8-10 11-7 8-15 16-12 11-11 10-11 9-15 11-11 5h-2l1-7 9-10 7-6 4-4 6-4 3-3 6-5 5-4 4-4 8-7 18-18 2-4 13-13 12-16 9-11 28-38 13-20 9-15 5-10h2l2-5 17-34 5-13 5-11 9-24 5-15 10-38 7-28 5-22 4-14 1-5z",
    fill: "#1B202F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,1293)",
    d: "m0 0 13 2 14 5 13 5 8 5 3 6-1 5-3 3-9 2-32 1-17 1-38 1h-50l-28-1-19-2-8-3-1-2v-20l22-1h29v-6h2l2 4 7 4 4 4 5 2 17 2h20l18-2 8-2 3-3 4-2 2-4 11-3z",
    fill: "#CFCECD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078,762)",
    d: "m0 0 19 1 32 2 14 2 10 3 2 3 1 11v9l-4 15-6 7-13 4-12 2-17 1-15-1-13-4-6-5v-2h-3l-4-6-5-6-3-3-1-7 4-6 11-6 5-12z",
    fill: "#FADFCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,1611)",
    d: "m0 0h8v3l1-2h9l21 4 6 3 1 3 1 19 2 9 6 10 3 4 5-1 6-8 8-16 3-14 2-5 2-1h17l10 1-1 7-13 16-11 14-12 17-8 10-4 13v7l6 22v6h-9l-24-5-10-3v-3l6-8 5-10v-20l-3-11-6-13-7-20-10-16-9-8h-2z",
    fill: "#070606"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,273)",
    d: "m0 0h12l10 4 7 6 5 6v2h2l7 12 7 18 1 5v14l-3 7-7 9-8 6-5 2h-6l-10-5-10-9-7-10-8-16-5-14v-20l3-6 8-7 5-3z",
    fill: "#FBFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1481)",
    d: "m0 0 3 3 4 19 9 17 3 8-2 5-9 2h-6l-8-19-4-10-2-2h-3v15l2 15v8l-5 2h-15l-1-30-1-7h-8l-1 3-2 16-1 4v11l-4 9-7 6-5 3-11 3h-5l-12-11-6-8-3-11-1-7v-17l5-2h9l3 3 5 30 4 5 3 1 5-3 1-2 1-41 29-9 15-6 10-2z",
    fill: "#070607"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1407)",
    d: "m0 0h5l2 22 3 10 6 14 2 9v7l-6 3h-5l-6-7-5-8-11-6-4-2-10 1-9 4-4 1 3 12 9 20 1 5v10l-3 3-5 2-5-1-14-24-6-8-5-3h-11l6 18 5 11 3 10v8h-2l-1 3-4 2h-6l-6-10-12-22-4-8v-9l5-5 5-3 15-8 14-8 13-7 13-8 6-4 10-3 1-3 6-5 8-10z",
    fill: "#070607"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1207,915)",
    d: "m0 0 5 2 15 9 21 12 26 14 25 14 16 9 11 6 8 4-1 3h-25v-1l9-1v-3l-8-2-5-2-9-1h-8l-14-3-8-2 2-2 12 1 3 1 18 2 3 1-1-3h-5l-12-5-4-1v-2l-8-1-6-2-7-2v3l-8-2-4-2-3 1v2h-2l-2 4-9 2-7-1v2l-7-1-5 2-21-1-5 1h-17l-22 1-2-1v-3h2v-2l4-4 4-2 5-4 4-2 3-4-1-2 4-2h2l9-9 7-1v-2l3 1h7l2-3-2-9 3-5z",
    fill: "#1F1D33"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(978,1517)",
    d: "m0 0h21l10 3 1 1 2 26h6l4 5 3 7 3 1 1-3h2l5 5-11-25-1-6 1-10 2-2h24l8 2 1 7-4 10v16l4 13 2 2-1 5-5 3h-11l-13-1-8-6-2-3-6 1-13 8-8 3-11-1-7-4-4-7-2-11 2-18 1-18 1-2z",
    fill: "#070607"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,774)",
    d: "m0 0h10l2 4 3 20 1 5h2l4 9 11 8 15 5v2l38 2 3 2v3l-19 8-7 8-5 6-5 2-2 9 7 19 1 4-4-1-3-2v-2h-2v-2h-2l-7-8-6-3-4-6v-4l7-3-1-4-5-3-10-2-8-5-5-5-5-2-5-4-8-16-6-15-3-13 2-7 7-6z",
    fill: "#FEEDDE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,923)",
    d: "m0 0 14 2 2 3 1 8 5 4 7 2 2 2 8 2 5 4 13 7 3 3v2l15 3h25v3l-14 2-3 1-13-2-15-1-5 1-18-1-6 1h-12l-12 2v-2l-7 1v2l-13 2-3-1-5 1-12-1-7-1-13 2-2 1-3 7-3 1-8-1-11 4-5 1h-25v-2l10-1 13-5 4-3 6-1 7-4 9 1 7-2 1-2 8-6h3l2-4 5-3 2-4 5-5 3-1 1-3 5-2 4 1 4-6 8-2z",
    fill: "#1F1D33"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1069)",
    d: "m0 0 2 2 4 44v8l-1 1-1 9-2 5-5-2h-5l-7 10-4 8-5 12-5 9-2 4h-2l-2 5-7 14-3 12-4 8-3 9-6 7-5 1-2 4 2 10 6 6v12l-4-3-3-1-7-10-4-7-6-11-1-5 4-1 7-10 6-11 12-26 18-38 9-17 14-31 10-24z",
    fill: "#1E1A27"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,673)",
    d: "m0 0h2l4 8 4 11-1 3-4-3v-2l-3 1-4 5-5 1-2-1-1 2h3v13l4 10 7-1 6-3 4-4 1-10h2l5 9v12h2l2 7 3 9 7 15 11 23 2 7v5l-6-2-8-7v-2l-4-2-4-18v-3h-2l-2-5h-4l-10 7-6 4-7 8-2 6h-2l1 14 4 6v2l-6-2-5-5-4-9-3-6v-11l4-7 9-7 6-3 26-8 1-2-1-4h-2l-2-11-6 1-16 8-16 7-9 7-5-1-6-6 1-9 5-5 8-5 5-7v-8l-5-3h-7l-4 3h-2l-2 4-4 4-5-2-2-4h-2l-4-9 1-3 24-6 12-5 15-8 4-1z",
    fill: "#0C0B0D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,513)",
    d: "m0 0h2v2l-7 6-7 8-12 13-2 5-5 2-2 4-5 8-4 7-2 4-3 7-5 10v3l-3 6 2 1 1 6-3 7h-2v9l-3 11-3 8-2 1-3 12-4 5-3 5-1 4-6 3 1 7-5 3h-2l1 5 1 3-2 5-2 7-1 3-5 21-4 16 1 12 8 3 16 2v1l-14 3-7 2-2 2h-6l-3-3v-7h-3l-1 5-4 4-4 8-6 4-4-1 1-6-2-1-2-4 1-5 8-21 13-31 13-29 12-30 5-12 12-27 13-27 10-17 10-13 8-10 9-10 7-8z",
    fill: "#1F1A27"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,371)",
    d: "m0 0h13l4 10 3 10v15l-4 24-2 4-9 3-10 1-21 9-7 2h-14l-2-5-4-16-3-6-4-16-1-8v-10l2-2 14-4 4-1h16l4 3 2 4 2 10v14l-4 10v9l5 5 5 1 6-2 2-4 6-9 1-4v-20l-5-18-2-3v-5z",
    fill: "#080709"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,1615)",
    d: "m0 0h17l7 8 7 11 6 12 4 15v22l-4 6-13 9-10 6h-5l-5-7-11-38-5-20v-12l6-9z",
    fill: "#FAF9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,1525)",
    d: "m0 0h4l2 10 2 16 8 14 10 19 12 20 9 10 7 4 7 2-2 4h-2v2l-23 13-12 5-4-1 3-4v-9l-4-11-36-60-7-8-7-2-1-4 5-4 14-7z",
    fill: "#060506"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,1177)",
    d: "m0 0h11l10 3 10 7 5 8 1 17-8-6-10-8-16-8-7-3-4 1-4 4v3l6 4 15 9 10 7 11 8 5 10v9l-4 8-7 4-9 5-8 2h-13l-13-5-7-8-5-11v-2h3l-3-6v-7l5 3 3 9h2v2l4 2 13 9 8 2 14-2 4-2-5-4-8-7-12-8-4-5-7-3-10-3-5-3-1-2v-8l4-8 6-8 16-8z",
    fill: "#B1B1B1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,429)",
    d: "m0 0 8 1 7 4 7 8 4 3 5 12 4 18v3l-11 6h-3l-2 4-6 4-11 4h-6l-11-8-7-9-7-14v-18l24-16z",
    fill: "#0B0A0C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1472,573)",
    d: "m0 0h10l7 3 9 10 4 5 4 4 1 4-9 7-13 15-6 7h-2l-2 4-3 3-6 3h-6l-5-5-11-14-6-8v-12l3-6 5-7 5-4 9-5 7-3z",
    fill: "#221E24"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,1115)",
    d: "m0 0h85l19 2 23 8 7 5 5 8 4 23v10l-2 13-1 17-2-2-1-7-1-8v-10l-3-8-3-6-5-5-8-5-15-6-25-6-6-1-18-1h-34l-14 1 2-2 9-2 3-1 4 1 1-2 22-1 32 1 14 1 7-3-2-4-65-1h-8l-8-1h-48l-1-4 14-3z",
    fill: "#B5B6B5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,358)",
    d: "m0 0h10l9 5 3 4v31l2 6v8l-2 11-7 3-13 2-5 1h-7l-9-4-1-2v-9l1-1-1-24-2-17v-8l1-1 9-1 8-3z",
    fill: "#0A090A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1100,1512)",
    d: "m0 0h14l3 3 2 7 1 17 4 1 2 4v10l-2 9-5 5-7 3-5 1h-14l-10-5-10-9-4-5-2-8 1-13 4-9 6-5h6l8-4z",
    fill: "#070607"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,1473)",
    d: "m0 0h8l14 4 17 10 1 3v12l-4 23-3 9-7 4-17-2-10-4-9-6-6-7 1-9 6-15 5-16 3-3z",
    fill: "#070507"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,1419)",
    d: "m0 0h13l11 4 6 4 9 10 2 4-1 9-3 5-5 2-5 6-5 13-4 7-5-1-9-4-11-7-9-9-5-11 1-8 10-19 5-4z",
    fill: "#090809"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,476)",
    d: "m0 0 12 3 12 5 19 10 20 13 21 16 11 10 8 7 16 16 9 11 12 15 9 15 10 21 10 27 8 21 12 28 12 30 9 25 7 25 7 29 2 12v7h-2l-2-15-1-1-2-14-4-14-3-13-4-13h-4l-4-8-2-3v-8h-2l-4-10-5-10v-7l-4-8 1-7-3-8-4-2v-2h-2l-2-9-1-1-2-3-1-4-2-1-1-6h-2l-4-8-6-10-4-4-6-13-7-18-2-7-3-1-4-10-3-4v-2h-2l-4-7-5-6v-2h-2l-1-4-4-2v-2l-4-2v-2h-2v-4l-4-2-4-6-6-5-6-7-6-4-5-5v-2h-3l-1-2-4-2-2-2-1-2-4-1-2-2-3-1-4-4-16-10-11-5-4-2-7-2-3-1h-9l-16 7-12 7-11 8-13 11-2-1 7-7 16-12 13-8 14-6z",
    fill: "#1F1D33"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,1503)",
    d: "m0 0h8l32 6 7 4 3 6-1 17-2 25-2 10-11-2-6-2-2-4 1-7v-35l-1-4-8-3 1 17 1 5v9l-6 11-5 4-4 2-8-1-6-4-1-5 7-28 1-15z",
    fill: "#070607"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,794)",
    d: "m0 0h2l5 10 2 10 3 5 1 6h2v8l-4 4-23 4h-3l-1-2-4 1-5 1-2-1-1 4-1 2-7 2h-8l-4-2-2-4-3-1-3-12v-10l2-4 2-7 17-4 22-4 10-3z",
    fill: "#1F1B22"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,592)",
    d: "m0 0h4l2 4v5l-8 9-3 9 10 7 16 11 12 7 6 1v3h-2l-1 5-5 6h-8l-10-4-8-10-12-6-7-3-10 5-6 11-7 3-5 4-1 2 5 2 12 4 19 7 5 4 11 6 2 3v5l-5 6h-5l-10-7-32-16-11-4v-8l12-14 7-11 12-18 9-12 10-14z",
    fill: "#0B0A0C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,775)",
    d: "m0 0 8 1 9 3 8 4 5 8-1 8-6 15-7 11-4 8-7 10-5 2h-23l-5 1h-9l-3-4-1-6 12-7 6-8 8-4 5-5 4-26 4-9z",
    fill: "#FEEEDE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,363)",
    d: "m0 0h22l10 2 2 2 1 4v11l-1 4-2 23-5 22-15 1-9-3-8-3-1-6v-48l3-7z",
    fill: "#F8F7F7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,1014)",
    d: "m0 0 4 1v2h2l2 10v5l2 4 2 7 2 1 1 4-1 2h2l2 16 5 35 5 28 10 42 6 24 5 15 5 19 4 11-1 2-1 4-2 1v3l3 3-2 1-1 3-3-9h-2l-4-12-3-10-2-8-2-7-2-6-5-18-3-13-2-5-2-11-3-16-2-6-2-14-2-7-2-12-2-2v-8l-1-4h-2l-1 4-6-51-1-16z",
    fill: "#201B27"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,435)",
    d: "m0 0 6 1 12 9 6 4 1 7-5 7h-2l-2 4-3 3h-2v2l-15 15-3 4h-3l-2-3h-5l-1 5h2v2l6 2 9 4 7 5 1-2 3 1h-2v2l5 1-2 3-5 2-8-5-5-3-8-6-9-4-10-2-5-4 2-7 3-1 1-4 4-5 5-14 3-9 4-8 9 1 5-5z",
    fill: "#0E0D0F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1303,1582)",
    d: "m0 0h17l5 6 2 4v20l-4 8-5 7 1 9 4 2 11 7 11 8 7 7 1 2 17 1v1l-18 1-4 2-9 1h-13l-6-2-4-4-3-7v-12l1-11 1-3h-6l-8-7-5-7-6-15 1-5 2-7 7-5z",
    fill: "#FAF9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1047)",
    d: "m0 0 2 4 4 16 1 5-1 3 3 8v3h2l2 6v13l-1-2h-3v-2l-6 3 5 3 6 5 6 7 3 2 3 7 6 10 8 13 4 7 4 11 8 11 3 7-1 6h-4l-4-6h-2l-5-7-2 1-7-9-9-16-3 3-2-8-7 1-4-2-1-7-3 1-2-4v-7l-1-5-5-2v-9l-1-7 1-31z",
    fill: "#161A29"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,749)",
    d: "m0 0 4 2 1 5h2l3 12 2 9 3 2v2l4 2 5 5 5 2 1-4 2 5-1 4-5 4-17 4-19 3-11 3-2 8-2 2 1-9-3-6 1-5h-2v-2h-4l-5-8 1-4 5 9 8 4-5-8v-14h2v-5l6-7h2l1-3 12-8z",
    fill: "#F8F7F7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1407)",
    d: "m0 0h5l2 22 3 10 6 14 2 9v7l-6 3h-5l-6-7-5-8-11-6-4-2-10 1-9 4-4 1v5l-2-1-5 1-1 4 2 1-1 2 2 3 3 1 2 5-1 6-4-1-8-8 1-6-5-1-6-1 4-1 1-4 7-4 5-4-3-2-1-4 13-8 10-6 9-4h2l1-3 6-5 8-10z",
    fill: "#201C23"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1481)",
    d: "m0 0 3 3 4 19 9 17 3 8-2 5-9 2h-6l-8-19-4-10-2-2h-3v15l2 15v8l-5 2h-15l-1-30-1-11v-9h-2l1-4 15-6 10-2z",
    fill: "#070506"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,764)",
    d: "m0 0h3l-3 11-5 4-6 3h-2l-2 4-1 3 1 8 4 2 7 9 4 7-2 1-6-3-7-6-3-5-8-10-2-1-1-3-6-5-7-2h-2l-2 4-2 3h-2l-2 7-14 16-9 6-10 4-10 3-7 1-1 1h-32l-6-2v-1l37-2 13-2 3-2h4l1-4 7-6h2v-2l5-2 7-10 1-6-4-5-7-6v-2h-2v-2l-12-2-1-2 4-1 19-1h59z",
    fill: "#201B29"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,784)",
    d: "m0 0h10l10 1 11 5 7 4 6 8 3 6v12l-2 4-1 18-4 5-6 2-5-1-13-3-19-6-6-2-9-6-1-1v-9l2-9 4-3h3l4 5v2h2l5 5 8 6 9 3h15l6-4 2-3 1-6-5-2-8-7-8-4-12-3-2-4-8 2-1-3h-3v-10z",
    fill: "#0A090B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,1651)",
    d: "m0 0 10 1 11 6 15 6 4 3-1 9-4 9-4 6-8 7-5 5-5 1-1 2-22-4 3-2-2-4v-31l5-10z",
    fill: "#F9F8F8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,758)",
    d: "m0 0h20l1 3h13l5 1v1h-22v2l-21 2-5 5-3 14 1 13 3 10 4 6 5 3 9 2h29l15-2 12-3v2l-6 1-1 2-13 2-33 2v1l-10-1-9-4-10-7-3-4-1-6h-2l-3-10-2-15-1-3h-10l-10 4-5 4-2 7 4 16 5 12 9 17 6 7 13 8 6 5 3 6 3 8 7 10 10 18 9 13-1 2-7-8-10-17-9-14-10-20-9-3-8-7-7-9-9-16-4-9-3-8-1-11 2-7 2-4v-2l-2-1 1-4 3-4h2v-3l5-4 18-1h12l2-1z",
    fill: "#201925"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1379,1270)",
    d: "m0 0 3 1 1 2v9l2 16 5 1 3-3 7-1 3-2h5 3l1 2 7-1 10-11 4-3 4 2-2 6-3 4-2 4-5 4-4 8-8 6-2 4h-2l-2 4-8 11h-2v2l-10 4h-2l-1 2h-2l-3 6h-2v8l-2-1 1-36v-11l1-7 1-24z",
    fill: "#161B2A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,1301)",
    d: "m0 0 1 4-3 10h4l-2 7-7 14-7 15-10 19-6 12h-2l-1 5-8 13-9 15-4 7-8 12-6 8-3 5-6 9-7 10-9 13-13 17-11 14-9 11-12 14-10 11-7 8-15 16-7 7-2-1v-2l2-1-1-1-2-1 1-2h2l2-4 5-5h5v-2h2l2-4 2-5 6-1 2-4h2l3-6h2l2-5 1-4h2v-2l2 1 1 1v-3l2-2v-4h2l2-4h2l1-3 6-2 2-5h-2l-2 4-2-1 2-4h2l1-4 5-4v-3l4-5h2l1-4 4-3-2 5-1 3 3-1 3-6 4-4 3-6 4-1 1-5 5-6 4-8 3-2 4-8 4-5 6-12-5 6-1-2 5-9 7-10 9-15 8-15 12-21 14-29 6-11 7-18z",
    fill: "#211D24"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1523,622)",
    d: "m0 0 7 1 4 6 2 8 7 7 6 10v3l-20 6-12 3-8 7-3 7-3 10-1 1h-6l-5-4-7-12v-2l20-6 11-5 25-8 1-4-3-5v-2l-3-1-1-2-6 1-15 8-6 4-21 8-5 4h-3l-4-6v-2h-2l1-5 11-8 11-7 9-5 15-9z",
    fill: "#201C23"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1826,696)",
    d: "m0 0 6 2h4l7 18 8 25 6 23 4 15 5 22 8 45 4 26 1 20-2 6-1-4h-2v7l-2 2-2-25-2-7-1-8-1-11-2-11-2-15-1-5-2-7-2-10-7-34-4-13-10-31-8-24z",
    fill: "#1F1C23"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,1274)",
    d: "m0 0 7 2 1 6v2l2 4 7 1 3 3v2h2l1 4 5 2v2h3l2 4 2 1v2l5 2v2l13 1 5-3 4-2 2-11 1-17 1-4h2l1-3h1l1 9 2 51 2 25 1 4-4-2-5-6-6-5-7-8-10-10v-2h-2l-7-8-10-11-8-10-9-11-9-13z",
    fill: "#171C2A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,1519)",
    d: "m0 0h24l8 2 1 7-4 10v16l4 13 2 2-1 5-5 3h-11l-13-1-8-6v-4l4-1h6v-2h3v-4h-2l-10-22-1-6 1-10z",
    fill: "#060506"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(856,237)",
    d: "m0 0h18l10 3 6 7 7 4h3l1-6h1v38h-1v-11l-15 2-15 3-5 2-2 4-3-1v-4l-7-14-4-15v-6l5-5z",
    fill: "#F8F7F7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,1028)",
    d: "m0 0h5v11l-7 34-4 20-6 21-3 12-8 26-9 23-1-2h-2l1-5h2l1-7-8 16-6 15-1 2-4 2-2 9-8 16h-2l-2 5-1 4-3 7h-3l-1 5h-3l1-4h2l2-5 17-34 5-13 5-11 9-24 5-15 10-38 7-28 5-22 4-14 1-5z",
    fill: "#211F29"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,1491)",
    d: "m0 0h8l18 4 3 2-2 10-9 40-3 4h-12l-9-4-6-4-1-4 5-10 4-6 2-8z",
    fill: "#070607"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,441)",
    d: "m0 0 2 4 1 12 5 2 7 5 16 2 7-1-4 2-5 2 7 8 2 5v9l-6 8-11 11-5 2-6-1-6-4-6-7-4-6-4-11 1-3 5-3h7l1-3 9-7-5-5-7-3-5 2-2 2 1-4 2-3 2-10z",
    fill: "#F8F7F7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(977,1300)",
    d: "m0 0 6 2 4 4 5 2v2l11 1 7 2-1 3-9 3v4h2v3l-6 1h-19l-7-3-6-3h-17l-14 2-8-3-2-1 1-13 2-3 7-1h41z",
    fill: "#FCFCFB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,565)",
    d: "m0 0h7l10 4 8 2v2l11 3 14 4 9 1 5 2-6 7-4 5h-6l-2 1-13-4v-2l-10-3-15-5 3 7 8 7 4 8v2l4 2 4 8-1 7-4 5-2 3h-2l-2-6-5-8-9-19-5-12-6-11-1-5z",
    fill: "#09080A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,1083)",
    d: "m0 0 1 4 3 8-1 6h3l1 8-1 7-4 5-7 1-4 4-7 9h-2l-2 5-4 4-3 5-1 6h-2l-3 9-3 6-5 11-1 7v3h-2l-1 9h-2l-1 6-1 2h-4l-1 4-5 1-1 7-5 4-2 1-1 7h2l-1 8-3 3h-3l-4-8-1-5 4-1 7-10 6-11 12-26 18-38 9-17 14-31 4-10z",
    fill: "#1E1A21"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,356)",
    d: "m0 0h9l6 2 6 9 2 5 1 6v19l-12 6h-7l-7-3-7-7-8-14-1-8 7-7 10-7z",
    fill: "#F8F7F7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,1328)",
    d: "m0 0 4 1 4 5 3 1 1-2 11 14 13 15 29 29 8 7 11 10 10 8 7 7 4 6 5 8-6-2-12-7-16-13-11-9-9-9-8-7-13-12-14-15-7-8-8-9v-2h2l-3-5-2-3-2-6z",
    fill: "#1B1D2A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,1258)",
    d: "m0 0 3 3v2l42-1 17-1h26l5-2 5 1 1 4 26 4h22l5-3 3-2-2 6-2 2-8 1h-17l-11 1-8 2-8 1-28 1-23-1-39-5-5-5-4-6z",
    fill: "#2B2D44"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1027)",
    d: "m0 0 5 1 3 7 7 30 4 16 4 17-1 2v1l-2 8 2 3 4 16 3 10 4 12 3 6 4 13 8 20 5 13 2 4 2 6 1 5h2l1 4v4l3 3-2 2-4-4-10-21-7-15-7-19-3-9-4-9-4-13-6-18-8-33-6-28-1-2-2-15-1-5v-11z",
    fill: "#201E25"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,986)",
    d: "m0 0 10 1h39l257-1h111l136 2 4 2h-147l-88 1h-89l-48-1-183-1-3-2z",
    fill: "#979596"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1707,897)",
    d: "m0 0h18l3 5 2 24 1 9-5 5-6 3h-8l-9-3-4-5-3-10v-19l2-5 4-3z",
    fill: "#F7F6F6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,459)",
    d: "m0 0 6 1 10 23v5l-5 2-4 5-6 1 3-5 1-14h2v-6l-8 2-5 4-4 11v7l9 1v2l3 1v2l3-1 2-3 7 9 4 8 3 9-8 4h-6l-5-4-7-10-4-8-8-8-7-8-5-6 1-4 13-10 5-4 4-4z",
    fill: "#0A090A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1582,739)",
    d: "m0 0 4 1 7 15 11 23 2 7v5l-6-2-8-7v-2l-4-2-4-18v-3h-2l-2-5h-4l-10 7-6 4-7 8-2 6h-2l1 14 4 6v2l-6-2-5-5-4-9-3-6v-11l4-7 9-7 6-3 26-8z",
    fill: "#080709"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,1445)",
    d: "m0 0 5 1 4 6 11 6 13 10 6 4-1 3-14 9-7 6-8 11-2 4-3 2-5-1-9-5v-6l7-14 4-13v-17z",
    fill: "#080708"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,1447)",
    d: "m0 0 9 4 9 2 12 6 18 2 26 8 18 5 14 3 7 4 8 1 4 2 18 2 37 6 21 2 17 1v1h-23l-36-4-6-1-34-1-14-1-11-5v-2l-4-2-3-1-3-3-2-1v2h-7l-11-3-12-1-6-3-8-1v2l7 1v1h-7l-1 4-2 2-2 4v-4l-6-2 3-3-1-3-9-6-11-8-8-4-2-2z",
    fill: "#D1D1D0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,764)",
    d: "m0 0h13l10 5 4 5 1 4v15l-2 7-3 3h-18l-11-3-5-5 1-12 3-9 6-9z",
    fill: "#F8F7F7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,1475)",
    d: "m0 0 20 4 37 8 27 4 28 2h71l29-2 28-4 28-5 14-2 20-5v3l-12 5-19 6-19 4-9 3-1 3-3 2h-7l-10-3-102-1-7-1-28-2-22-3-31-5-12-1-7-3h-5l-8-5z",
    fill: "#AEAEAE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,1614)",
    d: "m0 0 7 1 10 6 9 8 3 8v8l-5 7-2 1h-10v-2h-7l-8-4-5-5-10-9 1-6 3-8 8-4z",
    fill: "#F8F7F7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1573,1160)",
    d: "m0 0 2 1-2 7h-2l-1 5h2l-1 8-13 30-8 17-9 17-16 27-11 18-6 9-4 1-1-3 2-3h2l1-5 1-3-6 8-4 5-1-5 1-4 11-16 12-19 8-13 2-2 2-1v-2h3l1-4 2-4 1-5 5-6 4-8 3-7 1-7 2-2h3l3-10 9-20z",
    fill: "#191E2C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,411)",
    d: "m0 0h7l4 3 13 4 10 6 1 10-1 5-4-1-8-6-2-2h-6l-3 3-5 12-5 26-3 6-7-1-9-4v-5l6-12 10-29 3-7 1-7z",
    fill: "#0A090B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,363)",
    d: "m0 0h22l10 2 2 2 1 4v11l-3 8h-4l-8-20-2-3h-8l-4 5-2 7v21l3 14 4 7h6l11-4-1 9-2 4-14 1-14-4-2-1-1-6v-48l3-7z",
    fill: "#080709"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1375,312)",
    d: "m0 0 7 1 10 7 6 6 3 8v9h-2l-1 4-4 4h-18l-14-4-2-6v-6l8-16 4-5z",
    fill: "#F8F7F7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,941)",
    d: "m0 0 7 6 4 5 5 4 7 3h6l6 5 13 6 3 1v3h6l7 2 5 1 4-2 6 2h6l5-2 2-3 11-1h8l1-1 9-1 6-1v-2l3-1 2 4-1 2 9-2 7-3 3-5 1-1h5v-2l7-4h5v-2l4-1-1 2h9l-1 2-9 2h8l-5 4-7 1-5-2-6 4v6l-5 3h-5v2l-15 1-3 1-7 2-2-1-1 2-4-2-8 1-8 2h-37l-1 1h-9l-10-6-6-1-2-6-5-4h-8l-11-6-3-4-2-5-3-5z",
    fill: "#161B2A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,788)",
    d: "m0 0h1v8h3l1 2 8-1 2 3 15 4 11 8 7 5v6l-5 6-4 2h-15l-10-4-11-8-1-3h-2l-4-5v-2l-5 2 2-5 4-5z",
    fill: "#F8F7F7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1180,382)",
    d: "m0 0 15 2 2 5v13l-2 10-3 7-6 10-8 14-4 3-10-1-3-1 1-6 6-8 4-11 7-36z",
    fill: "#070607"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1523)",
    d: "m0 0h1l2 13 6 10 6 18 1 11-3 6-2 2-4 1h-9l-8-4-6-9-1-2v-10l8-16 1-1h-5v-3h-6v-1h14l4-1z",
    fill: "#F8F7F7"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,589)",
    d: "m0 0 2 2 2 5 5 10v2l5 2 2 2h16l8-3h6l-1 5-10 13-14 14-1 3-4-2-4-5v-2h-2l-7-10-12-18v-3l2 1-3-4 1-4h2v-2h2v-2l4-1z",
    fill: "#09080A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,580)",
    d: "m0 0h6l6 7 5 6-2 5-3 6h-2l-2 4-13 10-7 7-3 2h-5l-2-2-3-10v-9l3-7h2l2-5 5-6 8-4z",
    fill: "#F5F4F4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1140,291)",
    d: "m0 0 4 1 3 3 2 5 2 23 2 7v6l2 1-9-1-28-4 3-2v-3h-2l-1-3v-8l4-10 11-9 5-5z",
    fill: "#F9F8F8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,987)",
    d: "m0 0 8 2v1h-9l-10 1-23 1h-179l-36 1h-12l-7 1h-45l-3-1h-27l-26 1-42-2-39-1-158-1v-1h172l48 1h98l79-1h147l60-1z",
    fill: "#B6B7B6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1366,463)",
    d: "m0 0h6l3 2-1 7-7 12-11 13-7 9-3 5h-2v2l4 2 4 5 5 5-2 1-2-1-1 2-2-1v2l-5-2-8-5-8-4-4-3 1-3 4-2 4-8 7-9 14-20 9-8z",
    fill: "#0A090B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,604)",
    d: "m0 0 2 1-5 6-2 5-1 3 10 7 16 11 12 7 6 1v3h-2l-1 5-5 6h-8l-10-4-8-10-12-6-7-3-3-1 1-2-5-5v-3h2l1-4 4-2 4-1 1-6 5-5z",
    fill: "#201C23"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1122,1325)",
    d: "m0 0h4l-2 5-5 2-8 1-70 3h-91l-18-2-11-3-1-2 2-1 47 2h58l44-2h48v-2z",
    fill: "#6F7070"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,407)",
    d: "m0 0h8l3 3 4 13 3 7 1 3 4 2 8 6v28l-3 2-10 1-2-4-4-20-5-8-6-9-2-4-1-19z",
    fill: "#0A090A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,1205)",
    d: "m0 0h1l6 32 6 22 7 10 2 1v3h-30l-4-4 2-6 2-5-1-8 1-7-1-10 2-11 3-7 2-8z",
    fill: "#B4B5B4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,445)",
    d: "m0 0h21l5 5 5 15 2 9v7l-3 2h-11l-9-6-5-5-5-6-3-5-2-9v-4z",
    fill: "#F8F7F7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,371)",
    d: "m0 0h13l4 10 3 10v15l-4 24-2 4-9 3h-12v-2h2l2-4 6-9 1-4v-20l-5-18-2-3v-5z",
    fill: "#070607"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,673)",
    d: "m0 0h2l4 8 4 11-1 3-4-3v-2l-3 1-4 5-5 1-2-1-1 2h3v15l-2-1-1-12-4-1-1-3-3-1v9l2 1-1 8h-1l-1-8-5-3h-7l-4 3h-2l-2 4-4 4-5-2-2-4h-2l-4-9 1-3 24-6 12-5 15-8 4-1z",
    fill: "#2C2E41"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,371)",
    d: "m0 0h5l1 1v10l-7 46-3 10-2 1-12-2-1-1v-8l7-30 3-20 5-5z",
    fill: "#080709"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1069)",
    d: "m0 0 2 2 4 44v8l-1 1-1 9-2 5-5-2h-5l-7 10-4 8-1 3-6 1-3 1-2 5-6 11-3 1v7h-2l-4 12-1-4v-8l6-12 2-5 4-9 2-4 2-5 5-8 3-3 1-2h2l2-4 4-5 2-3h2l1-2 7-1 3-4 1-7v-8h-3v-7l-3-9-3 1 3-10z",
    fill: "#1F1A27"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,476)",
    d: "m0 0 12 3 12 5 19 10 20 13 21 16 11 10 8 7 16 16 18 22 1 5 6 9 15 30 1 8-5-1-2-5-6-5-1-7h-2l-4-12-3-8v-3h-2v-2h-2l-5-10-4-4-8-13-9-8-4-5v-3h-2l-5-5-6-7-11-9-10-9-4-2v-2h-6v-2l-4-1-2-2-3-1-4-4-16-10-11-5-4-2-7-2-3-1h-9l-16 7-12 7-11 8-13 11-2-1 7-7 16-12 13-8 14-6z",
    fill: "#161A29"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1223,395)",
    d: "m0 0 9 1 3 1 2 3-1 4-10 9-2 3-5 17-3 9-3 12-3 4-6-1-8-4-1-7 6-13 4-8 5-7 8-17 3-5z",
    fill: "#090809"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,1282)",
    d: "m0 0h29l3 1v3h15l8-2 3 3-8 3-11 4-4 1h-73l1 4-3-2-1-4 4-4-9-2-1-3 16-1 2 2h12l6-2z",
    fill: "#ADACAB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,397)",
    d: "m0 0 6 1 5 5 8 20 6 17 7 16 1 3-6 3h-5l-3-7-6-8-8-7-1-14-5-13-2-5-3-2h-8l4-3z",
    fill: "#0A080A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,769)",
    d: "m0 0 2 2 1 9 1 8v10l2 4 4 2 12 4h30l12-2 8-1 2 1 1 4-7 4-11 2-3 2-19 1h-14l-12-2-4-2-6-8-2-6v-4h-2l-1-2-1-10 3-13z",
    fill: "#FEEDDD"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,363)",
    d: "m0 0h10l4 5 1 4v9l-3 6-3 3 4-1 1 2v10l-3 15-6 5-9 1-3-7v-8l5-10 3-5-1-4-3-5-2-6v-10l2-3z",
    fill: "#F3F2F2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,358)",
    d: "m0 0h7l4 5 1 19 2 13v18l-2 10-3 3h-17l4-7 2-6v-44l-1-9z",
    fill: "#0A090B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(439,750)",
    d: "m0 0 5 2 7 2 9 1 14 7 16 5 8 6 2 3-1 5-7 2h-8l-12-5-12-6-14-5-11-7 1-5z",
    fill: "#0A090B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,1014)",
    d: "m0 0 4 1v2h2l2 10v5l2 4 2 7 2 1 1 4-1 2h2l2 16 3 23-1 7-1 3-4-1 1-4-2 1v7l-2 1-1-6-1-8h-2l-1 4-6-51-1-16z",
    fill: "#201C23"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,1265)",
    d: "m0 0 4 5 11 17 12 17 10 13 12 15v3l-4-1-4-5-1 1 4 9 2 2v3l-4-1-11-13-12-16-11-17-9-13-5-8h4v-3l2-1-2-5h2z",
    fill: "#1F1B21"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,1296)",
    d: "m0 0 14 1 9-1h38l9 2 4 3v2h7l-2 4-13 3-13 1h-20l-17-2-8-4-2-3-5-3z",
    fill: "#211D25"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1613,814)",
    d: "m0 0h2l2 3 1 12-9 4-18 4-27 1-1-1 1-9 2-4 5-3 23-3 11-1z",
    fill: "#F2F1F1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,1177)",
    d: "m0 0h11l10 3 10 7 5 8 1 17-8-6-10-8-16-8-7-3-4 1-4 4v3l6 4 5 3v1l-16 1-2-7 1-5 1-2-5 2-2 1 2-4 2-3 16-8z",
    fill: "#A8A7A7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1789,594)",
    d: "m0 0h2l9 17 6 13 11 25 18 45v5l-3 1-2-2-4-2-4-8-6-16-7-17-2-2-3-10-6-12-2-2h2l1-5-2-1-2-7-2-1-3-7-2-9-1-3h2z",
    fill: "#1F1B23"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1625)",
    d: "m0 0 2 1-1 3 1 7 4 2 11 7 11 8 7 7 1 2 17 1v1l-18 1-4 2-9 1h-13l-6-2-4-4-3-7v-12l1-11 1-3h-6v-1l7-2z",
    fill: "#FAF9F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,366)",
    d: "m0 0h10l2 6 1 30 3 14 2 14-5 1h-11l-4-17v-9l3-9-1-9z",
    fill: "#09080A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1530,639)",
    d: "m0 0 5 1 6 8 1 5-4 3-25 8-13 5-16 5-4-5-1-4 7-5 23-9 9-6z",
    fill: "#F2F1F1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,1089)",
    d: "m0 0h2l2 5v7l2 1 1 9 2 10 1 1 2 14 2 6 3 16 3 15 2 4 2 10 5 18 2 6 2 7 4 16 3 9 2 5 1 13-4-4-2-6-4-11-6-21-8-26-12-51-6-35-1-3z",
    fill: "#0A090B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,689)",
    d: "m0 0h3l3 5 6 2v2l7 1 10 3 10 2 5 5 9 7 5 6-1 5-1 1h-6l-9-7-16-8-5-5-5-2-10-1h-3l-8 4-3 3-2 7-4 2-4-1 5-10 13-20z",
    fill: "#23202A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,1416)",
    d: "m0 0h3l-2 4-9 14-6 8-3 5-6 9-7 10-9 13-13 17-11 14-9 11-12 14-10 11-7 8-15 16-7 7-2-1v-2l2-1-1-1-2-1 1-2h2l2-4 5-5h5v-2h2l2-4 2-5 6-1 2-4h2l3-6h2l2-5 1-4h2v-2l2 1 1 1v-3l2-2v-4h2l2-4h2l1-3 6-2 2-5h-2l-2 4-2-1 2-4h2l1-4 5-4v-3l4-5h2l1-4 4-3-2 5-1 3 3-1 3-6 4-4 3-6 4-1 1-5 5-6 4-8 3-2 4-8 4-5 8-16h2v-2z",
    fill: "#1F1C23"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,523)",
    d: "m0 0 6 2 10 10 12 15 7 8 10 10-3 5-8 7h-1l-2-9-3-1-7-10-8-7-15-15-2-6v-5z",
    fill: "#0B0A0C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,580)",
    d: "m0 0 5 5 9 16 8 17 10 27 8 21 12 28 12 30 9 25 7 25 7 29 2 12v7h-2l-2-15-1-1-2-14-4-14-3-13-4-13h-4l-4-8-2-3v-8h-2l-4-10-5-10v-7l-4-8 1-7-3-8-12-30-6-16-3-5-2-10-12-24-8-14-2-3z",
    fill: "#1F1D31"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,790)",
    d: "m0 0 2 2 6 30 8 50 1 20-2 6-1-4h-2v7l-2 2-2-25-2-7-1-8-1-11-2-11-2-15-1-5-2-7v-5h2l-2-18 2 1z",
    fill: "#1F1B25"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1189)",
    d: "m0 0 3 1-2 4 1 9h18l11 7 7 5v4h-2v2l-7-2-7-1 2 5 1 5v2l-5-1-5-5-6-5-12-3-7-4-1-2v-8l4-8z",
    fill: "#F9F8F8"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,1028)",
    d: "m0 0h5v11l-7 34-4 20-2 8-1-4-4 1 2-8h-2l-4 18-6 22-4 12-3 1-1 2 2-9 10-38 7-28 5-22 4-14 1-5z",
    fill: "#201F35"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1348,1432)",
    d: "m0 0 3 4 4 10 3 7 2 9v7l-6 3h-5l-6-7-5-8-11-6-3-2v-2h-2l1-4 22-10 3 1z",
    fill: "#090809"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,725)",
    d: "m0 0 5 1 3 2 16 2 7 4 14 3h23l-1 4-4 6-8 4h-21l-13-6-9-6-5-4v-2l-3-1-4-5z",
    fill: "#090809"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(357,465)",
    d: "m0 0 3 1-11 14-14 19-10 14-24 36-5 9-4 6-1-3 3-7 6-11-1-1-2 1 2-6 6-11h2l2-4 3-5 5-10h2l1-4 5-6 3-3 7-11 7-9 4-2v2l6-2 1-4z",
    fill: "#211D24"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078,1652)",
    d: "m0 0h2l7 12 5 10 5 17 7 14-8-1h-7l2-2 8-1-4-2-1-2-15-3-6-4-2-2v-16l5-16z",
    fill: "#F1EFEF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1228,928)",
    d: "m0 0 6 2 21 12 30 16 24 14 17 9 8 4-1 3h-25v-1l9-1v-3l-8-2-5-2-9-1h-8l-14-3-8-2 2-2 12 1 3 1 18 2 3 1-1-5-9-3-4-3-4-1-4-5-10-5h-2v-2l-10 1-10-2-3-3v-2l-4-2-5-3-2-2-6-5z",
    fill: "#1F1A26"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1029,780)",
    d: "m0 0 9 3 2 4 3 1v3l4 2 8 10 1 4 3 1 4 8 5 3v2h-5l-14-11v-2h-2l-7-9-8-4-10-1 2 2v6l-4 6-7 6-6 4h-5v-4l10-12 7-9 2-5h2l2-4z",
    fill: "#FBE4D5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,1222)",
    d: "m0 0 1 3h2l2 3v39l-1 1v6h-22v-3-3l10-25 3-7 3-8z",
    fill: "#F4DBCA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,809)",
    d: "m0 0h3l4 5v2h2l5 5 7 5-2 2 8 7v3l6 1 11 5-1 3 10-1-2 2-8 1-6-2-12-3-21-7-9-6-1-1v-9l2-9z",
    fill: "#221F26"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,383)",
    d: "m0 0 5 1 3 5 5 15 2 20v11l-4-2-5-5-8-7-2-4-1-7v-22z",
    fill: "#F3F2F2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(380,560)",
    d: "m0 0h1l1 11 1 3 4 2 8 12v6l-4 1h-7l-12-5-17-9 3-7 5-8 5 3 1-4h2v-2h2l3 7h3z",
    fill: "#201D24"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,334)",
    d: "m0 0 2 4 4 4 3 2-9 4-5 2-2 4-4 10-10 3-11-1-8-4-8-6-3-1 2-6 6-10 2-3 2 10 14 4h18l4-4 1-3h2z",
    fill: "#1F1B22"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,1275)",
    d: "m0 0h3l-2 5-12 16-10 12-7 9-9 11-8 8-14 16-8 7-4 4-2-1 2-44h2l-1 31 1-2h2l3-6h2l1-3 9-3h3v-2l5-5 7-10h2l2-5 8-6 4-8h2l1-3 3-2 1-5 2-1 2-6 1-2 6-3z",
    fill: "#221E2B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1315,437)",
    d: "m0 0h7l1 4-6 2-4 5-4 13-2 9-3 6h-2v3h-3v-9h2l2-12-2-1-1-1-2 1-1 13v3h-2l-1 3h-2l-1 3-2 1v4h5v4l4 1 1 6-15-2-5-4 2-7 3-1 1-4 4-5 5-14 3-9 4-8 9 1z",
    fill: "#0B090C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1242,826)",
    d: "m0 0 2 4-1 2h2l1-3-1 9-8 21-8 16-10 16-9 11-4 3-2-2 3-1v-3h-2l-1-5 1-3 8-7 2-3 2-7 5-9h2l2-5 2-3v2h2v-9l2-1 3-11 3-3 2-6h2z",
    fill: "#201C2A"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1138,766)",
    d: "m0 0 10 1 6 2 3 5 1 13 1 4v14l-1 8 5-3-2 4-5 3-12 5-22 4-20 1-21-3-12-5-8-6-2-4 7 5 4 1-2-5h2l5 5 10 4 4 1 17 1 22-2 16-4 6-5 3-8 2-9v-9l-1-11-3-3-13-3z",
    fill: "#E54145"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,1101)",
    d: "m0 0 2 3 1 7 2 6 5 19 3 8 4 10 3 10 3 8 7 17 5 13 2 4 2 6 1 5h2l1 4v4l3 3-2 2-4-4-10-21-7-15-7-19-3-9-4-9-4-13-6-18-1-11v-8z",
    fill: "#0B0A0C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,255)",
    d: "m0 0h36l-2 12-5 6-4 2h-13l-12-2-3-4-2-3v-5l5-2z",
    fill: "#221E24"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1515,284)",
    d: "m0 0 5 2 22 16 16 13 10 9 11 9 10 9-1 2h-4l-1 3 5 2v4l-4-2-12-11-11-9-12-10 1-4-5-5h-1-3l-6-5v-3l-3-2v-2l-4-2-5-6-6-4z",
    fill: "#1D1A20"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,1186)",
    d: "m0 0 4 1 13 5 12 7 8 7 4 6h-2l-1 4-2 3h-6l-11-8-14-9-5-3-6-4 1-4h2l2-4z",
    fill: "#1D1F25"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(892,1500)",
    d: "m0 0 3 1 4 1h7v1l-6 1-1 5-1 15-8 32-8-2-5-4 2-3 10-44z",
    fill: "#F2F1F1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,778)",
    d: "m0 0 14 1 1 4 2 1-4 11-14 16-9 6-10 4-10 3-7 1-1 1h-32l-6-2v-1l37-2 13-2 3-2h4l1-4 7-6h2v-2l5-2 7-10 1-6-2-6z",
    fill: "#130B0D"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,768)",
    d: "m0 0 25 1 1 1h7l4 1-1 5-6 3h-2l-1 5-3 5 1 8 4 2 7 9 4 7-2 1-6-3-7-6-3-5-8-10-2-1-1-3-4-4 2-4h2v-4h2l-1-2-6-1v-3l-6-1z",
    fill: "#1F1B21"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,639)",
    d: "m0 0 6 2 6 8 3 5v3l-20 6-12 3-8 7-3 7-3 10-1 1h-6l-5-4-7-12v-2l20-6 11-5 25-8 1-4-3-5v-2l-3-1z",
    fill: "#231F29"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(741,1578)",
    d: "m0 0 5 1 1 1v27l-4 5-5 1-10-4-6-4-1-4 6-10 11-11z",
    fill: "#F3F2F2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1398,1071)",
    d: "m0 0 3 1 13 33 16 32 10 19 9 17-2 4-4-4-3-4-5-14-7-10-9-16-3-4-1-4-8-7-8-8-4-2 3-2 4-1v2h3v-11l-1-6h-2l-4-11z",
    fill: "#1F1A21"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,442)",
    d: "m0 0 6 1 5 4-1 14-9 13-5 10-2 2-5-1-3-1v-8l4-8 2-12 4-9z",
    fill: "#F5F4F4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1415,499)",
    d: "m0 0 5 1 3 7v5l-7 11h-2l-1 3-8 7-8 6h-2v2l-4 4-3 4h-2l1 3h-2v-4h2l-1-3-3-3 6-7h2l1-4 5-5 4-2v-5l3-3 1-3 6-4-2-6 3-3z",
    fill: "#201C23"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1612,559)",
    d: "m0 0h2v3l4 1v8l5 2 5 5 1 8-2 6-2 2-6 1-7-6-5-6-4-9-2-1v-2h-6l5-4 4-3 7-4z",
    fill: "#080708"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,1224)",
    d: "m0 0h4v2l4 2 12 8 6 6 4 2-2 3-14 3-9-1-11-7-6-5-1-4 1-1 9-1z",
    fill: "#070807"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1472,573)",
    d: "m0 0h10l7 3 9 10 4 5 4 4 1 4-6 4-6 2v2l-2-1-2-2 1-6 2-5-6-7-4-5h-6l-8 6-5 2-4-1-2-2-4-1 2-5 4-4z",
    fill: "#0D0B0E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1559,690)",
    d: "m0 0h3l4 4 2-1 5 8-1 12-8 7-6 2-5-1-4-10v-9l1-4h-3l1-3 5 1 5-5z",
    fill: "#F3F2F2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,1328)",
    d: "m0 0 4 1 4 5 3 1 1-2 11 14 13 15 32 32-5 1-9-7-14-14-4-3h-3l-9-9v-4l-3-1-7-8-6-5-3-5-2-3-2-6zm6 16 2 1-2 1z",
    fill: "#2D3146"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1418,1387)",
    d: "m0 0 3 2h-3l-1 5 2 1-4 1-1 4-4 6-5 3h-2l-2 5-5 5h-2l1 4-15 10-9 4h-2l1-7 9-10 7-6 4-4 6-4 3-3 6-5 5-4 4-4z",
    fill: "#2D3246"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,937)",
    d: "m0 0m-2 1 2 1-5 6-5 5-3 1-1 4-3 3-4 2-1 2-7 4h-2l-1 3-5 3-5 1-8-1-10 5-4 1-9 4-7 3h-7l4-2 17-8 19-11 20-11 22-13z",
    fill: "#1E1A26"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,845)",
    d: "m0 0 2 2v3l3 1 3 4v2l7 1 2 4h2l2 5 4 2 3 5v1l6 1 1 3 2 2h-2l-1 3-3 1 1 6 4 5-9-1-9-10-9-15-4-7-2-4v-7h-2z",
    fill: "#211C2A"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,955)",
    d: "m0 0 2 1 2 16 2 10-1 10 1 8v7l3 1v5h2v-2h2l2 23 1 16h-2v-6l-4-2-2-9-1-1-1-15h-2l-1-2-2 3-2-12v-50z",
    fill: "#24212F"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388 1e3)",
    d: "m0 0 2 2 4 42-3 32-2 36-4 55-4 59h-1v-29l2-31 3-41 2-23 2-41v-9l-1-5v-14l-1-6-1-17z",
    fill: "#9D9C9C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1523,622)",
    d: "m0 0 7 1 4 6 2 8 2 3h-8l-8 4-3-1 2-3-1-5-8 3-5 2-6 2-10 5h-5l-1-2 4-4 7-5 11-6 12-7z",
    fill: "#090809"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,1506)",
    d: "m0 0h8l1 1 1 7v30h12v2h-8l-19-2v-14l2-8 1-12z",
    fill: "#B1B1B1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1181,936)",
    d: "m0 0 4 2 1 5v10l-5 6-10 6-10 3-3 1h-7l-2-1 1-4 2-4 5-1 4-4 4-2 3-4-1-2 4-2h2l7-7z",
    fill: "#1E1A27"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,517)",
    d: "m0 0 3 1-13 8-20 13-14 10-16 12-16 13-10 9-8 7-16 15-16 16-9 11-12 14-2-2 11-14 15-16 31-31 8-7 5-5h2v-2l12-8 4-4 10-7h2l1-3h3v-2l3-1 5-5 5-1 1-3 7-5 6-3h3v-2l10-6z",
    fill: "#ECD6C6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,1529)",
    d: "m0 0 10 2 16 8-1 4-7 6-9 5-9-1-4-7v-11z",
    fill: "#D0D0CF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1047)",
    d: "m0 0 2 4 4 16 1 5-1 3 3 8v3h2l2 6v13l-1-2h-3v-2l-9 3-2-2-1 5h-1l1-28z",
    fill: "#171B2B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1866,1056)",
    d: "m0 0 2 2 2 7 2 8-1 9-2 7-1 9h-2l1 7-4 8-2 17-2 6-2 10-4 2 2 1-1 8-2 4v2h-2l-1 2 1-8 7-36 6-39z",
    fill: "#221F27"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,1514)",
    d: "m0 0 6 1 3 2 1 4v35l-1 10-8-4-7-4 7-13v-9l-1-5z",
    fill: "#A6A5A5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1208)",
    d: "m0 0 6 2-2 6-5 3-2 5v5l-3 3v3l-2 4 2 10 6 6v12l-4-3-3-1-7-10-4-7-1-3 4-3 2-8h-2v-7l7-5 2-7 5-1z",
    fill: "#161B29"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1300,453)",
    d: "m0 0 2 4 1 4-2 9h-2l1 4-1 5h3l1-3v8l8 1 6-4h3l-9 10h-3l-2-3h-5l-1 5h2v2l6 2 9 4 7 5 1-2 3 1h-2v2l5 1-2 3-5 2-8-5-5-3-8-6-9-4-8-1v-1h9l4 2-2-6-3-1v-4l-5 1-1-5 6-5 2-5v-6l3-10z",
    fill: "#1C1920"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1154,941)",
    d: "m0 0 1 3-5 7-2 1 1 2-4 2-3 1-1 3-6 1-16 6-3 1-2 4-9 1-10 2v-2l9-3v-6l7-5 5 2 7-1 3-2h-8l1-2 10-2h-9l3-4 8-1 3 1 6-4 2 1-2 4 3-1 1-3 8-4h2z",
    fill: "#1E1A27"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,1437)",
    d: "m0 0h14l6 4 2 3v9l-5 5-5 1-11-3-5-4-1-7z",
    fill: "#F3F2F2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,772)",
    d: "m0 0h11l2 3 2 15v8h-1l-3-20-1-3h-10l-10 4-5 4-2 7 4 16 5 12 9 17 6 7 13 8 6 5 3 6 3 8 7 10 10 18 9 13-1 2-7-8-10-17-9-14-10-20-9-3-8-7-7-9-9-16-4-9-3-8-1-11 2-7 5-6 9-4z",
    fill: "#E64145"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,673)",
    d: "m0 0h2l4 8 4 11-1 3-4-3v-2l-3 1-4 5h-4l-2-5v-3l-9 1-4 4-3 1-3 3h-3l-9-2-2-2h3v-2l17-6 17-9 4-1z",
    fill: "#090709"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,775)",
    d: "m0 0 8 1 9 3 8 4 5 8-1 8-2 5-2-2 2-6v-6l-4-5-6 2-3 9-4 8-4 1-2-7-4-11-3-2-2 8-2 9-1-3 3-16 4-7z",
    fill: "#F9DFCC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1539,695)",
    d: "m0 0 4 1 1 3 3 1 1 2 1 10 3 4 2 5 4 2-6 2-5 3-3-1-4 1-1 3-6 4h-5v-4l3-4v-2l-3-2 5-3 5-7h2v-8l-1-1z",
    fill: "#201C24"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1172,1479)",
    d: "m0 0 3 1-20 7-15 4-11 2-9 3-1 3-3 2h-7l-10-3-102-1v-1l71-1 19-1 60-8 19-5z",
    fill: "#D1D1D0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1549,751)",
    d: "m0 0 2 1-2 4h-3l1 3 3-2 2 3v4h-2l1 3-1 2 4-1-2 3-1 5h-2l1 14 4 6v2l-6-2-5-5-4-9-3-6v-11l4-7z",
    fill: "#232028"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1490,603)",
    d: "m0 0 4 2h1l5-2-6 8-11 12-4 5h-2l-2 4-3 3-6 3h-6l2-1v-6l-5-2-1-4 7 1 10-9 14-11z",
    fill: "#211C28"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(984,391)",
    d: "m0 0 5 2 4 7-1 13-3 5-4 3-9 1-3-7v-8l5-10z",
    fill: "#F7F6F6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,476)",
    d: "m0 0 12 3 12 5 19 10 20 13 21 16 11 10 8 7 16 16 1 3h-2l-7-8-6-5v-2h-4l-5-5-6-7-11-9-10-9-4-2v-2h-6v-2l-4-1-2-2-3-1-4-4-16-10-11-5-4-2-7-2-3-1h-9l-16 7-12 7-11 8-13 11-2-1 7-7 16-12 13-8 14-6z",
    fill: "#1E1A25"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1611,609)",
    d: "m0 0h6l-1 5-10 13-3 2v-2l-4 4h-2l-2-2-5-2-4-2v-2l-6-1-2-1v-2h3v-2l7-4 15-1z",
    fill: "#201C23"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,1539)",
    d: "m0 0h9v3l7-2-1 3h-2l-2 6-5 10v12l-4 4-6-1-3-6-1-5 1-5v-3l3-5 2-4-2-3-2-1z",
    fill: "#211D24"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1099)",
    d: "m0 0 4 2 5 20 12 37 6 14 4 11h-2l-1 2-3-1-6-15-5-15-5-12-3-10-4-15-2-6-1-4 2-3z",
    fill: "#252333"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,1130)",
    d: "m0 0h2l-1 7-4 8v7l-2 5-6 1-3 1-2 5-6 11-3 1v7h-2l-4 12-1-4v-8l6-12 2-5 4-9 2-4 2-5 5-8 3-3 1-2h2l2-4z",
    fill: "#161A29"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,1301)",
    d: "m0 0 1 4-3 10h4l-2 7-7 14-7 15-6 12-4 2-5-1 2-6 13-27 6-11 7-18z",
    fill: "#1E1A22"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1167,1501)",
    d: "m0 0h1v39l-4 4-4 2-6-5-2-8-1-13h2v-3l3-1 2-2 7 3 1 2z",
    fill: "#CBCBCA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 452)",
    d: "m0 0h45l42 3 10 2v2l-54-3h-33l-40 2-35 2 3-2 26-3 29-2z",
    fill: "#F2DAC9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,824)",
    d: "m0 0h1l1 18-3 4-4 1h-7l-1-3-11-5-4-1-3-5-6-5 4-1 9 3h15l6-4z",
    fill: "#070608"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,1503)",
    d: "m0 0 4 1 3 4 8 20 2 7h5l-4 2-14 5h-2l-3-23v-15z",
    fill: "#B5B6B5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1344)",
    d: "m0 0 4 2 9 9 4 5 2 4 7 7h4v2l4 2 8 8 8 7 7 5 1-2 5 3 3 4-3 3-5-4-6 2-15-14-8-7-16-17-14-16z",
    fill: "#232335"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,1083)",
    d: "m0 0 1 4 3 8v6l1 7-2 2-4 2h-7l-3 1-1 8-6 8h-3v3h-2l1-5 14-31 4-10z",
    fill: "#060405"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,987)",
    d: "m0 0 8 2v1h-9l-10 1-23 1h-47l-132-1 2-2h147l60-1z",
    fill: "#B3B4B3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,988)",
    d: "m0 0h16v1l-11 1-13 4-3 1v5l1 4-5 4-4 2-5 2h-3l-3-6-3-1v-6l4-4 12-5z",
    fill: "#FADFCC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1131,908)",
    d: "m0 0 2 1 1 8-1 3h-2v3l-5 2h-6l-1 4h-2l-1 6h-3l-1 3-5 2-7 5-1 2h-3v3l-7 5h-5l-1-2h2l2-5 13-9 14-14 5-4 3-6 5-3z",
    fill: "#0B0607"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,1222)",
    d: "m0 0 5 3 3 9h2v2l4 2 14 10-2 1 1 3-9-1 1 3 3 1 1 3h-7l-6-4-6-8-4-9v-2h3l-3-6z",
    fill: "#CDCDCC"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,749)",
    d: "m0 0h12l12 2 11 2 3 2h10l14 2 8 2v2l-8 1h-9l-14-2-3-1v-2l-9 1-20-2-7-2-16-2v-1z",
    fill: "#181C2C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,1672)",
    d: "m0 0h1l1 16 5 4 5 2 12 2 1 3 5 2v1l-9 1-3 3-1 2h-7l-8-4-8-2 2-9 3-4z",
    fill: "#0A090A"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,473)",
    d: "m0 0 3 2 1 3-3 6 3 1-2 4-12 14-5 8h-2v2l3 1-4 2-5 2-3-5-2-1 1-2 2 1-1-4 5-5h2l1-7 4-1 1-3 2 2 1 5 5-5 1-5-4-1v-5l7-8z",
    fill: "#211D24"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,458)",
    d: "m0 0 9 4 4 5-8 7-3 3-7 1-5 3-1 4-1-3-4-2v-2l-2-1h3l1-4 3-5 7-9z",
    fill: "#09080A"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,1216)",
    d: "m0 0 4 2 4 4h-2l1 2v12l-6 2-5-1-8-4-3-3 1-2-2-10 4-1 10 4z",
    fill: "#CFCFCE"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1601,1036)",
    d: "m0 0 2 4-2 12-3 22-3 8-7 26-6 22-4 12-3 1-1 2 2-9 10-38 7-28 5-22z",
    fill: "#313248"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,794)",
    d: "m0 0h2l5 10v6l-5 3-1 2-5-2-4-3 1-2h-8l-13 1-4-1-1-3h3v-2l17-3 10-3z",
    fill: "#060506"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,471)",
    d: "m0 0h6v6h-2v14l-3 4 6-1-1 4-2 3h-3l-3-3v-2h-9l-1-1v-7l4-11 6-5z",
    fill: "#F2F0EF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1552,819)",
    d: "m0 0h1l1 10h3l1 8h16l17-1 10-1 8 1h10v1l-23 4h-3l-1-2-4 1-5 1-2-1-1 4-1 2-7 2h-8l-4-2-2-4-3-1-3-12z",
    fill: "#1F1B22"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(861,382)",
    d: "m0 0 10 1 3 5 2 10v14l-4 10-3 1-2-13-3-13-4-11z",
    fill: "#070608"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,1247)",
    d: "m0 0h1v20l-1 1v6h-22v-3-3l2-5 3-4v5l5-2 2-4h2l2-5 5-5z",
    fill: "#D2D1CF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,492)",
    d: "m0 0 7 1 8 7 5 11v9l-1 4h-5v-2l-9-3v-2h-14l3-1v-2l13-3 1-3-1-5 1-2-3-1-2-4v-2z",
    fill: "#1C181F"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1442,594)",
    d: "m0 0 3 2v6l-1 1 2 1 2 3h4l1 10 2 1 3 11 6 1-2 1v6l-4-1-4-4-10-13-6-8v-12z",
    fill: "#0A090A"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,1475)",
    d: "m0 0 20 4 37 8 27 4 48 3v2h-19l-28-2-22-3-31-5-12-1-7-3h-5l-8-5z",
    fill: "#AFAEAE"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1191,830)",
    d: "m0 0h2v6l-4 4h-2v2h-2l1 5-5 9-7 10-3 3-6 15-5 5-2-2h-5l2-3 2 1 1-2 4-1v-2l-3 1 2-4 4-3 2-8 8-5 2-5h-3v2l-9 4-3-2 4-1 2-4 5-5 9-7 2-3h2l1-4z",
    fill: "#1F1A26"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,613)",
    d: "m0 0 1 3-1 14-3 7-1 2h-2l-1 5-6 3-2 5h-2l-1 6-2 4-3 13h-2v4l-4 1-1 5-2-1 3-8-2-1h3l2-7 4-9 3-8 3-5 3-6 3-10 7-15z",
    fill: "#2A2C44"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1407)",
    d: "m0 0h5l2 22-1 5h-5l1-4-5-1-5 4h-2v-3l-4-1 2-2h5v-2h-5l-2 1 1-4 10-12z",
    fill: "#1A1A23"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1145,760)",
    d: "m0 0h10l6 2v2h6l8 5 1 3-5 3-2 3-5 1v-4l-4-1h-4l-3-5-15-3-3-2v-2l3-1 7 1z",
    fill: "#171B29"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1185,423)",
    d: "m0 0 4 1-8 14-5 7-2 1-10-1-3-1 1-6 6-8 2-2h2l5-3z",
    fill: "#1E1A20"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1119,1333)",
    d: "m0 0 3 1-6 4-8 1-50 2h-88l-17-1 1-2h106l33-1 19-2z",
    fill: "#B6B7B6"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,1090)",
    d: "m0 0h2l-1 7h3l-1 10-2 7-3 12-4 14-3-1-1 5-4-2 2-9 6-21 5-20z",
    fill: "#1A1E2D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1160,772)",
    d: "m0 0m-1 1 5 2v4h4l2-4 1-1h7v1l-6 2-4 9-3 21-5 6h-2v-22l-1-4v-12h2z",
    fill: "#342027"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,255)",
    d: "m0 0h11l-2 12-5 6-4 2h-13l-2-2h8l-1-3 2-7-1-4-15-1v-1z",
    fill: "#090809"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1228,928)",
    d: "m0 0 6 2 21 12 15 8 1 3-2 1v-2l-10 1-10-2-3-3v-2l-4-2-5-3-2-2-6-5z",
    fill: "#1E1A26"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1120,951)",
    d: "m0 0 2 1-1 1h9l-1 2-9 2h8l-5 4-7 1-5-2-6 4v6l-5 3h-5v2l-15 1h-3l-1-2 5-3 9-2 7-3 3-5 1-1h5v-2l7-4h5v-2z",
    fill: "#161A29"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,513)",
    d: "m0 0h2v2l-7 6-7 8-12 13-2 5-5 2-2 4-5 8-4 7-2 4-3 7-5 10v3l-1 2-3-1-1 2h-2l-1 5-4 2 2-6 11-21 10-16 10-12 9-11 14-15z",
    fill: "#1F1A25"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1375,1318)",
    d: "m0 0h2l-1 31 1-2h2l3-6h2l1-3 11-3 3 2-2 2-2 4-8 9-8 7-4 4-2-1z",
    fill: "#211F2A"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,535)",
    d: "m0 0 5 1 2 4h2v2l4 2 3-1 3 1 1 4-5 5-9 7-5 2 1-7-4-8v-8z",
    fill: "#0A090B"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,1293)",
    d: "m0 0 13 2 14 5-3 1v4h-14l-15-2-8-2 1-4 11-3z",
    fill: "#ADACAC"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1481)",
    d: "m0 0 3 3-1 4v-3h-2v11l-5 3h-4v2l-4-1-3-6-5-5v-4l4-2z",
    fill: "#201C23"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1442,559)",
    d: "m0 0 5 2 1 2 3 1-9 8-8 7-4 5-5 4h-9l4-2 4-3v-10l5-2v-2h2l2-4 4-3 4-2z",
    fill: "#201D24"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,751)",
    d: "m0 0h8l-2 1v2h29v2l-33 1-11 2h-15l-12 1h-10l4-2 8-1 3-1v-2l11-2h9l4 1z",
    fill: "#181B28"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,942)",
    d: "m0 0 5 2 8 5 5 2 4 2v2l5 1v2l5 1 10 4v2h3v2l4 1 2 4h-3l-3 1-4-6-9-1-7-3-8-4-5-3-8-5v-2h-2z",
    fill: "#170C0E"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(823,1490)",
    d: "m0 0 4 1 2 2v15l-3 6-8 8-4 2 1-9 4-16 3-8z",
    fill: "#F0EFEF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1516)",
    d: "m0 0 1 3-6 28h3l-1 9-8-2-5-4 2-3 6-27h1v6l1-3h3l1-4z",
    fill: "#CDCCCC"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1644)",
    d: "m0 0 4 1-2 4-13 18-4 6h-3v-2l-5 3-1-3-2-1 5-6h2l5-10h2l2-5 5-1z",
    fill: "#1F1B21"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,764)",
    d: "m0 0h3l-3 11-5 4-7 3v-3l8-4 1-4h-13v-1l-17-1h-14l-3 2v-2h-25l1 3-12-2-1-2 4-1 19-1h59zm-58 7h8v2l-8-1z",
    fill: "#793A43"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1538,879)",
    d: "m0 0 2 4 4 32 2 36v17l-3 50-2 20-2 2 2-27 1-20v-65l-2-27-2-15z",
    fill: "#E4D3C6"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1379,1235)",
    d: "m0 0h1l-1 23-4 79-1 25v3l-4 4h-2l-1-4 3-6 2-15 3-64 2-34z",
    fill: "#9E9D9D"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,757)",
    d: "m0 0h22l17 1-2 4-16 2h-9l-8-1h-15l-7-1v-1l7-2 3-1z",
    fill: "#FEEEDE"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1049,964)",
    d: "m0 0 3 1-5 5v2l-5 1-3 4-10 1-8-2-3 2-8-3 2-4h3l-1-3-4-2 13 2 12 1 7-2z",
    fill: "#291D25"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,859)",
    d: "m0 0 3 1-2 8-3 10-3 1-2 5-7 9-3 6-3-1 1-5 3-6 6-16 5-10z",
    fill: "#FEEEDE"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,786)",
    d: "m0 0h1l1 13 3 10 4 6 5 3 9 2h29l15-2 12-3v2l-6 1-1 2-13 2-33 2v1l-10-1-9-4-10-7-3-5 7 2-1-9z",
    fill: "#DD474B"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,566)",
    d: "m0 0 6 1 12 4v2l11 3v1h-5v2l5 2v4h-7l-10-6-13-4v-2l-3-1 2-4z",
    fill: "#1F1B21"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,786)",
    d: "m0 0h6l3 5 5 23-1 4-4-1v-2l-4-1-5-14z",
    fill: "#FCF9F7"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,580)",
    d: "m0 0 5 5 9 16 8 17 10 27 8 21 12 28 3 10-3-3-4-9v-2l-2-1-3-9-12-29-5-14-3-5-2-10-12-24-8-14-2-3z",
    fill: "#1F1A24"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,703)",
    d: "m0 0 7 1 5 5 9 7 5 6-1 5-1 1h-6l-9-7-11-5 3-3 5 1 3-2-1-3-3-1v-3h-5z",
    fill: "#26232C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,589)",
    d: "m0 0 2 2 2 5 5 10v3l-6 2-2 3h-5l-6-8 1-2 2 1-3-4 1-4h2v-2h2v-2l4-1z",
    fill: "#1E1A21"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,983)",
    d: "m0 0 13 1h90l17 1v1l-44 1h-120v-1l27-1 13-1z",
    fill: "#244F3F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658 1e3)",
    d: "m0 0 2 4 1 1v9l-2 5v42l-2 8v32h-1l-3-31v-7l2-9v-21l1-20z",
    fill: "#A7A5A6"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,1313)",
    d: "m0 0 1 2h5l1-2 8 10 7 9v3l-4-1-4-5-1 1 4 9 2 2v3l-4-1-11-13-3-5 4 1-2-3-2-6z",
    fill: "#24202D"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1540,688)",
    d: "m0 0h9l2 5v3l2 1-5-1-1 2h3v15l-2-1-1-12-4-1-1-3-3-1v9l2 1-1 8h-1l-1-8-5-3-11-1v-6l5 1h3l3-3h3l1-3z",
    fill: "#221F27"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1504,667)",
    d: "m0 0h5v3l-7 2-3 3-1 3 5 1-1 6-3 5-5-2-5-5-5-8v-2z",
    fill: "#211F2B"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(716,1399)",
    d: "m0 0 4 2 9 11 4 2 5 5 9 3 8 8 7 6 1 4h2v2l3 1-4 1-9-9v-2l-4-2-8-6-5-1-11-4h-16l2-2 13-1-3-2-3-10-4-4z",
    fill: "#CFCFCE"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,1135)",
    d: "m0 0 11 1 9-1h34v1l-30 1-24 3-20 5-12 5-9 6v-4l8-6 4-2 4-4 10-1 7-3z",
    fill: "#ABABAA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,790)",
    d: "m0 0 2 2 3 14v9h-2l2 3v7h-2l3 12 1 5v3l-3-1-2-2-2-16-1-5-2-7v-5h2l-2-18 2 1z",
    fill: "#1B1721"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,1416)",
    d: "m0 0h3l-2 4-9 14-6 8-3 5-6 9-7 10-9 13-6 8h-1v-5l3-3 3-6 4-1 1-5 5-6 4-8 3-2 4-8 4-5 8-16h2v-2z",
    fill: "#231F28"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,1586)",
    d: "m0 0 7 6 8 8 8 7 3 2v2l4 2 7 7 8 6v2l4 2 3 3-2 4-1-3-4-1-7-7v-2l-4-1-4-4-4-2v-2l-5-3-4-5-8-7-9-9v-3z",
    fill: "#1E1A20"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,809)",
    d: "m0 0 1 2-2 3 8-1-4 4-10 4-10 3-7 1-1 1h-32l-6-2v-1l37-2 13-2 3-2h4l1-4z",
    fill: "#201D27"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(169,1006)",
    d: "m0 0 5 2v5h2v-2h2l2 23 1 16h-2v-6l-4-2-2-9-1-1-1-15h-2l-2-3 1-5z",
    fill: "#221E2E"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,920)",
    d: "m0 0 9 4 8 5 7 9 4 8 3 5-1 2-6-3v-2l-5-1-7-7-3-8-1-2 1-2-2-1-7-3-1-3z",
    fill: "#1E1A27"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,553)",
    d: "m0 0 3 1-7 5h-2l-1 3-10 7h-2v2l-8 7-9 8h-2l-2 4-12 12h-2l-2 4-11 11v-3l4-5 5-5h2l3-10 12-6 10-10h2v-2h2v-3l4-4 7-8 7-4 7-3z",
    fill: "#FFEFDF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,281)",
    d: "m0 0 9 1 2 3 5 1 1 2-15 4h-16v7l-2 3 1-13 2-5z",
    fill: "#1F1B23"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(903,1238)",
    d: "m0 0h1l3 37 3 23 4 10 1 1v11l1 7h-2l2 4 10 3 9 2 18 2v1h-11l-21-3-7-3-5-3v-5l3-7-2-11-3-11-2-15-2-26z",
    fill: "#B6B7B6"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,446)",
    d: "m0 0 11 2 6 2 11 2 18 2v1h-9l-24-2h-45l-7 1h-10v-1l11-2 12-1 13-3z",
    fill: "#FFEFDF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,785)",
    d: "m0 0h10l11 5 7 4v3l-7-3 4 4 1 4 3 1-1 5-7-3v-2l-4-1-1-5-5-1v2l-4-2-7-2 1-3 3-1 4 2 1-2v2h4v-3l-8 1-1-3z",
    fill: "#201C22"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,965)",
    d: "m0 0 3 2-2 6-3 2v2l-7 2-2-1-1 2-4-2-8 1-8 2h-10l3-2 13-3v-4l8-1 1-1 9-1 6-1v-2z",
    fill: "#1E1A27"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1573,1160)",
    d: "m0 0 2 1-2 7h-2l-1 5h2l-1 8-11 26h-3l-5 11-1-4 5-10-1-2 5-12 7-18z",
    fill: "#09080A"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,433)",
    d: "m0 0 2 4-2 4-1 6-2 4v14l-1 5-7 2-3-3 1-4h2v-8l-1-2 4-12h2l3-6h2z",
    fill: "#201C23"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,1519)",
    d: "m0 0 3 1-1 1-1 11 3 9 8 18v3l-4-2-1-3h-2l-1 4-4-2-5-10-7-2 1-3 7 1 1-5 2-1v-12z",
    fill: "#ADADAD"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,366)",
    d: "m0 0h1l1 21 1 9-3 9v13l-4-4-3-1v-2h-2v-7l3-9 4-11z",
    fill: "#A4A3A3"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,1500)",
    d: "m0 0 5 2 15 15-1 3-5-4-1-2-1 1 3 5-1 2h3l4 4v3l3 1 8 10 1 2h-3v-2l-5-2-10-10-4-2-1-5-5-7-2-2 1-5h-2z",
    fill: "#1F1A27"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,1279)",
    d: "m0 0 3 3 3 1 2-3 3 5 6 8 6 5-1 2 3 5v2h-4l1 3h2l-1 3-5-3-12-19-6-9z",
    fill: "#080709"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,879)",
    d: "m0 0 1 2-4 23-3 33v53l2 33-2-2-3-29v-40l1-26 4-31 3-15z",
    fill: "#EFD9CA"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,1667)",
    d: "m0 0h21l-5 5-10 8-8 4-5 1-1-5 1-3 2-2 2-4h7v-2h-4z",
    fill: "#1D1A20"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(362,570)",
    d: "m0 0 2 4 1 5h9l2-3 2-1 4 4h-3v13l-6-1-8-5-10-5 3-7z",
    fill: "#080707"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1123,462)",
    d: "m0 0 13 2 27 7 11 3 10 4 30 10 27 11 9 5v3l-23-11-24-9-30-10-40-11-9-2z",
    fill: "#F0DBCB"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,1195)",
    d: "m0 0 4 1 6 5v2l5 1 3 3 6-2 3 1v2h2l1 5-2 6-4-1-16-11-9-6-1-3z",
    fill: "#080908"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,387)",
    d: "m0 0h4l-1 9-2 5-6 2v6l-2 5-4-1v-2l-3-3v-3h-2l1-4h2l1-3 5-3 2-6z",
    fill: "#1E1A20"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1181)",
    d: "m0 0 1 2 3 1 7 17 7 13v5l-6-2h-2l-4-9-1-4-5-11-2-8h2z",
    fill: "#1F1B27"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,794)",
    d: "m0 0 5 2v6l-4 6-7 6-6 4h-5v-4l10-12z",
    fill: "#FBE9DA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,775)",
    d: "m0 0 10 1 10 4 6 7 1 2-1 10-8 18-6 10-8 14-7 6-10 5-5 2-4 6-5 12-1-3 7-16 10-6 9-3 4-5 7-11 5-10 5-8 5-14-1-7-3-4v-2l-5-2-7-3-8-2z",
    fill: "#E64145"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,604)",
    d: "m0 0 2 1-5 6-2 5-1 3 2 2-3 1-3-1 1 7-1 8-3 1-5-1 1-3-5-5v-3h2l1-4 4-2 4-1 1-6 5-5z",
    fill: "#23202C"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1565,1167)",
    d: "m0 0h1v10l-6 15-1 2-4 2-2 9-8 16h-2l-2 5-1 4-3 7h-3l-1 5h-3l1-4h2l2-5 17-34 5-13 5-11z",
    fill: "#1C1F31"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,1237)",
    d: "m0 0 10 1 5 4 4 2-2 3-14 3-9-1-4-3h4l-1-4h2l2-4z",
    fill: "#1F1D23"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,1217)",
    d: "m0 0h8l7 3 3 4-3 1-3 7-9 1v3h-2v-2h-2v-8z",
    fill: "#283042"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,571)",
    d: "m0 0m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1 1 3-10 10-8 7-19 19-9 11-12 14-2-2 11-14 15-16 31-31z",
    fill: "#E8D3C5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,1187)",
    d: "m0 0 1 3-4 8-2 7h-2l-1 7-1 2h-2l-1 5-4 6-1 7h2l-1 8-3 3h-3l-4-8-1-5 4-1 7-10 6-11 9-20z",
    fill: "#1F1B26"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(963,933)",
    d: "m0 0h5l11 8 8 4v2l5 2 2 1v2h2v2h2l1 4-7-2-5-1v-2l-4-1-8-7-8-6-4-2z",
    fill: "#FBE3D4"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388 1e3)",
    d: "m0 0 2 2 4 42-2 3-2 27h-1v-22l-1-5v-14l-1-6-1-17z",
    fill: "#B5B6B5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1612,559)",
    d: "m0 0h2v3l4 1v8l4 2-10-1 1 3-6 1-1 4-3-6-2-1v-2h-6l5-4 4-3 7-4z",
    fill: "#211D27"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,366)",
    d: "m0 0h6l2 5v11l-3 8h-4l-6-16 1-4v2l4-1z",
    fill: "#080709"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1089,1533)",
    d: "m0 0h2l-1 9 3 1 1 6 7-1 4-2 2-6 3-2 6 1 1 4-7 6-9 5-9-1-4-7v-11z",
    fill: "#F1F0F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,1437)",
    d: "m0 0 4 2-3 6v7l4 2 1 2-5-2-4-1-9 1-2-2-1-3-2-2 3-1 6-7z",
    fill: "#1F1B22"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,1143)",
    d: "m0 0 4 4 6 16 5 12 3 8h-2l-1 2-3-1-6-15-5-15-3-6v-2h2z",
    fill: "#24202B"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,689)",
    d: "m0 0h3l2 5h-2l-1 7-5 5h-2l-2 4-2 2-2 7-4 2-4-1 5-10 13-20z",
    fill: "#111013"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1046,1221)",
    d: "m0 0 5 5 3 7v9l-1 3-8-4-2 2h-5l-7-7h3l5 1 5-1v-14z",
    fill: "#B2B3B2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1235,398)",
    d: "m0 0 3 1 2 4v1h6l2 4-7 9-5 4-4 1v-11l-4 2-4 3 2-4 7-7 3-2z",
    fill: "#A2A1A1"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1543)",
    d: "m0 0 5 1 1 7-7 7-7 3-1 2h-2v2h-7v-2l4-4h3l1-4 6-9z",
    fill: "#E7E6E6"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1181,841)",
    d: "m0 0m-1 1m-1 1m-1 1m-1 1m-2 1h2l-1 3-10 10-4 2h-3v2l-1 1h3l-1 5-5 6-4 1-1-4 7-16 4-4 10-4z",
    fill: "#1E1A21"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,1244)",
    d: "m0 0h3l8 13 4 7v3h-2l3 6h-3v3h-4l1-6-5-6v-3l-3-1-2-6 2-2-1-3-3-1z",
    fill: "#1D1923"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(885,836)",
    d: "m0 0 10 5 2 4 5 2 5 3 11 2 4 4-1 4-4 2h-3l3 7 1 3h-2l-4-7-3-8-5-5-9-6-8-6z",
    fill: "#FBE0CC"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1184)",
    d: "m0 0h9l-1 4-4 4v3l6 4 5 3v1l-16 1-2-7 1-5 1-2-5 2-2 1 2-4 2-3z",
    fill: "#C7C7C6"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1556,1194)",
    d: "m0 0h2l-1 5v4l-4 9v2l4-8 2 1-3 9-8 16h-5l2-12 5-10 3-7 1-7z",
    fill: "#17151C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1195,1491)",
    d: "m0 0 2 1-1 2h2l1 2v7l-1 3-8 1-2 3v-4l-6-2-1-4 1-2 6-1v-3l3-2z",
    fill: "#201D25"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1069)",
    d: "m0 0 2 2 3 31v6l-2-1-1-6h-3v-7l-3-9-3 1 3-10z",
    fill: "#1F1B25"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1509,1285)",
    d: "m0 0 2 1-3 4-1 4h-2l-1 4 3 2-10 14-5 5-1-3-4 1 2-5 15-20z",
    fill: "#1E202E"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,782)",
    d: "m0 0 4 2-3 5 1 8 4 2 7 9 4 7-2 1-6-3-7-6-3-5-5-7 6 3-3-8 1-6z",
    fill: "#2A1D23"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1045,1240)",
    d: "m0 0 4 2 3 3-2 5-7 4-9 5-4-1h3v-3l-3-1 3-4-3-2 10-2 1-3z",
    fill: "#A8A7A7"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1299,489)",
    d: "m0 0 1 4h2v2l6 2 9 4 7 5 1-2 3 1h-2v2l5 1-2 3-5 2-8-5-5-3-8-6-9-4-8-1v-1h9l4 2z",
    fill: "#2E3241"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,1275)",
    d: "m0 0h3l-2 5-12 16-7 8-6 2 2-6 3-1 1-3 3-2 1-5 2-1 2-6 1-2 6-3z",
    fill: "#221E2A"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,441)",
    d: "m0 0 2 4 1 12 5 2 7 5 16 2 7-1-4 2-5 2 2 3-9-2-5-2-5 3-5 4-3-1 9-7-5-5-7-3-5 2-2 2 1-4 2-3 2-10z",
    fill: "#A8A7A7"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1680,856)",
    d: "m0 0 2 4 8-1 1-2-1 9-3 1 1 5 6 1v1l-23-1 3-5 5-5z",
    fill: "#ABAAAA"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1207,915)",
    d: "m0 0 5 2 15 9 1 2-5-1v2l-6-2-5-1h-8l-4-3 2-6z",
    fill: "#161A29"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1827,676)",
    d: "m0 0 2 2 6 16v5l-3 1-2-2-4-2-4-8-2-7 2-2 1 1z",
    fill: "#201D27"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,1548)",
    d: "m0 0h2l-1 5-16 17-7 7-2-1v-2l2-1-1-1-2-1 1-2h2l2-4 5-5h5v-2h2l2-4 2-5z",
    fill: "#1F1C22"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1540,785)",
    d: "m0 0 3 4 3 5 8 4-3-5 1-2 2 1v2l3 1 3 5 1 4h12v1l-17 4-2 8-2 2 1-9-3-6 1-5h-2v-2h-4l-5-8z",
    fill: "#A9A8A8"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,779)",
    d: "m0 0 4 1 1 4v11l-1 8h-5l-3-13-1-2v-6z",
    fill: "#FEEEDE"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1682,1514)",
    d: "m0 0 3 3-2 4-12 14-10 11-5 5v-5l4-2 3-6h2l2-5 1-4h2v-2l2 1 1 1v-3l2-2v-4h2l2-4z",
    fill: "#27242B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1539,695)",
    d: "m0 0 4 1 1 3 3 1 1 2v13l-4 1h-4l-1 4-4 1 1-5 2-3h2v-8l-1-1z",
    fill: "#060505"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,1404)",
    d: "m0 0 5 4 1 3h2l2 7h2v2h2l2 6 3 3 2 4-1 2h2v3h2l2 5v3l-4-1 1-3-3-1-7-12-6-10-1-4-3-1-3-7z",
    fill: "#211E2E"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,784)",
    d: "m0 0h1l1 26-5-1-3-3v-3h-2l-1-7 3 1v-5l2 3v-7l-2-1 3-1h3z",
    fill: "#271D25"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(252,890)",
    d: "m0 0h5l1 2 3 2-1 9-2-1-1-3-1 1 1 9 1 7-1 3-4-2-2-8v-18z",
    fill: "#1F1C22"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,474)",
    d: "m0 0h3l4 9v5l-5 2-4 5-6 1 3-5 1-14h3z",
    fill: "#0D0B0E"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,1443)",
    d: "m0 0 3 1 2 6h2v2l4 2v2h2l4 5 2 7h2l2 3 2 8-4-2v-3l-4-2v-2l-3-1-1-3-2-1-4-7-1-4-3-1-2-4v-4l-2-1z",
    fill: "#201C2A"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,1239)",
    d: "m0 0 2 1 1 4h-2l-1 4 4 4-1 2v2l1 4 2 1 4 7 2 4-3 3-11-17-7-13h4l1 3 2-1-2-5 4 1z",
    fill: "#23202C"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,945)",
    d: "m0 0 2 1-4 5h-2l-1 4-3 3-4 2-1 2-7 4h-2l-1 3-1-2-2-1 3-6 14-10z",
    fill: "#161A29"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1029)",
    d: "m0 0 4 1 3 6 2 22-1 4h-2l-1-7-3-1v-12l-2-4z",
    fill: "#040304"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1389,1110)",
    d: "m0 0h1v9l-2 30v13l-3 25-2 28h-1v-17l5-72z",
    fill: "#2A2C44"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1490,603)",
    d: "m0 0 4 2h1l5-2-6 8-10 11-4 1 2-10-4 1 5-5z",
    fill: "#24212B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,1155)",
    d: "m0 0v3l-3 7-2 18v33l-2-4-2-12-1-2 2-29 3-8z",
    fill: "#AAA9A9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,1143)",
    d: "m0 0h1v11l-5 75h-1v-29l2-31 2-23z",
    fill: "#9B9A9A"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,578)",
    d: "m0 0 7 1 13 2 5 2-6 7-4 5h-6l-2 1-13-4 4-1 10 2v-2l4-1 1-5 1-2-10-2z",
    fill: "#252434"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,358)",
    d: "m0 0h10l6 3v1l-19 2-3 1-1 2-1 9h-1l-1-9h-4v-3l-6 3-2 3v-6l1-1 9-1 8-3z",
    fill: "#2B2833"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,1305)",
    d: "m0 0 7 1 5 1 4 5v3h-5l2 3 2 8-5-2-9-11 3-1 1-2h-2z",
    fill: "#1E1B22"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(972,1294)",
    d: "m0 0h2l2 4 2 2-4 3h-41l-7 1-4 15h-1v-18l22-1h29z",
    fill: "#D3D2D0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,761)",
    d: "m0 0h5v2l-5 1v3h-2v2l4-2 3 1-3 4-2 10-1-4-9-2-2-4v-5l12-4z",
    fill: "#2E1E25"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,1630)",
    d: "m0 0h3l4 5 12 10 3 3 5 2 7 1v2h6l-3 1 2 5-5-2-5-3-4-1v-2l-7-2-13-7 2-1v-3l-4-2-3-1z",
    fill: "#211F27"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1344)",
    d: "m0 0 4 2 9 9 4 5 2 4 7 7h4l-2 5-5-2-7-8-12-13-5-6z",
    fill: "#1F1E28"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,788)",
    d: "m0 0h1v8h3l1 2 8-1 2 3 3 2h-6l-7 1-6 4 1 7-4-3v-2l-5 2 2-5 4-5z",
    fill: "#A1A0A0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,1140)",
    d: "m0 0 10 1 18 6 11 6 5 4 2 3v3l-5-2-11-8-12-6-11-4-7-2z",
    fill: "#282A41"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1599,770)",
    d: "m0 0 3 4 4 11v5l-6-2-8-7v-2l-4-2 1-3 5 5v-4h2l2-4z",
    fill: "#23212E"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,755)",
    d: "m0 0h3l1 9h8l3-3 13-1-4 2-5 2-7 4-6 2v2l-5-1-1-1v-7h-5l4-4z",
    fill: "#2A2C44"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,417)",
    d: "m0 0h1l-1 9-2 4-14 1 2-1-3-9h7z",
    fill: "#252330"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1407)",
    d: "m0 0h5l1 7v13h-3-2l-4-5v-8l-2-2z",
    fill: "#292E3C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,774)",
    d: "m0 0h10l2 4 2 18-2-1-2-18h-6l-3 5-6 1-3-2-6 3-1 2-1 10h-1l-1-8 3-6 6-5z",
    fill: "#F4DBCA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,541)",
    d: "m0 0 5 3 5 5 3 6 4 4 1 6-7-2-1 3-2-6-1-6h-2l-5-10z",
    fill: "#1F1B21"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(890,618)",
    d: "m0 0h3l-2 6-5 11-3 9-3 6-3 5-4 12-4 8h-2l3-10 7-17 5-12z",
    fill: "#1F1A24"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,573)",
    d: "m0 0 2 1 1 5h3l-12 11-5 6h-4v2h-7l-8-4 3-1 8 2 5-1 3-1 7-8v-2l-16-3-14-4v-1l8 1 14 3 10 1v-3h3z",
    fill: "#A9A8A8"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,1503)",
    d: "m0 0 4 1 3 4 6 15v5h-2l-4-9-6-3v3h-2v-15z",
    fill: "#C3C3C2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,329)",
    d: "m0 0h15v5l-5 2-1-1-9 1-1 3-6 1-1-9 1-1z",
    fill: "#23202A"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,866)",
    d: "m0 0 14 5 6 6-1 2-6-6 1 6-3 3-3-1v-2h-3l-1 3-4-12z",
    fill: "#201D25"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,1028)",
    d: "m0 0h5v11l-2 9-4 1-2 2v-17l1-5z",
    fill: "#1B1E2F"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,796)",
    d: "m0 0 4 5 4 7v12l-2 4-1 12h-1l-1-11-1-2 1-6-3-1 1-10h2l-3-6z",
    fill: "#252229"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1510,664)",
    d: "m0 0 3 1-2 2 2 2-4 4-3 7-3 10-1 1h-6l-5-5 5 2h4l2-7-1-2-3-1 1-4 5-4h5v-3l-4-1z",
    fill: "#4B4B59"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1757,560)",
    d: "m0 0 2 1 5 10 6 10 5 8 6 12v2h2l2 8h2l2 5 1 3-3 1-17-34-12-21z",
    fill: "#0E0D12"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,1319)",
    d: "m0 0h9l11 1h13l3 2-5 2h-34l-3-1v-2z",
    fill: "#FEFDFD"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,1086)",
    d: "m0 0 2 3 2 1 1 4 2 1 1 5-1 1-1 4-3-3-1 5-1 6-2-4-2-8 1-12h2z",
    fill: "#1F1C24"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1600,1070)",
    d: "m0 0h1l1 10-3 13-2 8-1-4-4 1 1-13 3-7 2-3z",
    fill: "#262439"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1230,746)",
    d: "m0 0 2 3 7 25 7 29 2 12v7h-2l-2-15-1-1-2-14-4-14-3-13-4-15z",
    fill: "#201C28"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1464,575)",
    d: "m0 0h6l1 3 1 1v3l-6 3h-2l1 4-4-1-2-2-4-1 2-5 4-4z",
    fill: "#060505"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1540,1237)",
    d: "m0 0h4l-2 6-8 14-7 11-4-1 1-3h2l2-6 3-5 1-5 5-5 1-3h2z",
    fill: "#110F13"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(894,772)",
    d: "m0 0h2l3 8h5l2-1 3 1v5l-7 2 2 5v5l-2-2-1 2-3-1-3-21z",
    fill: "#1F1A27"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1154,767)",
    d: "m0 0h7l5 1 10 3-3 3-2 1-2 3-5 1v-4l-4-1h-4z",
    fill: "#1C181F"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,742)",
    d: "m0 0 1 2h11l15 4 9 1-3 2h-21l-13-6-2-2z",
    fill: "#24212A"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,1207)",
    d: "m0 0 4 1 7 23 3 11-4-1-2-5-3-10-2-4-2-5-1-4z",
    fill: "#231F27"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,517)",
    d: "m0 0 3 1-13 8-20 13-9 6-2-1 1-3 4-3h4l1-3 7-5 6-3h3v-2l10-6z",
    fill: "#FAE4D2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,459)",
    d: "m0 0 6 1 2 6-3-2h-6l-11 6-1 3 1 5-5 1v-3h-6l4-4 9-7 4-4z",
    fill: "#292733"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,1222)",
    d: "m0 0 5 3 3 9h2v2l3 1-3 1 2 6-3-2h-4l-2 2-3-9h3l-3-6z",
    fill: "#A3A2A2"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1860,1123)",
    d: "m0 0 1 3-1 5-2 11-2 5-3 1 2 1-1 8-2 4v2h-2l-1 2 1-8 6-30 1-3z",
    fill: "#211E26"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,768)",
    d: "m0 0 13 1 2 2-1 1 6 2v2h-2l-1 6-3 1-2-5v-5l-4 1-4 4 1-4-8-2z",
    fill: "#1E1A21"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1117,1487)",
    d: "m0 0m-7 1 14 1v1l-37 5h-13v-2l2-1 21-2z",
    fill: "#B0AFAF"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1867,812)",
    d: "m0 0h1l6 35-3 1-1-2h-3l1-5-1-4-2-12h2l-1-7-1-3h2z",
    fill: "#1E1A21"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1538,764)",
    d: "m0 0 3 2v4l5 1 2 2-1 4-2 4h2v7l-4-2-1-5-4-3-1-9z",
    fill: "#040303"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1800,1333)",
    d: "m0 0h1v6l-12 24-2-1 1-5 1-4 1-5 3-6 1-4z",
    fill: "#201C27"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,1228)",
    d: "m0 0 3 2v3h2l3 7 2 1 1-3 3 1 1 4h-3l1 4-4 2v-4l-5-1-8-14z",
    fill: "#1D1921"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(948,920)",
    d: "m0 0 7 6 4 4 3 5 11 8 7 5-3 2-10-7-5-3-5-6-5-5v-2l-4-2z",
    fill: "#57252C"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,703)",
    d: "m0 0h3v2h5l1 3 4 4-4 3-5-1-5 1-2-1-2-6h2v-3h3z",
    fill: "#201C24"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1036,1259)",
    d: "m0 0 5 1 1 4-13 1-33-1-8-1v-1l17-1h26z",
    fill: "#1F1B21"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,529)",
    d: "m0 0h3v2h-2l1 5h-2l-2 5-4 4-3 4h-2l1 3h-2v-4h2l-1-3-3-3 6-7h2l1-3 4-2z",
    fill: "#221F28"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,503)",
    d: "m0 0h4l1 2 4-1 1 2-3 5h-2v2l3 1-4 2-5 2-3-5-2-1 1-2 2 1-1-4z",
    fill: "#1F1B27"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1289)",
    d: "m0 0 11 1 4 2v1h-11l-6 1-19 1-4-1v-2l12-2z",
    fill: "#FEE2CE"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1390,545)",
    d: "m0 0 2 4v3l1 3 4 1 5 5 8 5h5l4-2 2 2 6-2-1 2-3 1-4 4h-6l-14-9-13-11v-2z",
    fill: "#B1B1B1"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1301,487)",
    d: "m0 0h5l2 4 2 1 1 4 10 6 6-1 2 2v4l2 1-5-1-1-3-1 3-8-6-12-5-2-1v-2h-2v-5z",
    fill: "#B2B1B1"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1311,1439)",
    d: "m0 0h7v2l3 3v2l3 1-1 2-10 1-7 2v-2l-2-1 1-4h4l1-5z",
    fill: "#191E2D"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,768)",
    d: "m0 0h14l8 1v2l-4 1v2l-4 2-4-1 1-2-11 2-2-1-1-5z",
    fill: "#1A171E"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,523)",
    d: "m0 0 3 1 2 3-1 2 3 1 2 4 2 2v3l3 4 1 5 3 1 2 4-4-2v-2l-3-1-1-2h-3l1-5-3 1-5-7 1-4-4-4-1 2-1-3z",
    fill: "#1F1A26"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1733,1448)",
    d: "m0 0h3l-1 4-6 8-10 15-9 12h-1v-5l3-3 3-6 4-1 1-5 5-6 4-8 3-2z",
    fill: "#25222A"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,435)",
    d: "m0 0 6 1 12 9 2 2h-5v4h-4l-1 9h-1v-13l-9-6h5v-2l-7-2z",
    fill: "#1B1720"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,1420)",
    d: "m0 0 7 2 1 4 5 2 6 9-6-2-12-7-4-6 3-1z",
    fill: "#1C1F2D"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1483,653)",
    d: "m0 0 9 1 4 1v2l-12 5-5 1-1-4-3-1 4-4z",
    fill: "#070607"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,362)",
    d: "m0 0 2 4 3 4v2l9 1 1 9h-5l1 2-4-1v-4h3l1-3h-6l-5-4-7-2 5-5z",
    fill: "#1B1923"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,822)",
    d: "m0 0h18v1l5 1-1 2h-32l-6-2v-1z",
    fill: "#592C3A"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,755)",
    d: "m0 0 13 1 16 3v2l-8 1h-9l-6-1v-1l-7-1-1-3z",
    fill: "#171B29"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1123,462)",
    d: "m0 0 13 2 27 7 11 3 15 6-1 2-29-9-30-8-6-2z",
    fill: "#EFD9C9"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,1186)",
    d: "m0 0 4 1 2 1 2 7h-3l-1 6-4-2-6-4 1-4h2l2-4z",
    fill: "#1C1B23"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,550)",
    d: "m0 0 2 3 1 6v3l-5 7-3-1v-2l-4-2-2-4 6-4 5 1z",
    fill: "#E3D4C9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,1506)",
    d: "m0 0h8l1 1v12l-10-2v-10z",
    fill: "#F6F6F5"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,782)",
    d: "m0 0h7l2 1v7l3 9-8-4-4-4-2-5z",
    fill: "#080506"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,1278)",
    d: "m0 0 4 4 7 11 9 12-4 2-4-4-1-5-2-2-6-7-4-4v-2z",
    fill: "#24202A"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1098,388)",
    d: "m0 0h1v13l-3 17-3 13-15 1 2-2 11-1 2-7-1-6 3-10v-15z",
    fill: "#B1B0B0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1576,333)",
    d: "m0 0 5 2 8 7-1 2h-4l-1 3 5 2v4l-4-2-5-5v-2l-1-4-5-1v-3l1-2 2 1z",
    fill: "#1F1A25"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,135)",
    d: "m0 0 9 1v1l-41 6-4-1 1-2 22-4z",
    fill: "#211E28"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1360,1539)",
    d: "m0 0 2 1-2 4 5 6v2h2l1 4h-2l-1 2-6-7-7-2-1-4 5-4z",
    fill: "#27242B"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,1067)",
    d: "m0 0h1l6 28-3-1-2-4-3-3-3-10 2-7h2z",
    fill: "#24212F"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1204,904)",
    d: "m0 0 2 1-2 6-6 4-2 4-1 3-5 1 2-5-1 1-5 2 6-8 3-3h3v-2h3v-2z",
    fill: "#201B29"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,491)",
    d: "m0 0 4 1-24 11-19 10-8 4v-3l16-8 15-8 7-3z",
    fill: "#ECD8C9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1543,1221)",
    d: "m0 0h2v7 3l2 1-2 6h-4l-1 2h-2l-1 5-3-1 3-10 3-5 1-5z",
    fill: "#1B1A24"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,384)",
    d: "m0 0h1v9l-2 1-1 7 2 7 2 6-1 4-2-4-4-1v-2h-2v-7l3-9z",
    fill: "#CFCFCE"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,1519)",
    d: "m0 0 3 1-1 1-1 11 3 13-4 1v6l-6-4-6-1 1-3 7 1 1-5 2-1v-12z",
    fill: "#C0C0BF"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,770)",
    d: "m0 0h7l4 1-1 5-6 3-5-2-7-3 2-3z",
    fill: "#040303"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,566)",
    d: "m0 0 6 1 4 3-7-1v2l5 2 7 3 3 2-5 1-8-2-6-2v-2l-3-1 2-4z",
    fill: "#221F27"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,478)",
    d: "m0 0 3 1-18 8-12 7-11 8-13 11-2-1 7-7 16-12 13-8 14-6z",
    fill: "#1F1B22"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1504,667)",
    d: "m0 0h5v3l-7 2-3 3-1 3h-4l-2 2-1-3 1-2-6-1-1 3-1-4z",
    fill: "#231F2A"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(212,713)",
    d: "m0 0 2 1-1 5-5 15-3 2-1 7h-6l1-8 3-4v4h2l3-9 2-4z",
    fill: "#242027"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,363)",
    d: "m0 0h22l10 2-4 2-1 5h-6l-3-5-8-1v-1l-10-1z",
    fill: "#25212C"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1547,777)",
    d: "m0 0h1l1 12 5 7v2l-6-2-5-5-4-9-1-4 5 3 2 6 2 1v-7h-2z",
    fill: "#201D27"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1517,701)",
    d: "m0 0 5 1-3 6-5 5-5-2-3-4 1-3h5z",
    fill: "#1C1921"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1609,1365)",
    d: "m0 0h2l1 2v12l-3 1-2-5-4-2-12 12v-3l13-13z",
    fill: "#221F28"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1321,979)",
    d: "m0 0 5 2 8 4-1 3h-25v-1l9-1 2-4h3z",
    fill: "#1F1A21"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1619,827)",
    d: "m0 0 4 2-1 6-1 1-17 1-3-1v-2l16-5h2z",
    fill: "#0B0A0C"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,1551)",
    d: "m0 0 2 1v14l-8-4-7-4 2-4 7 2z",
    fill: "#BFC0BF"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1099)",
    d: "m0 0 4 2 4 17-1 4-3 4-3-14-2-5 2-3z",
    fill: "#232029"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 784)",
    d: "m0 0h7l2 6v2h-2l-1 3-3 2h-3l-1-3v-9z",
    fill: "#FEEEDE"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1046,1309)",
    d: "m0 0h18l3 3-3 2-14 1-3-1-2-4z",
    fill: "#F9F8F8"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,1272)",
    d: "m0 0h46v2l-16 1h-12l-18-2z",
    fill: "#1F1B21"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1565,1167)",
    d: "m0 0h1v10l-6 15-1 2-6 3 2-5z",
    fill: "#28283A"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1688,914)",
    d: "m0 0 6 1-2 5-1 13-4-2-1-1v-5l-2-1v-3h2l1-6z",
    fill: "#1F1B21"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(362,850)",
    d: "m0 0 7 6 3-1-4 19h-3l-1-20z",
    fill: "#BCBCBD"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1597,835)",
    d: "m0 0 12 1h10v1l-23 4h-3l-1-2-4 1-5 1-1-4z",
    fill: "#1F1B25"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,586)",
    d: "m0 0v3l-13 13h-2l-2 4-11 11v-3l4-5 5-5h2l3-10 12-6z",
    fill: "#FEEDDD"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,580)",
    d: "m0 0 5 5 9 16 8 17 1 5-4-4-6-14-6-10-6-11-2-3z",
    fill: "#1F1A21"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,658)",
    d: "m0 0 9 3 2 1-1 3-15 2-21 1h-20v-1l46-3 4-1z",
    fill: "#A8A7A6"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(322,635)",
    d: "m0 0 1 3h4l1-3h13l4 2-12 3-2 2-8 1h-3z",
    fill: "#AFAFAF"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,573)",
    d: "m0 0 15 5 6 1v1l-7 2-1 1h-8l-4-3z",
    fill: "#201D26"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,927)",
    d: "m0 0 2 1-5 6-9 3-3 5-6-2 2-4 12-7 5-1z",
    fill: "#1B1A27"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1612,837)",
    d: "m0 0h7v1l-20 4-10 1-8 4h-5l3-1 2-6 7-1 4-1 1 3 7-2z",
    fill: "#A2A1A1"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,764)",
    d: "m0 0h3l-3 11-5 4-7 3v-3l8-4 1-4h-13l1-2 10-1v-2z",
    fill: "#632A34"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,1220)",
    d: "m0 0h6l3 4-3 1-3 7-9 1v3h-2v-2h-2v-5l5-2v3h6l1-2h-2l-1-4z",
    fill: "#181E29"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,1325)",
    d: "m0 0 23 2 28 1v1l-8 1h-30v-2l-11-1z",
    fill: "#B1B1B1"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1398,1071)",
    d: "m0 0 3 1 11 28v5l-3-3-4-10-1-6h-2l-4-11z",
    fill: "#0D0B0E"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,957)",
    d: "m0 0h6l-5 4-1 2h-2v2h-2v2l-8 1-4-1v-2h4l1-3z",
    fill: "#1B0C0E"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1759,553)",
    d: "m0 0 6 2 2 4-1 2 4 2 2 8h2l2 5-3 1-3-1-2-6-2-5-3-6h-3l-2-4z",
    fill: "#1F1A26"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1347,491)",
    d: "m0 0 3 2 1 5 2 1-2 4-5 3-3-1v-2l-3-1h2l1-7 4-1z",
    fill: "#1F1B22"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,1630)",
    d: "m0 0h8l2 4 5 4v3l-9-2-9-4z",
    fill: "#1F1A24"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,1515)",
    d: "m0 0 7 1 1 1v10l-4 1-4-2z",
    fill: "#F6F6F5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,1406)",
    d: "m0 0 2 1-2 5-1 5-3 3h-2v2h-3l-2 5-5 5 2-6 7-11z",
    fill: "#1D1921"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,746)",
    d: "m0 0 1 2 4 2 1 3-2 9-3-1-3 3-2-5z",
    fill: "#231F26"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,321)",
    d: "m0 0 1 2h8l2 1h6l4-2v2l3 3h-16l-9-1-21-1v-1l22-1z",
    fill: "#303945"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1690)",
    d: "m0 0 2 1 3 8v4l3 1-4 1-9-3 2-9z",
    fill: "#3A3740"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,970)",
    d: "m0 0 6 3 11 3 7 2 5 1v2l-3 1h-9l-10-6-6-1z",
    fill: "#1F1D33"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(181,1085)",
    d: "m0 0 5 4-1 7-1 3-4-1 1-4-2 1v7l-2 1-1-6v-5l2-1 1-4h2z",
    fill: "#1F1B21"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1229,930)",
    d: "m0 0 4 2 5 4 6 3v2l5 1 1 4h-6l-4-4-3-1-2-2-6-5z",
    fill: "#161A29"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,1557)",
    d: "m0 0 5 3 1-3h2l5 5 1-3v4h-3v2l-6 1h-4l-1 2-4-2v-2h2v-2l2-2z",
    fill: "#221F2B"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,703)",
    d: "m0 0 1 2h10l6 3 2 3-5-2-4-2-6 1-7 3-10 1 4-5z",
    fill: "#B5B4B4"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1300,453)",
    d: "m0 0 2 4 1 4-2 9h-2l1 4-2 2-4-1 2-5v-6l3-10z",
    fill: "#1F1B21"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,1090)",
    d: "m0 0h2l-1 7h3l-1 10-2 2h-2l-2 2-2-1 3-14z",
    fill: "#191C2C"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(909,795)",
    d: "m0 0 1 2h2l2 9 6 7v2l7 2 3 3-8-1-6-4-5-8-2-8z",
    fill: "#EDD7C7"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,627)",
    d: "m0 0 6 1 2 4 9 4-3 1-10-1h-7l-1-4 2-3h2z",
    fill: "#221F2B"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,1219)",
    d: "m0 0 4 4 2 4v47l-5 1-8-1v-1h9l2 1-1-8h1v-38l-1-3h-2z",
    fill: "#B4B5B4"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1611,609)",
    d: "m0 0h6l-1 5-4 5h-2v-2l-6-1v-2l-4 1v-2z",
    fill: "#0E0D0F"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1344,1440)",
    d: "m0 0 3 1 1 5-3 5-5 3-4-1 2-6 4-4z",
    fill: "#1F1B21"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,1373)",
    d: "m0 0 4 2 5 5 1 5-4-1-1 2-10-10 3-2z",
    fill: "#2C2C3F"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,1242)",
    d: "m0 0 3 1 1 4 4-2 2-2 4 1-2 3-14 3-9-1 3-1v-2h2v-2z",
    fill: "#2B3D44"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,854)",
    d: "m0 0 5 1 6 7 3 9 2 5-4-4-2-5h-2l-5-6-3-3z",
    fill: "#040303"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,768)",
    d: "m0 0 14 1 1 3v4h2v4l-5 1-2 6-3-4 2-2 2-1v-4h2l-1-2-6-1v-3l-6-1z",
    fill: "#291C29"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,1326)",
    d: "m0 0h2l7 10 4 5v3l-4-1-11-13v-3z",
    fill: "#191822"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1515,1281)",
    d: "m0 0 2 4-7 11-2 3-4 1-1-3 2-3h2l1-5 2-3h2l2-4z",
    fill: "#1A1820"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1873,847)",
    d: "m0 0h1l1 5v22h-2l-1-11-2-5-1-7 2-1v-2z",
    fill: "#1C191F"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,725)",
    d: "m0 0 5 1 3 2 16 2 1 2h-5v5l-5-1v-2l-3-1v-2l-7-2h-3z",
    fill: "#211D29"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,514)",
    d: "m0 0 6 2-1 8h-5v-2l-9-3 1-2 2 1v-2z",
    fill: "#242332"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,1293)",
    d: "m0 0 2 1-1 6-29 1h-22l1-2h15l32-1 1-4z",
    fill: "#AEADAD"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1184)",
    d: "m0 0h9l-1 4-4 4-4-1-3-1-5 3 2-4 2-3z",
    fill: "#D4D3D3"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,1169)",
    d: "m0 0 6 1 5 13h-2l-1 2-3-1-5-12z",
    fill: "#201C29"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1724,940)",
    d: "m0 0 4 1-9 5-4 3-2-2h-6l-2-1-1-5 16 1z",
    fill: "#2A272F"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,678)",
    d: "m0 0 2 3 4 11-1 3-4-3v-2l-3 1-2 2 2-9-3-1 2-4z",
    fill: "#201C26"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,662)",
    d: "m0 0 11 1-1 2-10 2-10 1h-27v-1l21-1 15-2z",
    fill: "#221F2B"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,621)",
    d: "m0 0h2v2l5-1 2 4-1 2-3 1v6l-4 1 1-3-5-5v-3h2z",
    fill: "#1F1C25"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,576)",
    d: "m0 0 5 1 4 1v2l-6 2-9 6-4-1v-2l8-4-3-2z",
    fill: "#242029"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1312,502)",
    d: "m0 0 7 2 2 2 4 1v-3l3 1h-2v2l5 1-2 3-5 2-8-5-5-3z",
    fill: "#222731"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1260,157)",
    d: "m0 0 18 4 4 1v2l5 1 7 1 8 4-1 2-13-4-7-3-15-4-6-2z",
    fill: "#1F1A21"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1134,1537)",
    d: "m0 0 2 4 3 5-1 2-2-1-2 4-2-4-4-2-1 9h-1l-1-12 4-2h4z",
    fill: "#CBCBCA"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1464)",
    d: "m0 0h4v2l5 1-3 9-1-4h-7l-3-5 4-2z",
    fill: "#232025"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,916)",
    d: "m0 0 4 1v2l7 1 2 4-13 2-2-7 2-1z",
    fill: "#2A2C44"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,639)",
    d: "m0 0 6 2 6 8 3 5v3h-6l-2-7-3-5v-2l-3-1z",
    fill: "#16141B"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1847,753)",
    d: "m0 0 3 1 4 17v10h-2l-3-13-2-7z",
    fill: "#222030"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,681)",
    d: "m0 0h5l5 13v5l-3 1-2-6-2-1-2-8z",
    fill: "#19161B"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,615)",
    d: "m0 0 2 1-1 7-4 5-2 3h-2l-2-6-3-4 1-2 1 3 5-1z",
    fill: "#211F2B"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(927,1521)",
    d: "m0 0h1v14l-1 10-4-3-1-8h2l-2-6h-3l1-2 6 1z",
    fill: "#CCCCCB"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,1410)",
    d: "m0 0 8 6 7 7 1 4-3-1-1-4-6-1-1 2-6-4v-2h3l-2-3z",
    fill: "#24273A"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,1312)",
    d: "m0 0h1v9l-1 7h-1l-1-5-4 3-3 1h-37v-1l32-1 9-2 3-4v-5z",
    fill: "#B2B2B1"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,817)",
    d: "m0 0 2 1-5 3h-2v2l-16 4h-33v-1l30-1 1-1 15-3z",
    fill: "#B28D8E"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1665,802)",
    d: "m0 0h5l2 13 2 4-5-2-4-5z",
    fill: "#1F1B21"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,775)",
    d: "m0 0 10 1 1 7-5 5-1-7-9-2-1-2z",
    fill: "#2E1F26"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,492)",
    d: "m0 0 6 1 16 10v3l4 2-2 2v-2l-4-1-2-2-3-1-4-4-11-7z",
    fill: "#1F1A25"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,439)",
    d: "m0 0 5 3v6l-2 4 1 3-6-2-1-7z",
    fill: "#221E2A"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1315,176)",
    d: "m0 0h7l5 1v3l10 1 2 1v2l8 1v3l-10-2-11-5-11-4z",
    fill: "#1F1B21"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1509,1285)",
    d: "m0 0 2 1-3 4-1 4h-2l-4 8h-2l-2 5-7 8-1-3 15-20z",
    fill: "#292B43"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,1188)",
    d: "m0 0 7 2 1 3 4 4v4l-7-2-3-3-2-4z",
    fill: "#171E2A"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,975)",
    d: "m0 0 1 2-7 2-2-1-1 2-4-2-8 1-8 2h-10l3-2 13-3z",
    fill: "#1F1D33"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,677)",
    d: "m0 0 7 2 3 3-4 3h-2l-3 1-8-5 3-2h4z",
    fill: "#201C23"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,513)",
    d: "m0 0h2v2l-7 6-7 8-16 17-2-1 12-13 7-8z",
    fill: "#1F1A23"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,1144)",
    d: "m0 0 18 6 1 5-3 1-10-6-6-4z",
    fill: "#C6C5C5"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,879)",
    d: "m0 0h3l3 6 5 2 6 9-9-1-1-4-6-7z",
    fill: "#292B43"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1523,622)",
    d: "m0 0 7 1 4 6 1 8-2-1-2-6h-7l-2-6-3-1z",
    fill: "#1E1B23"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 416)",
    d: "m0 0h1l1 6h3v3l9-2 4-3-2 4-1 1 15 1v1h-26v-2l-4 1h-7l6-3z",
    fill: "#B3B2B2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,334)",
    d: "m0 0 2 4 4 4 3 2-9 4-5 2-2 4-7-2v-1l7-1 4-4 1-3h2z",
    fill: "#1D1A22"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,1150)",
    d: "m0 0 1 3 3 1v12l-1 3h-2l-2-3v-15z",
    fill: "#1B1A27"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,1082)",
    d: "m0 0h1l2 20v6l-2-1-1-6h-3v-12l3-1z",
    fill: "#221F2E"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1552,819)",
    d: "m0 0h1l1 10h3l1 8h6v2h-4l2 5 2 3-4-1-2-4-3-1-3-12z",
    fill: "#2C2E43"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1164,436)",
    d: "m0 0 1 3 6-1 3 2-1 4 1 2-10-1-3-1 1-6z",
    fill: "#252330"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,327)",
    d: "m0 0 2 3v6l2 1-9-1-28-4 3-3 16 3 11 1 3-2z",
    fill: "#C1C0C0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,825)",
    d: "m0 0 2 2v3l6 2 4 5-6 1-8-5-1-5z",
    fill: "#231E2A"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,804)",
    d: "m0 0 1 3-5 10-5 8-4 8-3 3 1-4 3-9 2-5 5-5z",
    fill: "#EED7C7"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,690)",
    d: "m0 0 4 1-11 4h-37v-1l38-3z",
    fill: "#C6BBB4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,662)",
    d: "m0 0h1l-1 10-1 3h-2v4l-4 1-1 5-2-1 3-8-2-1h3l2-7z",
    fill: "#292B43"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,132)",
    d: "m0 0h45v1l-25 1-11 1h-9l-2-2z",
    fill: "#22202D"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1625)",
    d: "m0 0 2 1-1 3 1 7 4 2h-3l-3-2-2 8-1 11h-1v-12l1-11 1-3h-6v-1l7-2z",
    fill: "#B6B6B5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,1496)",
    d: "m0 0h7l5 3 8 6-4 3-5-4v-2l-9-3z",
    fill: "#1F1B24"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,1206)",
    d: "m0 0h2l4 8v5l-6-2h-2l-2-5v-3l2-1z",
    fill: "#18151D"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1854,783)",
    d: "m0 0h2l2 5 2 10 1 1v10h-2l-3-10z",
    fill: "#26263A"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1025,307)",
    d: "m0 0h13v4l4 1-1 4-4-1-2-3-3 1-4-3v-2z",
    fill: "#1F1B23"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,1428)",
    d: "m0 0 6 2-2 5-5 2h-6l2-5h2l1-3z",
    fill: "#292A41"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,914)",
    d: "m0 0h1v5l-6 5-7 1-2-3 13-7z",
    fill: "#161B2A"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,569)",
    d: "m0 0 12 1 3 1v2h2l1 3h-10l-8-5z",
    fill: "#0E0D0F"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1249,457)",
    d: "m0 0 2 2h-2l2 7 1-3 3-3-1 10-7 2-3-3 1-4h2l1-7z",
    fill: "#1F1A21"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,387)",
    d: "m0 0 3 1-1 2 4-1 1 2v10l-4-4-2-4-4-1-3 2 1-5z",
    fill: "#B5B5B4"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1682,1514)",
    d: "m0 0 3 3-2 4-7 8-1-3v-2-4h2l2-4z",
    fill: "#232028"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,1477)",
    d: "m0 0 7 1 19 5 17 3v1l-24-2-7-3h-5l-7-4z",
    fill: "#B6B7B6"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(197,760)",
    d: "m0 0 2 1v7l-2 2v-2l-7 5-1-4 3-8 3 1z",
    fill: "#201C27"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1348,515)",
    d: "m0 0 11 7 7 5-1 2h-3v-2l-6 1-5 2-2-2v-3h4 3l-8-8z",
    fill: "#29262F"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,473)",
    d: "m0 0 3 2 1 3-2 4-6 3-4-1 2-5 5-5z",
    fill: "#1F1A22"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,1237)",
    d: "m0 0h2l-1 5-1 2h2l-2 4-5 5-1-2-3-1 6-9 1-2h2z",
    fill: "#1C1F2F"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,786)",
    d: "m0 0h3v5l5 2 4 4-8 2-1-3h-3z",
    fill: "#262432"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 754)",
    d: "m0 0 40 1v1l-33 1-11 2-4-1 1-2z",
    fill: "#97333C"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1349,188)",
    d: "m0 0 9 2v2l7 1 6 4 9 4 1 2-10-3-22-10z",
    fill: "#1F1B21"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,1292)",
    d: "m0 0h4l-1 4-7 8-6 2 2-6 3-1 1-3z",
    fill: "#1F1B24"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,747)",
    d: "m0 0 4 2 5 5 3 7 1 3-2 3v7h-1l-3-15v-3h-2l-2-5h-4v-3z",
    fill: "#201C25"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1308,461)",
    d: "m0 0h1l1 14-3 5h-2l1 4h-3v-8l4-8z",
    fill: "#BBBBBA"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1075,455)",
    d: "m0 0h17l10 2v2l-17-1-16-1v-1z",
    fill: "#E5D1C3"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1124)",
    d: "m0 0 3 1-1 3h2v5l-2 5-4-2-2-7 1-3z",
    fill: "#161A29"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,1086)",
    d: "m0 0 2 3 2 1 1 4 2 1 1 5-1 1-1 4-2-1-1-8-2-1-2 3-1-2v-7h2z",
    fill: "#1F1A26"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1027)",
    d: "m0 0 5 1 3 7 2 11-2 1-3-13-2-4-3-1 1 9 2 5-1 6h-1l-2-10v-11z",
    fill: "#262635"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,914)",
    d: "m0 0 2 1-2 3-12 6-2 3-6 3-3-1 4-4 15-9z",
    fill: "#1E1A25"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,751)",
    d: "m0 0h2l-1 6-4 7-2 3-1-2-3 1h-16v-1l16-2 3-2 4-4z",
    fill: "#AFAEAE"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,528)",
    d: "m0 0 2 4 3 7 3 4-9 1-2-6 2-5z",
    fill: "#C3C3C2"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1525)",
    d: "m0 0 1 4v6l2 2h2v6l-6-2-8-3 4-3 3-3z",
    fill: "#B4B3B3"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(516,1258)",
    d: "m0 0 4 3 4 7 2 4-3 3-9-14v-2z",
    fill: "#242028"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,833)",
    d: "m0 0 2 3v5l4 1 2 4 3 1h12l-1 2-3 1h-8l-7-3-4-8z",
    fill: "#A5A5A5"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1206,780)",
    d: "m0 0 3 1 3 6-5 10h-1l-1-11-2-4z",
    fill: "#1F1A27"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,757)",
    d: "m0 0h3v2l24 3 17 1v1h-18l-19-1-4 1 1-3-5-2z",
    fill: "#E64145"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,469)",
    d: "m0 0h1l2 7 4 2-5 3-1 4-1-3-4-2v-2l-2-1h3l1-4z",
    fill: "#302D35"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1696)",
    d: "m0 0h1l1 16 1 4-5-2-6-1 2-5 5-2z",
    fill: "#221F2A"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,1198)",
    d: "m0 0h6l3 6-2 6-5-2-1-4-2-5z",
    fill: "#19151E"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,1078)",
    d: "m0 0 2 3 2 8h-2v7l-2 1-3-13v-4h2z",
    fill: "#201D26"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1389 1e3)",
    d: "m0 0h1l4 42h-3l-2-26z",
    fill: "#ACABAB"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,445)",
    d: "m0 0h21l1 2-17 1-6 2-4 2v-4z",
    fill: "#D4C7C0"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(927,1535)",
    d: "m0 0h1v21l-3-4-2 2-1-11 4-3z",
    fill: "#AFAFAE"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1523)",
    d: "m0 0h1l2 15-9 4h-2-5v-3h-6v-1h14l4-1z",
    fill: "#B4B3B3"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,1321)",
    d: "m0 0h1l2 30 2 12-4-2-3-4h2z",
    fill: "#2A2C44"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1195,908)",
    d: "m0 0 3 2-5 3-9 11h-2l-2 4h-2v2l-5 4-2-1 5-5 4-5 6-5 7-9z",
    fill: "#242234"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,826)",
    d: "m0 0h1v12l2 10v4h2v5l-3-4-4-10v-12z",
    fill: "#7D7B7D"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1599,770)",
    d: "m0 0 3 4 1 4-4 1-3 3-4-1v-2l-4-2 1-3 5 5v-4h2l2-4z",
    fill: "#211D26"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,717)",
    d: "m0 0 17 2h9l14-2-1 5-1-2-4 1h-22l-12-3z",
    fill: "#B9B9B9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1757,560)",
    d: "m0 0 2 1 5 10 6 10 5 8v3h-2l-15-27z",
    fill: "#0C0A0D"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1552)",
    d: "m0 0 1 4 1 2 3 1-5 2-1 2h-2v2h-7v-2l4-4h3l1-4z",
    fill: "#B4B3B3"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,1539)",
    d: "m0 0h3l1 5h12v2h-8l-19-2 2-1v-2l3 1 4 1 1-3z",
    fill: "#C3C3C2"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,701)",
    d: "m0 0 5 1v3l-2 1-1 3v2l-1 2-5-5-3-2h2l1-3 2-1 2 1z",
    fill: "#232029"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1511,645)",
    d: "m0 0 3 1-2 4-8 4h-6v-2l7-4 4-2z",
    fill: "#09080B"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,583)",
    d: "m0 0 2 1-8 8-3 4h-4v2h-7l-8-4 3-1 8 2 5-1 3-1 7-8z",
    fill: "#B4B4B3"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,465)",
    d: "m0 0h8l8 1 7-1-4 2-5 2 2 3-9-2-5-2-2-1z",
    fill: "#B2B2B2"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1402,1642)",
    d: "m0 0 2 1 1 2-14 7-13-1v-1l17-4 6-3z",
    fill: "#24222C"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,1466)",
    d: "m0 0h6v4l-10 1 1 5-3-3-4-2 3-3z",
    fill: "#22202B"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1619,1445)",
    d: "m0 0 8 3 14 7 3 2-2 1-6-1v-2l-6-1-2-1v-2l-7-2-3-3z",
    fill: "#28252B"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,1232)",
    d: "m0 0h2l-1 8-3 3h-3l-2-5 2-4z",
    fill: "#1E1A21"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1856,1141)",
    d: "m0 0 2 1-2 5-3 1 2 1-1 8-2 4v2h-2l-1 2 1-8 3-14z",
    fill: "#25222A"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1870,829)",
    d: "m0 0h1l3 18-3 1-1-2h-3l1-5v-7z",
    fill: "#1F1B24"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1647)",
    d: "m0 0 8 3 7 1v2h6l-3 1 2 5-5-2-5-3-4-1v-2l-7-2z",
    fill: "#474654"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388,1344)",
    d: "m0 0h4l-2 5-10 9-3-1 4-6h2l1-3z",
    fill: "#100E0F"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,1241)",
    d: "m0 0 2 4 2 6h3l2 4v5h-2l-5-7-4-7-1-3z",
    fill: "#25212B"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1029,780)",
    d: "m0 0 9 3 2 4 3 1-1 2-3-2v-2h-13l-4 4-1-2h2l2-4z",
    fill: "#E0C7BA"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1613,560)",
    d: "m0 0 1 2 4 1v7l-5-1-5-3 1-3z",
    fill: "#9D9B9C"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,1575)",
    d: "m0 0 5 2 8 8 2 5-4-1-5-5-4-5z",
    fill: "#1F1A24"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1542)",
    d: "m0 0 1 4h2l1-2h2v11l-5-2-4-3 2-3z",
    fill: "#B7B7B7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,1306)",
    d: "m0 0 5 1 4 5v3h-5-3l-1-4v-2z",
    fill: "#1C1923"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,955)",
    d: "m0 0m-2 1 2 1-1 1 2 1-2 7-5 1-3-1v-6l5-1z",
    fill: "#1F1A22"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,516)",
    d: "m0 0h6l2 1v2l5 1 4 2v2h5l1-4v5l-4 1-5-2v-2l-7-1-1-2h-14l1-2z",
    fill: "#A8A7A7"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,506)",
    d: "m0 0 9 3 8 4 12 7v2l-5-2-24-12z",
    fill: "#F2DCCC"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,492)",
    d: "m0 0 7 1 8 7-1 2-2-1-2 2-5-3-2-4v-2z",
    fill: "#232029"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,425)",
    d: "m0 0 2 3 16-1 1-2 5 2-2 2-4 1-22 1 4-2z",
    fill: "#BDBDBC"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,1553)",
    d: "m0 0v3l-1 3-3 1-2 3h-2v2h6v1h-11l-2-1v-2l5-1 2-4 6-3z",
    fill: "#282937"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,1514)",
    d: "m0 0 3 1h-2v13h3l2 3v3h-2l1 8-1-3h-2l-2-8z",
    fill: "#ADADAC"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,1301)",
    d: "m0 0h16l-4 2-7 1-4 15h-1z",
    fill: "#F5DECE"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,1274)",
    d: "m0 0 7 2 1 6v2l-1 4-8-11z",
    fill: "#1C1C29"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1047)",
    d: "m0 0 2 4 3 13-1 4-2-3-3 4z",
    fill: "#232030"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,773)",
    d: "m0 0h4l2 10-10-2 1-4z",
    fill: "#5C3144"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,758)",
    d: "m0 0 3 2-1 14 4-1-3 3-4-1 1-6-2-1-1-2z",
    fill: "#2A2C44"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,635)",
    d: "m0 0 4 3-6 1v5l-3 1-1 2v-3-3l-9 9 2-5 3-5z",
    fill: "#B8B8B7"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,1652)",
    d: "m0 0 2 1-2 3 3 1-1 5-6-2-3-3v-3z",
    fill: "#1D1A21"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1350,987)",
    d: "m0 0 11 1 10 2v2l-12-1-13-1z",
    fill: "#E9D4C5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,985)",
    d: "m0 0m-4 0 4 1 16 1v1h-39l-6-1v-1h23z",
    fill: "#273942"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 773)",
    d: "m0 0h6l-2 5v2l2 2-1 3-10-9 1-2z",
    fill: "#4A2732"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,468)",
    d: "m0 0 3 1-2 4 1 5-5 1v-3h-6l4-4z",
    fill: "#1F1B23"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1231,396)",
    d: "m0 0 4 1 2 3-1 4-6 4v-4h-2l1-4h2z",
    fill: "#312F3A"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1320,1623)",
    d: "m0 0 1 4 4 6-1 3 1 3-6-3-2-9z",
    fill: "#272533"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1086)",
    d: "m0 0h1l1 11 4 2h-3l1 4h-3l-1-1-1 5h-1l1-18z",
    fill: "#201D27"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1232,788)",
    d: "m0 0 6 5 3 8-1 5h-2v-3h-3v-5l-1-5z",
    fill: "#1F1A26"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1480,619)",
    d: "m0 0 1 3 2 1-4 5h-2l-1 3-4-4 2-4z",
    fill: "#221F27"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,578)",
    d: "m0 0 7 1 13 2 3 3h-2v2l-6-2-1 5-2 1 1-5 1-2-10-2z",
    fill: "#201D27"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,542)",
    d: "m0 0 2 1-2 1zm-1 2 2 2-16 12-3 1 2-4 6-5h2l1-3h3v-2z",
    fill: "#EAD5C6"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,531)",
    d: "m0 0m-1 1 2 2-11 7-6 4-2-1 1-3 4-3h4l1-3z",
    fill: "#F7E0CE"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,480)",
    d: "m0 0 2 1-9 10h-3l-2-3-5-1 2-3 8 1 6-4z",
    fill: "#2C3842"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,1290)",
    d: "m0 0 5 5 7 11-5 1-4-7v-2l-2-2z",
    fill: "#27232C"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1745,899)",
    d: "m0 0h1l1 30 2 4-1 1h-5l-1-3 2-4z",
    fill: "#AFAFAE"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,797)",
    d: "m0 0h2l2 3 3 2h-6l-7 1-6 4-2 3 1-5 5-5 6-2z",
    fill: "#C2C2C1"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058,793)",
    d: "m0 0 5 1 8 6-1 2h-5l-6-4z",
    fill: "#FFEFDF"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,429)",
    d: "m0 0h2v2l4-1-1 4-4 7-4-2 1-5 3-1z",
    fill: "#0B0A0C"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1359,336)",
    d: "m0 0h1l2 11h-3l-2 4-3-1 1-6z",
    fill: "#343341"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1189,1517)",
    d: "m0 0 9 1 1 1v16h-1l-1-11-5-4v3l-3-1z",
    fill: "#D1D1D0"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,1381)",
    d: "m0 0 7 5-1 5h-4l-5-5v-2l3-1z",
    fill: "#191927"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1372,1344)",
    d: "m0 0h1v15l-1 5 2 1-4 4h-2l-1-4 3-6z",
    fill: "#B7B8B7"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1555,794)",
    d: "m0 0 5 5 1 5h12v1l-12 3h-4l-1-10z",
    fill: "#C1C1C1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1417,564)",
    d: "m0 0h2l2 2 6-2-1 2-3 1-4 4h-6l-3-2v-2l6-2z",
    fill: "#BDBCBC"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1421,225)",
    d: "m0 0h5l5 3 8 4 8 5v2l-5-2-10-5-8-5z",
    fill: "#1F1B21"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1158,1529)",
    d: "m0 0h5l2 3v4l-6 1-3-4z",
    fill: "#B6B7B6"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1719,1469)",
    d: "m0 0 3 1-6 9-6 8h-1v-5l3-3 3-6 4-1z",
    fill: "#29262F"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1523,1267)",
    d: "m0 0 4 2-8 13-2 2-2-4 1-2h3l1-7z",
    fill: "#252229"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,1186)",
    d: "m0 0 4 1-4 2-3 2 2-4zm-5 5 2 1v2l7-2-1 4-1 3h2v2l-4-2-6-4z",
    fill: "#304545"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,435)",
    d: "m0 0 6 1 10 8v1h-5v-3l-5-2 1 4-7-2v-1h5v-2l-7-2z",
    fill: "#27232E"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1655,413)",
    d: "m0 0 4 1 8 8-1 2-3-2-1 2-6-5-2-2z",
    fill: "#1F1A26"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,334)",
    d: "m0 0h6l1 3-12 5-2-1 1-2h2l-1-3z",
    fill: "#0D0C0E"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1673,872)",
    d: "m0 0 14 1v1l-13 2-1 3 1 4-5-4 1-5z",
    fill: "#25222E"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(890,782)",
    d: "m0 0h3l1 12h-4l-1-1v-10z",
    fill: "#FEFDFD"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,660)",
    d: "m0 0h3l1 3-10 4-6 1 3-5z",
    fill: "#282632"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1400,563)",
    d: "m0 0 5 2 8 5h6 3l-5 4h-5l-2-3-7-4-3-2z",
    fill: "#23202B"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1774,1373)",
    d: "m0 0 3 1-3 8-3 5-3 1-1-3z",
    fill: "#1F1A24"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,1301)",
    d: "m0 0 1 4-4 12-4 5-3 7h-2l2-6 5-10z",
    fill: "#1F1A25"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1100,1259)",
    d: "m0 0 1 4v5l1 2-1 3 3 1h-8v-3-3l2-5z",
    fill: "#A6A5A5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(934,1234)",
    d: "m0 0 3 3 3 11v6l-3-3-3-10z",
    fill: "#BFBFBE"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,508)",
    d: "m0 0 4 1 2 4 3 1-4 2-5 2-2-5h1z",
    fill: "#1F1B22"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,245)",
    d: "m0 0h1v38h-1v-11l-4-1h3l-1-19z",
    fill: "#C1C1C0"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,1610)",
    d: "m0 0 16 4h2l-1 4-2-2-16-1z",
    fill: "#2E2B31"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,1475)",
    d: "m0 0 1 3-16 5h-4l1-3z",
    fill: "#B2B1B1"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,1464)",
    d: "m0 0 7 3 5 3 1 6-2 1v-2h-2v-3l-5-2-4-4z",
    fill: "#F4F3F3"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1425,1382)",
    d: "m0 0 1 3 2-1-2 4h-2l-3 6h-4l2-8 5-3z",
    fill: "#1D1C31"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,1046)",
    d: "m0 0 2 3 4 18h-3l-2-9v-4h-2v-7z",
    fill: "#23202D"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,961)",
    d: "m0 0h3l-2 6-7 3-2-1 1-4z",
    fill: "#1F1B21"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1208,915)",
    d: "m0 0 11 6 9 6-2 1-12-6-9-4 3-1z",
    fill: "#1F1B26"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(885,836)",
    d: "m0 0 10 5 2 4 5 2v3l-12-7-5-5z",
    fill: "#F7DDCB"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(894,772)",
    d: "m0 0h2l3 8h5l2-1 3 1-1 2-4 2h-3-3v6h-1l-2-15z",
    fill: "#1F1A21"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1676,644)",
    d: "m0 0h4l-2 5-1-3-6 1 1 5-3 7h-2l1-12z",
    fill: "#87878A"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,441)",
    d: "m0 0 2 4 1 11h-2l-1-5v6l-5 6-1-3 3-4 2-10z",
    fill: "#C3C4C3"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1308,433)",
    d: "m0 0 9 1h6l1 2h-6l-6 4-2 3-6-1v-1h6l-1-5z",
    fill: "#B8B8B7"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,309)",
    d: "m0 0 4 2h1 3l7 6-4 3-11-9z",
    fill: "#0F0E11"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,1502)",
    d: "m0 0 1 4v11l-1 1 2 2-6 4 1-9z",
    fill: "#B6B6B5"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1332,1418)",
    d: "m0 0 4 1 3 7-4 2v-3h-5l-2 1 1-4z",
    fill: "#111518"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,1408)",
    d: "m0 0 2 1-3 6-8 7-3-1 6-7h2l2-5z",
    fill: "#1F2233"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1541,1221)",
    d: "m0 0 1 3-3 9-2 4h-3l-1 5h-3l1-4h2l2-5z",
    fill: "#323144"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,809)",
    d: "m0 0 1 2-2 3 8-1-4 4-9 3 1-4v-3z",
    fill: "#472832"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1242,405)",
    d: "m0 0 5 1v3l-4 5h-3l-1-6z",
    fill: "#22202E"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,1578)",
    d: "m0 0 7 6 3 3-2 4-10-10 2-1z",
    fill: "#161317"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,1143)",
    d: "m0 0 4 4 2 5-1 4h-3l-4-8v-2h2z",
    fill: "#1F1A25"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1556,814)",
    d: "m0 0 2 4 1 5-4 1v5l-2-2v-10z",
    fill: "#222030"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,439)",
    d: "m0 0h9l-6 7-13-1v-1l8-1z",
    fill: "#C3C2C2"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,429)",
    d: "m0 0 2 4-2 2-11-1-3 1h-8v-1l10-2 8-2 3 1z",
    fill: "#211E29"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,1471)",
    d: "m0 0 9 1v1h-7l-1 4-2 2-2 4v-4l-6-2 5-5v3l3 1z",
    fill: "#BBBABA"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1718,1462)",
    d: "m0 0 2 1-8 12-6 6h-2v-2l5-5 7-10z",
    fill: "#1F1A22"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,1416)",
    d: "m0 0h3l-2 4-5 8-1-2-3-1 1-3h2v-2z",
    fill: "#29262F"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,1365)",
    d: "m0 0 4 1 6 5h3l-2 5-5-2-6-7z",
    fill: "#1B1923"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1808,1315)",
    d: "m0 0h3l-2 7-5 10h-3l2-5z",
    fill: "#211D29"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(995,1234)",
    d: "m0 0h3v2l3 1-3 1 2 6-3-2h-4l-2 2-1-7 4 2z",
    fill: "#B3B4B3"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1736,906)",
    d: "m0 0 3 1v12l-1 3-2-1-1-5v-9z",
    fill: "#1F1B21"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1579,840)",
    d: "m0 0h2l-1 4-1 2-7 2-4-1 7-6z",
    fill: "#292B42"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1615,812)",
    d: "m0 0 3 4 3 7v2h2v4h-4-1l-2-12-1-3-2-1z",
    fill: "#403E4A"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,793)",
    d: "m0 0 9 3 2 7 2 4-2 1v-2l-3-1v-2l-3-3-3-4-2-1z",
    fill: "#040303"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,772)",
    d: "m0 0h12v2l-2 1-2 3-5 1v-4l-4-1z",
    fill: "#1F1A23"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,758)",
    d: "m0 0 11 1v1l-23 2v-3z",
    fill: "#492530"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,721)",
    d: "m0 0 4 1-1 5-1 1h-6l-2-1v-3z",
    fill: "#2B2932"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(322,635)",
    d: "m0 0 1 3h4l1-3h7v1l-6 2-2 5h-7z",
    fill: "#A09F9F"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,629)",
    d: "m0 0 1 3-12 14-2-2 8-10z",
    fill: "#E9D5C7"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,1522)",
    d: "m0 0h1l1 17 4 1-2 1-3-1-1 2-1-3-9-4 2-1 7 1z",
    fill: "#2B2932"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,1291)",
    d: "m0 0 5 1v2l3 1 8 11-2 2-12-14z",
    fill: "#25222B"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,1146)",
    d: "m0 0h5l-4 3-8 5-5 5-3-1 7-8z",
    fill: "#2B3744"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(169,1006)",
    d: "m0 0 5 2-2 14h-1v-5h-2l-2-3 1-5z",
    fill: "#292A42"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1122,915)",
    d: "m0 0 1 3-4 6-15 14-2-1 12-12 5-4z",
    fill: "#61282E"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1204,906)",
    d: "m0 0 1 4-7 5-2 4-1 3-5 1 2-5 3-1 2-4 6-5z",
    fill: "#1F1B22"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1574,837)",
    d: "m0 0h6l-4 1v2l-6 2-2 2-4-1-1-2 2-1v-2z",
    fill: "#211D2C"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,790)",
    d: "m0 0 2 2-1 18h-1l-3-16 1-3 1 1z",
    fill: "#060506"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1524,702)",
    d: "m0 0 2 1-9 9-2 7h-2l-3-6-2-1 1-2 5 2 6-7z",
    fill: "#BCBBBB"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,705)",
    d: "m0 0h4l1 3 4 4-4 3-4-2z",
    fill: "#040303"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(735,442)",
    d: "m0 0 9 2v1l-21 1-5 2 4-4z",
    fill: "#22202D"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(982,767)",
    d: "m0 0h6l-3 2 12 3v2h2l4 6-4-2-3-3v-2l-9-1-7-3z",
    fill: "#AD9E9F"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,665)",
    d: "m0 0h16v3h-15z",
    fill: "#201D25"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,485)",
    d: "m0 0 3 4-2 4-13 1 2-4h2v2l4-2z",
    fill: "#BDBDBC"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1301,373)",
    d: "m0 0h5l1 9h-5l1 2-4-1v-4h3l1-3-3-1z",
    fill: "#221F29"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1471,1222)",
    d: "m0 0 2 2 1 3 3 1-2 7h-4z",
    fill: "#201D26"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1864,796)",
    d: "m0 0h1l2 10-1 7-3-3v-12z",
    fill: "#231F26"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1610,675)",
    d: "m0 0 8 1-4 5-6 2-2-3 2-1z",
    fill: "#211F2A"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,673)",
    d: "m0 0 6 2 13 8 2 2-3 1-5-4h-6v-4h-2l-1-2-4-2z",
    fill: "#2B2833"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,640)",
    d: "m0 0 1 2v4l1 6h2v2l7-1-2 2h-5l-1 2-2-3v-3h-2l-2-4v-3h2z",
    fill: "#9C9C9E"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,543)",
    d: "m0 0h3l5 1 1 4-6 5-2-6z",
    fill: "#49444E"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1247,456)",
    d: "m0 0h1l-1 9-2 1v4h-3v-7l3-6z",
    fill: "#080709"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,387)",
    d: "m0 0h4v6l-9 1 1-4 1-2z",
    fill: "#0A090B"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,364)",
    d: "m0 0 11 1-4 2-1 5h-4z",
    fill: "#211D24"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,1112)",
    d: "m0 0 3 1 1 8-4 5-1-5v-8z",
    fill: "#211D2A"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,877)",
    d: "m0 0 5 3 2 6 5 5 1 2-4-1-8-10z",
    fill: "#211E2B"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,578)",
    d: "m0 0 2 2-9 17-1-4 5-11z",
    fill: "#221F27"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,493)",
    d: "m0 0 3 1h4l1 4-3 3h-3l-3-3v-2l-4-1h5z",
    fill: "#898788"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,1230)",
    d: "m0 0 1 2 6 2 3 3-1 2h-2l-1 2-3-1-3-7z",
    fill: "#252433"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,796)",
    d: "m0 0 4 5 4 7v12h-1l-1-11-3-1-2-5z",
    fill: "#3E3B43"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,669)",
    d: "m0 0h2l4 9-1 4-2-1v-2h-2l-2-9z",
    fill: "#201F35"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,572)",
    d: "m0 0 10 4 3 2-5 1-8-2-2-3z",
    fill: "#201C26"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,544)",
    d: "m0 0 4 1 12 8 6 5-1 2-11-8-10-7z",
    fill: "#EAD7C9"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1307,499)",
    d: "m0 0 9 1 8 6-3 1-5-3-4-1-2 1-3-3z",
    fill: "#232935"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,138)",
    d: "m0 0 8 1-2 2-16 2 1-3z",
    fill: "#1E1B23"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,1436)",
    d: "m0 0h5l2 2 9 3 2 4-7-2-11-6z",
    fill: "#C3C3C2"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1341,1413)",
    d: "m0 0h2l2 7-1 4-4-1-1-3z",
    fill: "#3F4C51"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,1320)",
    d: "m0 0 8 6 3 5-1 3-5-6v-2l-5 2-2-3 4 1-2-3z",
    fill: "#28283C"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1185)",
    d: "m0 0h4l-1 5-2 4-6 3 2-5z",
    fill: "#2D2E3C"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1871,877)",
    d: "m0 0 3 3-1 17-2-4z",
    fill: "#1F1A25"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1591,836)",
    d: "m0 0h6l-1 5h-3l-1-2-4 1-5 1-1-4z",
    fill: "#22202D"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(212,713)",
    d: "m0 0 2 1-1 5-4 12h-3l2-6 2-7z",
    fill: "#1F1A21"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1506,694)",
    d: "m0 0h7l-1 2h-6v2l2 1-1 3-4-1-2-5z",
    fill: "#1F1C25"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1366,528)",
    d: "m0 0 9 6 5 3 3-2-1 5-7-2-5-4-4-4z",
    fill: "#27242F"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,369)",
    d: "m0 0 2 1-8 8 4 3 1 5-8-5 2-5z",
    fill: "#23212B"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1351,1660)",
    d: "m0 0 2 2 17 1v1l-18 1-4 2h-8v-1l7-2 4-1z",
    fill: "#ABABAA"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(887,1544)",
    d: "m0 0 1 3h3l-1 9-4-2v-9z",
    fill: "#CBCBCA"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1051,1212)",
    d: "m0 0 4 1v2h-2l-2 4v3l-1 2-6-4 4-1 2-4z",
    fill: "#2B3144"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,838)",
    d: "m0 0 10 1 7 2-3 1v2l-10-3-4-1z",
    fill: "#292633"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,817)",
    d: "m0 0h2l-1 3h-2v2h-3v-2h-16v-1z",
    fill: "#A5A4A4"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1606,786)",
    d: "m0 0 2 2 1 6-6 5-3-1 4-2-1-7 3 1z",
    fill: "#9F9E9E"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,413)",
    d: "m0 0h1l1 9h1l1 9 2 4h-5l-1-11z",
    fill: "#2A2730"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,406)",
    d: "m0 0 7 1 7 2h11l2 4-2 1-1-3h-13l-8-2v-2z",
    fill: "#262532"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1085,1695)",
    d: "m0 0 9 1 1 3 5 2v1l-11 1 1-2h2l-1-3-6-2z",
    fill: "#211F2B"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,1676)",
    d: "m0 0 6 4 4 1v2l9 1v1l-7 1-11-5z",
    fill: "#2D2B37"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,1667)",
    d: "m0 0h21l-5 5-2 1-3-3-11-1z",
    fill: "#42414C"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,1645)",
    d: "m0 0h5l5 3 6 2v2l-7-1-3-2-6-2z",
    fill: "#1F1B21"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,1629)",
    d: "m0 0h5l-1 14-1 11h-1v-16l1-5h-2z",
    fill: "#22202D"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1625,1581)",
    d: "m0 0 3 1-13 13h-2v-2h2v-3l4-1v-3l4-1v-3z",
    fill: "#3A373D"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,1538)",
    d: "m0 0 2 2 9 2v1l-7 1-3 2h-3l1-6z",
    fill: "#211E27"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1341,1424)",
    d: "m0 0 6 3 2 2-1 5h-5l1-4-5-2z",
    fill: "#1B1C27"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1794,1348)",
    d: "m0 0h2l-2 5-5 10-2-1 1-5z",
    fill: "#26222A"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1437,1154)",
    d: "m0 0h2l10 19-1 2-4-5-7-14z",
    fill: "#1F1A24"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,1142)",
    d: "m0 0 1 2-1 4 1 4h-2l1 3-5 1 2-11z",
    fill: "#1A1B2B"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1394,1064)",
    d: "m0 0 5 3 1 5-3 3-4-4z",
    fill: "#1E1A20"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,555)",
    d: "m0 0 1 4v3l-5 7-3-1v-2l-2-1 5-2 1-4 2-1z",
    fill: "#A1A1A1"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1667,429)",
    d: "m0 0 5 5 2 6h2l1 3-6-2-2-5-3-3z",
    fill: "#1F1A26"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,1502)",
    d: "m0 0h10v1l-6 1-1 5-5 1v-7z",
    fill: "#C4C4C3"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,1264)",
    d: "m0 0h4v3h-2l3 6h-3v3h-4l1-4 1-5z",
    fill: "#0E0B0F"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,1078)",
    d: "m0 0 3 1v3l3 1v4h-2l-1 4-2-3v-2z",
    fill: "#1F1A27"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(180,1054)",
    d: "m0 0h2l1 14-2 4-2-4v-9z",
    fill: "#282534"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,747)",
    d: "m0 0 15 2-3 2h-14l-1-2h3z",
    fill: "#1F1B23"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,590)",
    d: "m0 0h5l1 2-6 1-3 3-13-4 4-1 10 2v-2z",
    fill: "#26232F"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1532,557)",
    d: "m0 0 4 1-2 6 10 1v1h-8l-1 2-6-9z",
    fill: "#2B2936"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,521)",
    d: "m0 0h2l1 10-3-1v-2l-5-1v-2l4-1z",
    fill: "#201C24"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(260,1333)",
    d: "m0 0h2l7 15-1 2-1-3h-2l-2-8h-2z",
    fill: "#0F0E13"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1298)",
    d: "m0 0 4 2h2v2l4-1 7 2v1l-18-1-3-3z",
    fill: "#B6B7B6"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1143,890)",
    d: "m0 0h2l-1 6-3 1-1 4-3-1 2-5z",
    fill: "#040303"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1158,864)",
    d: "m0 0h3l-1 5-5 6-2-3z",
    fill: "#040303"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,648)",
    d: "m0 0 2 1-8 10-2 3h-2l-1 3-1-2 10-13z",
    fill: "#D9CDC5"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1572,335)",
    d: "m0 0 4 4 4 2v3l1 2-4-1-7-6v-2h2z",
    fill: "#0D0C0D"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,1634)",
    d: "m0 0 6 4v3l-9-2v-4z",
    fill: "#171419"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,1529)",
    d: "m0 0 10 2 2 2-5 1-3 2-3-3v-2l-2-1z",
    fill: "#A6A6A5"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1119,1327)",
    d: "m0 0h3v2l-2 1h-18l4-2z",
    fill: "#2A2C44"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1481,1323)",
    d: "m0 0 1 2-1 3h4l-2 5-4-3v2l-4 1 3-7z",
    fill: "#242337"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1547,790)",
    d: "m0 0 4 1 3 5v2l-6-2-3-2v-3z",
    fill: "#22202D"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,766)",
    d: "m0 0 5 1v3l2 1-4 1-7-2v-2z",
    fill: "#1D191F"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(956,760)",
    d: "m0 0h15v2l-4 1h-7l-5-1z",
    fill: "#211D2B"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1842,734)",
    d: "m0 0 3 3v4 6l3 1-5-1-3-10z",
    fill: "#27273B"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1731,659)",
    d: "m0 0 3 4 1 7-1 1-1 8h-1z",
    fill: "#ADACAC"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,639)",
    d: "m0 0 6 2 5 6v1h-5l-2-5-3-1z",
    fill: "#26242D"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,620)",
    d: "m0 0 4 2v7l-3 4-2-1 1-8z",
    fill: "#040303"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,604)",
    d: "m0 0 2 1-7 8-4 3-1-4 5-5z",
    fill: "#231F29"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1630,544)",
    d: "m0 0 2 1-15 15-1 2h-2l1-4 8-7z",
    fill: "#CBCAC9"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(698,485)",
    d: "m0 0h1v8l-9 1 2-5 6-1z",
    fill: "#9F8B8D"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,478)",
    d: "m0 0 7 6-6 7-3 2 4-10z",
    fill: "#BEBEBD"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,454)",
    d: "m0 0h1l1 7-1 6h-3l-1-2v-6z",
    fill: "#232233"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 416)",
    d: "m0 0h1l1 6h3v3l4 1-5 1v-2l-4 1h-7l6-3z",
    fill: "#BEBEBD"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,314)",
    d: "m0 0 1 2-1 7h-3v-3h-5l3-5z",
    fill: "#201D27"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,1557)",
    d: "m0 0 5 5-2 1v3h-2l-1 2-4-2v-2h2v-2l2-2z",
    fill: "#211E2A"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,1553)",
    d: "m0 0 3 4 1 5-4-2-1-3h-2l-1 3v-6z",
    fill: "#878686"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,1231)",
    d: "m0 0h3l3 11-4-1-2-5z",
    fill: "#27232D"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1202,917)",
    d: "m0 0 2 4v2l7 1 1 2h-8l-4-3z",
    fill: "#1F1A28"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,895)",
    d: "m0 0 10 3-2 4-5-1-3-4z",
    fill: "#2A2C44"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,803)",
    d: "m0 0 4 1-1 5-2 8-2 2 1-9-1-5z",
    fill: "#7B7A80"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1580,724)",
    d: "m0 0h1l2 7 1 8-3-3v-2h-2l-1-7h2z",
    fill: "#7D7D82"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,700)",
    d: "m0 0h2v4h8v1h-9-3l-4 2-3-1 5-4z",
    fill: "#262639"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,632)",
    d: "m0 0 5 3v2l-5 3-5-1v-4l6 1z",
    fill: "#2A2939"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1426,586)",
    d: "m0 0 1 3v6l-4-1-1-5h-6v-1l9-1z",
    fill: "#B0B0AF"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,480)",
    d: "m0 0 3 3-3 7-4 6-3 3 1-5 5-7z",
    fill: "#262430"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,421)",
    d: "m0 0h8l-1 4h-2v5l-4 1 2-1z",
    fill: "#211D29"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(934,408)",
    d: "m0 0 5 1v8h-3l-2-4z",
    fill: "#1F1B21"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,371)",
    d: "m0 0 5 1 3 3 6 1-1 4-3-1-1 3-5-8z",
    fill: "#A8A7A7"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(985,359)",
    d: "m0 0h9l5 2v1l-11 1-3-1z",
    fill: "#1D1921"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,1417)",
    d: "m0 0 9 3v1l-9-1h-16l2-2z",
    fill: "#BFBEBE"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,1360)",
    d: "m0 0h1v9l-2 9h-1v-8h-1l1-7h2z",
    fill: "#39373F"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1492,1311)",
    d: "m0 0h3l1 4-4 4-1-3-4 1 2-4 1 1z",
    fill: "#212035"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,1269)",
    d: "m0 0 6 1v3h-13l1-2z",
    fill: "#F4DDCC"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,1238)",
    d: "m0 0 5 4 1 4-7 1z",
    fill: "#18222D"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,1192)",
    d: "m0 0 2 3 1 7-2 4-2-6-1-6z",
    fill: "#252229"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,1155)",
    d: "m0 0v3l-3 7-1 5h-2l-1-5 4-7z",
    fill: "#B7B7B6"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,927)",
    d: "m0 0 2 1-5 6-2 1h-6l3-3z",
    fill: "#161B2A"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,833)",
    d: "m0 0 2 1-1 5-2 2h-4l1-5z",
    fill: "#FEFDFD"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,763)",
    d: "m0 0h8l3 3-21-1v-1z",
    fill: "#893139"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(277,574)",
    d: "m0 0h2l-1 5h-2l-2 6-4 6-1-2z",
    fill: "#1F1B21"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,497)",
    d: "m0 0 5 5v3l-5-3-3 1-4-2v-3l3 1v2l3-1z",
    fill: "#221F2D"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,411)",
    d: "m0 0 2 4 2 1 5-1-5 5-5 2z",
    fill: "#BEBEBD"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1578,342)",
    d: "m0 0h4l2 4-1 1 5 2v4l-4-2-5-5v-2z",
    fill: "#1B181C"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1154,1540)",
    d: "m0 0 13 1-3 3-4 2-6-5z",
    fill: "#A5A5A5"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,1521)",
    d: "m0 0h2v2l2 1-3 8-1-4h-2l-1-3z",
    fill: "#B5B5B4"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,1473)",
    d: "m0 0h8l-1 2 2 2-9 1h-3z",
    fill: "#23212E"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,1469)",
    d: "m0 0h9l3 3v2l-5-1-7-2z",
    fill: "#F4F3F3"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,1376)",
    d: "m0 0 4 1 5 6-4 1-5-5z",
    fill: "#222226"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,1274)",
    d: "m0 0 3 1 1 7 3 9h-2l-5-12z",
    fill: "#111013"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,782)",
    d: "m0 0 4 2-3 5-1 4-1-3h-2l1-6z",
    fill: "#7A2D35"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1850,766)",
    d: "m0 0h3l1 9v6h-2l-2-11z",
    fill: "#27273C"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,703)",
    d: "m0 0 1 2h10l6 3 2 3-5-2-4-2h-11l-2-2z",
    fill: "#918F90"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1567,693)",
    d: "m0 0 4 5 2 5-1 10h-1l-1-10-4-8z",
    fill: "#B0B0AF"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,651)",
    d: "m0 0 2 4v3l2 1 1 3 3 2-4 1-4-6v-2h-2l1-5z",
    fill: "#322F3A"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1588,614)",
    d: "m0 0h10l1 5h-6l-2-4-1 2v-2z",
    fill: "#080708"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,535)",
    d: "m0 0 5 1 2 3h-3-3l-1 9-2-1v-8z",
    fill: "#363440"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,488)",
    d: "m0 0 2 1v4h9v2l-10 1-1-1z",
    fill: "#C0BFBE"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,468)",
    d: "m0 0h1v10l3 1-6 5-4 1 2-4 3-1z",
    fill: "#B2B1B1"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1293,429)",
    d: "m0 0h2l2 6-1 3h-3v2l-4-1h3z",
    fill: "#B9B8B7"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,411)",
    d: "m0 0h7l4 3 8 2v1h-8l-4-3h-3l-2 3v-5z",
    fill: "#27242F"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,399)",
    d: "m0 0 1 3-5 11-1-4v-6l2-2h3z",
    fill: "#0A090C"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1372,1427)",
    d: "m0 0h2l-1 6 3 1-3 2-4 1 1-7z",
    fill: "#49645A"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1377,1327)",
    d: "m0 0 4 1 1 3-2 5-3-1z",
    fill: "#1F1B21"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1543,1221)",
    d: "m0 0h2v7l-3 7-1-4-1-6z",
    fill: "#171B2A"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,1206)",
    d: "m0 0 2 1-3 9-3 4-1-4z",
    fill: "#232026"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(931,1168)",
    d: "m0 0 2 2v7l-2 5h-1v-13z",
    fill: "#B4B5B4"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,1147)",
    d: "m0 0 3 1 1 7-2 4-2-2 1-2h-2l1-2-1-1z",
    fill: "#1F1B23"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1871,864)",
    d: "m0 0 2 2v10l-4-2-1-4z",
    fill: "#211E2B"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,837)",
    d: "m0 0 3 1 1 6-1 3-3-5-2 2-1-4z",
    fill: "#1F1A25"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(909,795)",
    d: "m0 0 1 2h2l3 13-1 3-4-10z",
    fill: "#D3C5BC"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1854,783)",
    d: "m0 0h2l2 5v8l-2 3z",
    fill: "#27283D"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,768)",
    d: "m0 0 8 1v2l-2 1h-8l-1-3z",
    fill: "#040303"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,758)",
    d: "m0 0h6l1 3h13v1h-16l-5-2z",
    fill: "#1B1A28"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1503,682)",
    d: "m0 0 1 3-2 6h-6l-5-5 5 2h4z",
    fill: "#9C9B9B"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1489,673)",
    d: "m0 0 4 2-2 7-5-4v-4z",
    fill: "#050404"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(290,564)",
    d: "m0 0 1 2-6 11-2-3 4-8z",
    fill: "#232027"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1450,543)",
    d: "m0 0h10l5 2 1 3-5-2h-3-5z",
    fill: "#26232D"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,426)",
    d: "m0 0h1l1 14 2 3h-6l-2-4h3z",
    fill: "#B2B2B1"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1098,388)",
    d: "m0 0h1v13l-2 3-1-9-1-4z",
    fill: "#B6B6B5"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1462,248)",
    d: "m0 0 4 1 13 8-1 2-13-8-3-1z",
    fill: "#1F1B21"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,1265)",
    d: "m0 0 4 5 2 5-5-2-3-4v-2h2z",
    fill: "#25222A"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,966)",
    d: "m0 0 13 2 3 2-11 1-1-3z",
    fill: "#211F2E"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,966)",
    d: "m0 0 5 1 4 4-2 2h-3l-2-1z",
    fill: "#040303"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1603,783)",
    d: "m0 0h2l1 7-6-2-3-4 5 1z",
    fill: "#2A2835"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1542,651)",
    d: "m0 0h1v6l3 1-8 1v-2l-4-1 7-3z",
    fill: "#25222E"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,543)",
    d: "m0 0 7 6 7 7 1 3h-2l-7-8-6-5z",
    fill: "#1F1A25"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(293,546)",
    d: "m0 0h2l-1 4-3 4-6 11-1-3 5-9z",
    fill: "#1F1B21"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1325,501)",
    d: "m0 0 4 2v4l2 1-5-1-1-3-1 3-4-4z",
    fill: "#979696"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,501)",
    d: "m0 0 5 2v3l4 2-2 2v-2l-4-1-2-2-3-1v-2z",
    fill: "#1F1C2E"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1169,475)",
    d: "m0 0 10 1 10 4-1 2-19-6z",
    fill: "#E7D4C5"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,460)",
    d: "m0 0 2 1-6 7 4 2-11 3v-2l5-4z",
    fill: "#2F2E39"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,400)",
    d: "m0 0 4 2v2l3 1 7 8v3l-12-12z",
    fill: "#040303"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1399,343)",
    d: "m0 0 3 4-4 3h-2l-2 4-7-2v-1l7-1 4-4z",
    fill: "#3B3945"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,318)",
    d: "m0 0 1 3h6l3 2h6l-1 2h-6l-10-2z",
    fill: "#B8B8B8"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,132)",
    d: "m0 0h12l-3 3h-9l-2-2z",
    fill: "#201C24"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,1611)",
    d: "m0 0h8v3h2v2l-5-2-1 1h-3-2z",
    fill: "#252530"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,1505)",
    d: "m0 0h5l2 3-1 4-6-3z",
    fill: "#EEEDED"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,1440)",
    d: "m0 0 1 3 4-2-2 9-1-3h-2l-1 2 1-5h-2v-3z",
    fill: "#221F2D"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1739,1432)",
    d: "m0 0v3l-5 8-3 5h-3l7-11z",
    fill: "#1F1A22"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,1410)",
    d: "m0 0 8 6-2 1-1 2-5-5z",
    fill: "#2C2C41"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,1200)",
    d: "m0 0 2 4v8l-4-4 1-7z",
    fill: "#767475"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,1086)",
    d: "m0 0 2 3 2 1-2 5-3 3-1-2v-7h2z",
    fill: "#0E0E16"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,757)",
    d: "m0 0h3v2l12 2v1l-12 2 1-3-5-2z",
    fill: "#CB454B"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,705)",
    d: "m0 0 15 1v1l-18 2 1-3z",
    fill: "#A2A2A2"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,681)",
    d: "m0 0h5l1 8-3 1z",
    fill: "#080607"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1776,576)",
    d: "m0 0 3 4 3 5-1 2h-3l-3-3z",
    fill: "#1F1A26"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(297,551)",
    d: "m0 0h2l-2 5-5 8-1-3 3-7z",
    fill: "#28252E"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1086,455)",
    d: "m0 0 11 1 5 1v2h-7l-5-1v-2z",
    fill: "#F4DFCF"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1625)",
    d: "m0 0 2 1-1 3 1 5-5-1 1-4h-6v-1l7-2z",
    fill: "#979696"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1618)",
    d: "m0 0h4l1 7-4-1-2-1z",
    fill: "#1F1B22"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1595,1609)",
    d: "m0 0 2 2-7 7-2-4 4-2v-2z",
    fill: "#242029"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1401)",
    d: "m0 0 8 6 3 3-3 1-4-2-1-4-3-1z",
    fill: "#33364A"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1468,1330)",
    d: "m0 0h2l1 3-10 10v-3l6-8z",
    fill: "#2D3240"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1126,1322)",
    d: "m0 0h1v8l-3 3h-5l2-3h3l2-5-2-1z",
    fill: "#AEAEAD"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1507,1279)",
    d: "m0 0 2 1v4l-5 4-4 2 2-4z",
    fill: "#272B3C"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,1260)",
    d: "m0 0 2 2-4 6-4-1 1-3h2l1-3z",
    fill: "#1A181F"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1436,1220)",
    d: "m0 0h3v7l-2 5h-3l2-6z",
    fill: "#161B2A"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,1081)",
    d: "m0 0 2 4 2 10-3-1-2-7v-5z",
    fill: "#2D2A35"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,815)",
    d: "m0 0 2 1-2 1zm-4 2h4l-1 4-5 2-3-1 2-1 1-3z",
    fill: "#211E2A"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,794)",
    d: "m0 0h2l2 6-3-1-10 1 4-2z",
    fill: "#272430"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,785)",
    d: "m0 0h10l5 2v1l-10 2-1-3z",
    fill: "#3B3941"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,751)",
    d: "m0 0h2l-1 6-4 7-2 3-2-4h3l1-5z",
    fill: "#BABAB9"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,632)",
    d: "m0 0 7 2 1 2-5 2-2-2-4-2z",
    fill: "#2A2C44"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,628)",
    d: "m0 0h3l1 8-3 1-2-5z",
    fill: "#494853"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1783,608)",
    d: "m0 0 2 1v2h2l2 5 1 3-3 1-4-8z",
    fill: "#0C0B0F"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388,553)",
    d: "m0 0 5 3 7 6-2 1-7-4-3-4z",
    fill: "#211F2B"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,543)",
    d: "m0 0 1 3-4 3h-2l-2 4-3 3v-3l6-7z",
    fill: "#1F1B2A"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,476)",
    d: "m0 0 3 1-1 4h-2l-1 4-3-1 1-5z",
    fill: "#1F1A22"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1308,461)",
    d: "m0 0h1l1 14-3 3-1-2 2-4h-2z",
    fill: "#B1B1B1"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,406)",
    d: "m0 0 19 2v1l-11 1-8-3z",
    fill: "#B4B3B3"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,393)",
    d: "m0 0 1 2v7l1 1v10l-2-4-2-12z",
    fill: "#B3B3B3"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,381)",
    d: "m0 0h16l2 2h-9l-2 2-5-1z",
    fill: "#211E29"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1696)",
    d: "m0 0h1v14l-6 1 1-4 3-1z",
    fill: "#54535D"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1099,1700)",
    d: "m0 0 3 1 2 4-8-1h-7l2-2 8-1z",
    fill: "#ADACAC"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,1560)",
    d: "m0 0 2 3 2 5 1 5-3-1-1-3h-2z",
    fill: "#302E39"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,1493)",
    d: "m0 0 2 1-12 12v-3l5-6z",
    fill: "#272529"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,1351)",
    d: "m0 0h1l2 12-4-2-3-4h2z",
    fill: "#4F515C"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,1227)",
    d: "m0 0 2 1 1 4-2 1v3h-2v-2h-2v-5z",
    fill: "#1C232D"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,941)",
    d: "m0 0 4 2 7 5-3 2-6-4z",
    fill: "#7E343B"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,872)",
    d: "m0 0 1 3-7 12h-1v-5l5-6z",
    fill: "#E56B6A"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,834)",
    d: "m0 0 5 1 6 1-1 3h-8z",
    fill: "#1F1B28"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,753)",
    d: "m0 0 9 9-4 1-4-4z",
    fill: "#36343B"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1832,704)",
    d: "m0 0 2 1v3l2 1v4l-2-1-1-1-1 3-2-8z",
    fill: "#211F2C"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1827,676)",
    d: "m0 0 2 2v3l-3 1-2-1v-3zm-6 3 3 3-1 2h-2l-1-3z",
    fill: "#211E25"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1456,625)",
    d: "m0 0 7 1 4 1-1 3h-8z",
    fill: "#201D26"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,620)",
    d: "m0 0 1 3-7 8-2-3z",
    fill: "#E5D1C3"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,593)",
    d: "m0 0h1v11l-2 1v-2l-2-1 1-6z",
    fill: "#BDBCBC"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,542)",
    d: "m0 0h2l1 5 2 1v6h-2l-1-6h-2z",
    fill: "#24222F"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,455)",
    d: "m0 0h6l-2 2-3 1h-9l-3-2z",
    fill: "#FEE6D4"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,439)",
    d: "m0 0 5 3-2 4h-5l1-5z",
    fill: "#221E26"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,362)",
    d: "m0 0 2 4-4 2v2l2 1-7-1 5-5z",
    fill: "#343340"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1169,1723)",
    d: "m0 0 19 1v1l-18 1-7 1 1-2z",
    fill: "#B4B3B3"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1026,1548)",
    d: "m0 0h4l2 3-1 4-4-1z",
    fill: "#A7A6A6"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1661,1541)",
    d: "m0 0 2 1-2 4-5 5v-5l4-2z",
    fill: "#25222B"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,1410)",
    d: "m0 0 1 2-1 5-3 3h-2v2l-2-1z",
    fill: "#040303"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(516,1258)",
    d: "m0 0 4 3v5h-3l-3-5v-2z",
    fill: "#201D29"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1545,1231)",
    d: "m0 0 2 1-2 6-5-1 1-3z",
    fill: "#211E26"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,1216)",
    d: "m0 0 5 2h3v2h-3l-1 3-2-1v-2h-2z",
    fill: "#24212E"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,1188)",
    d: "m0 0 2 1 2 3-5 3-4-2z",
    fill: "#161B29"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,1084)",
    d: "m0 0 3 4v4l-3-1v-2h-2l-1 4v-7z",
    fill: "#201D26"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1116,915)",
    d: "m0 0h4l-1 6-5 1 1-5z",
    fill: "#FCEBDC"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,815)",
    d: "m0 0 5 2 6 4v2l-4-1-7-5z",
    fill: "#DFCDC1"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,767)",
    d: "m0 0h10v1h-6l1 3-8-1-1-2z",
    fill: "#E64145"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,764)",
    d: "m0 0h13v1l-11 1-7 6 2-5z",
    fill: "#BFBEBE"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(931,762)",
    d: "m0 0h7v3h-13l4-2z",
    fill: "#792D34"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1487,678)",
    d: "m0 0 3 3 6 1-1 3-2 2-5-5z",
    fill: "#201D2A"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,665)",
    d: "m0 0h1v6l6 1v1h-8l-2 4-1-2 3-5z",
    fill: "#B4B4B4"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1622,672)",
    d: "m0 0 2 1-2 1zm-1 2m-2 1 2 1-8 8-3 1-2-2 8-5z",
    fill: "#CBCACA"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,446)",
    d: "m0 0 4 1 2 4h-4l-1 9h-1z",
    fill: "#484856"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,439)",
    d: "m0 0 1 2-1 3-10-1-1-2 10-1z",
    fill: "#BBBABA"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,277)",
    d: "m0 0 4 1-2 3h-4l-2 4-3-3h3l2-4z",
    fill: "#201D26"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,1672)",
    d: "m0 0h1l1 16 2 3-4 1-1-3z",
    fill: "#201E29"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1105,1533)",
    d: "m0 0 12 5 1 4-2-1v-2l-10-2z",
    fill: "#AEAEAD"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1185,1530)",
    d: "m0 0 2 3h3l1 3-5 4-1-1z",
    fill: "#A3A2A2"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1739,1440)",
    d: "m0 0h2l-2 6-5 3 1-4z",
    fill: "#221E25"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,1424)",
    d: "m0 0h3l5 1v2l-9 1-2-2z",
    fill: "#8B8D8D"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,1337)",
    d: "m0 0 5 2 2 2v3l-4-1-3-3z",
    fill: "#222028"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,1312)",
    d: "m0 0h1v9l-1 7h-1v-6l-2-1 1-7z",
    fill: "#B6B7B6"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,1246)",
    d: "m0 0 2 2-5 9-2-1 2-7z",
    fill: "#211E25"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,1197)",
    d: "m0 0h1v6l-4 6h-2l2-6z",
    fill: "#23233A"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,1201)",
    d: "m0 0 3 3-2 6-3-1 1-5-2-1z",
    fill: "#231F29"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658,1144)",
    d: "m0 0h2l1 3v7l-3-1-2-5h2z",
    fill: "#221F2F"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1600,1070)",
    d: "m0 0h1l1 10-2 2-2-4 1-6z",
    fill: "#303248"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1141,884)",
    d: "m0 0 1 3-6 9-2-1 2-5z",
    fill: "#EFD8C7"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1872,860)",
    d: "m0 0 2 1 1 3v10h-2z",
    fill: "#040303"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1875,859)",
    d: "m0 0h1l2 17-1-2h-2l-1-11z",
    fill: "#27242E"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1690,851)",
    d: "m0 0h1v6l-1 2-8 1-1-4 6 2 1-3h2z",
    fill: "#262533"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,775)",
    d: "m0 0h7l9 4-4 1-12-4z",
    fill: "#1F1B26"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,775)",
    d: "m0 0 3 1-8 5-3 1v-3z",
    fill: "#6F2C35"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,768)",
    d: "m0 0 14 1 1 2-2 1h-6l-1-2-6-1z",
    fill: "#232231"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(394,747)",
    d: "m0 0h9l1 2-1 2h-5z",
    fill: "#41404B"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1560,687)",
    d: "m0 0 5 1 2 4-1 3-4-3v-2l-3-1z",
    fill: "#2D2B3A"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,643)",
    d: "m0 0 4 5 1 5-4 3-3-1 4-1-1-5z",
    fill: "#B4B3B3"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1570,593)",
    d: "m0 0 3 1zm-2 1 2 1 1 5-5-1-1-3z",
    fill: "#211E2B"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,588)",
    d: "m0 0h4v6l-5-1-1-4z",
    fill: "#39363D"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1613,560)",
    d: "m0 0 1 2h3v6l-3-1-1-2-4-2z",
    fill: "#67666C"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,517)",
    d: "m0 0 3 1-11 7-1-3 7-4z",
    fill: "#ECD8C9"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,431)",
    d: "m0 0 2 1-1 6-4-2-2-4z",
    fill: "#676569"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1248,407)",
    d: "m0 0 7 1v2h7l-1 2-9-1-5-2z",
    fill: "#9D9D9F"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,384)",
    d: "m0 0h1v9l-2 1-2 4-1-3z",
    fill: "#CCCCCB"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1552,320)",
    d: "m0 0 4 1h-2v2h3l5 6-1 2-9-8z",
    fill: "#1F1D23"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(898,246)",
    d: "m0 0h3v5l-4 1-5-4 5-1 1 2z",
    fill: "#24212A"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,238)",
    d: "m0 0v3l-2 6h-2l-1-8z",
    fill: "#ADACAC"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,1630)",
    d: "m0 0h3l4 5-1 3-5-3h-1z",
    fill: "#232029"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,1630)",
    d: "m0 0 3 1-1 3 3 2-1 2-7-3z",
    fill: "#252128"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1117,1487)",
    d: "m0 0m-6 1 13 1v1l-14 1z",
    fill: "#B1B1B0"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,1450)",
    d: "m0 0 1 2-2 3-5 2-2 1 1-5z",
    fill: "#211D29"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1322,1439)",
    d: "m0 0 3 1-3 7-2-1v-3l-3-2z",
    fill: "#1D1A24"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1431,1256)",
    d: "m0 0h4l1 4 2 1-4 1-3-1z",
    fill: "#161B2A"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1214)",
    d: "m0 0h2v2l5 2v3l-7-3-5-1 4-2z",
    fill: "#C2C2C1"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1195,908)",
    d: "m0 0 3 2-5 3-6 7-2-1 8-10z",
    fill: "#2A2C44"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1141,887)",
    d: "m0 0v3l-4 8-5 5 2-5 6-10z",
    fill: "#C13A3F"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1867,812)",
    d: "m0 0h1l2 12-3 1-1-7-1-3h2z",
    fill: "#27232D"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(274,787)",
    d: "m0 0h4l-1 6-2 1-3-3z",
    fill: "#1F1B21"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,477)",
    d: "m0 0h1v15l-1 2 2 1-6 1 3-5z",
    fill: "#343444"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1672,439)",
    d: "m0 0 3 3 4 2-1 5-5-5z",
    fill: "#26222A"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,430)",
    d: "m0 0 6 1 2-1 4 2-5 2h-5z",
    fill: "#ABAAAA"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,407)",
    d: "m0 0h8l3 3-1 3-4-4h-7v6h-1v-7z",
    fill: "#34323B"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1356,343)",
    d: "m0 0h2l1 6-4 2-1-5z",
    fill: "#A5A4A4"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1647)",
    d: "m0 0 8 3 7 1v1l-9 1v-2l-7-2z",
    fill: "#9A999A"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,1610)",
    d: "m0 0 5 1-2 3-4 1-4-2z",
    fill: "#1E1A21"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1194,1501)",
    d: "m0 0h2v4l2 1h-8l-1-2 2-2 3 1z",
    fill: "#393A49"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1774,1373)",
    d: "m0 0 3 1-3 8-3 1 2-9z",
    fill: "#1D1922"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,1328)",
    d: "m0 0h3l3 4v3l-4-1-3-5z",
    fill: "#262334"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1519,1275)",
    d: "m0 0h3l-2 5-3 4-2-4 1-2h3z",
    fill: "#211E26"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,1177)",
    d: "m0 0 3 1-1 6-3 2-1-4z",
    fill: "#252637"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,1028)",
    d: "m0 0h5l-4 4-1 3-3 1 1-7z",
    fill: "#2C2D41"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,984)",
    d: "m0 0 9 2v2h-7l-3-2z",
    fill: "#1F1A27"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1744,918)",
    d: "m0 0h1v9l-2 5-1 3-3-1 4-8z",
    fill: "#22202C"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,905)",
    d: "m0 0 6 5-1 4-4-1z",
    fill: "#1F1A21"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1605,836)",
    d: "m0 0h14v1l-11 2-5-1z",
    fill: "#232131"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,833)",
    d: "m0 0h2l3 4-6 1-3-2v-2z",
    fill: "#2B2830"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1153,802)",
    d: "m0 0h3l-2 9-1 2-3-1 2-3z",
    fill: "#3F2E44"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,801)",
    d: "m0 0 2 1-8 9-2-1v-2z",
    fill: "#672D38"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,761)",
    d: "m0 0h9l2 2-2 1h-8z",
    fill: "#181A27"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,747)",
    d: "m0 0 4 2 4 3-1 4h-2l-2-5h-4v-3z",
    fill: "#2E2B37"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,729)",
    d: "m0 0h9l5 2-3 1h-2l-1 3-3-4-5-1z",
    fill: "#464348"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1834,717)",
    d: "m0 0 4 2 1 4-1 3h-2z",
    fill: "#262638"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,605)",
    d: "m0 0 3 1 2 5 2 4-1 3-3-3-3-7z",
    fill: "#1F1A27"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1312,502)",
    d: "m0 0 6 2 1 3h-6l-2-4z",
    fill: "#0B0A0C"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1365,357)",
    d: "m0 0 4 2-2 4-6-1v-2z",
    fill: "#050304"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1448,238)",
    d: "m0 0 6 2 5 6-4-1-8-5z",
    fill: "#1F1B21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeClub);
export default __webpack_public_path__ + "static/media/coe-club.1f48e420b32be07cabb490e6622395b7.svg";
export { ForwardRef as ReactComponent };